{
  "level": "cc01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:cc01",
    "objects": "AREAS.E3:cc01.e3",
    "mesh": "TREES.E3:cc01.e3"
  },
  "spawn_point": {
    "position": [
      -327.16575176936914,
      680.7906510662276,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -327.16575176936914,
      780.7906510662276,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -6158.31884765625,
      -4693.75146484375,
      -300.0
    ],
    "bbox_max": [
      6992.10693359375,
      7450.0,
      1814.080322265625
    ],
    "vertex_count": 1607,
    "vertices": [
      [
        2849.835205078125,
        -368.1968994140625,
        -300.0
      ],
      [
        2849.835205078125,
        -331.8028869628906,
        -300.0
      ],
      [
        -3714.042724609375,
        -2323.521484375,
        1179.1292724609375
      ],
      [
        -5545.388671875,
        4741.15380859375,
        334.12225341796875
      ],
      [
        -6158.31884765625,
        3750.8916015625,
        976.300048828125
      ],
      [
        -5532.3203125,
        4687.76513671875,
        347.8644714355469
      ],
      [
        -5504.7001953125,
        4729.1015625,
        -22.699951171875
      ],
      [
        -3697.7392578125,
        -2384.4521484375,
        1181.5667724609375
      ],
      [
        -3709.58251953125,
        -2363.246337890625,
        1182.9832763671875
      ],
      [
        -3605.362548828125,
        -2269.30224609375,
        2.0755867958068848
      ],
      [
        -3614.939453125,
        -3588.4169921875,
        1317.599365234375
      ],
      [
        -4205.0,
        -2619.44677734375,
        1400.274658203125
      ],
      [
        -3461.15576171875,
        -4521.4228515625,
        1390.116943359375
      ],
      [
        -3093.3369140625,
        -4604.0595703125,
        1170.251708984375
      ],
      [
        -3095.20947265625,
        -4636.2900390625,
        1271.65087890625
      ],
      [
        -3412.67578125,
        -3448.206787109375,
        1220.0
      ],
      [
        -3411.630126953125,
        -3453.730224609375,
        1224.3428955078125
      ],
      [
        -3502.183349609375,
        -3576.798583984375,
        1274.598876953125
      ],
      [
        -3502.183349609375,
        -3576.798583984375,
        1274.598876953125
      ],
      [
        -3614.939453125,
        -3588.4169921875,
        1317.599365234375
      ],
      [
        -3605.362548828125,
        -2269.30224609375,
        2.0755615234375
      ],
      [
        -3709.58251953125,
        -2363.246337890625,
        1182.983154296875
      ],
      [
        -3714.01416015625,
        -2323.6279296875,
        1179.1334228515625
      ],
      [
        -5704.54443359375,
        4430.01318359375,
        976.300048828125
      ],
      [
        -5573.556640625,
        4626.0498046875,
        901.1133422851562
      ],
      [
        -5174.01171875,
        5224.01171875,
        -11.839163780212402
      ],
      [
        -5532.3203125,
        4687.76513671875,
        347.86444091796875
      ],
      [
        -5174.01171875,
        5224.01171875,
        -11.83917236328125
      ],
      [
        -5158.470703125,
        5234.39599609375,
        -22.699951171875
      ],
      [
        -4474.53173828125,
        4475.62646484375,
        150.0
      ],
      [
        -4591.42333984375,
        5531.40869140625,
        150.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        150.0
      ],
      [
        -4599.86376953125,
        5607.64501953125,
        150.0
      ],
      [
        -4485.7236328125,
        5683.9111328125,
        -0.0005645751953125
      ],
      [
        -4478.6357421875,
        5688.64697265625,
        -22.699951171875
      ],
      [
        -5174.01171875,
        5224.01171875,
        150.0
      ],
      [
        -5335.22314453125,
        4982.74169921875,
        150.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        671.77490234375
      ],
      [
        -5174.01171875,
        5224.01171875,
        671.7750244140625
      ],
      [
        -4901.68505859375,
        5405.974609375,
        546.6460571289062
      ],
      [
        -3344.00830078125,
        -2413.83203125,
        -300.0
      ],
      [
        -3861.63232421875,
        2261.417236328125,
        -300.0
      ],
      [
        -4468.451171875,
        5695.4521484375,
        -22.699951171875
      ],
      [
        -2916.739501953125,
        3191.2431640625,
        124.09432983398438
      ],
      [
        -3179.908447265625,
        3702.748046875,
        150.0
      ],
      [
        -4020.98193359375,
        5936.4208984375,
        150.0
      ],
      [
        -4038.4375,
        5982.77783203125,
        150.0
      ],
      [
        -3662.578857421875,
        6233.91845703125,
        -22.699951171875
      ],
      [
        -4599.8642578125,
        5607.64501953125,
        150.0
      ],
      [
        -2638.939453125,
        3351.18505859375,
        0.0
      ],
      [
        -2650.5576171875,
        3351.36181640625,
        4.2407684326171875
      ],
      [
        -2638.939453125,
        3351.18505859375,
        0.0
      ],
      [
        -2609.847900390625,
        3350.7421875,
        -10.6187744140625
      ],
      [
        -2501.9697265625,
        3265.2880859375,
        -300.0
      ],
      [
        -1156.463623046875,
        -2051.8349609375,
        202.6451416015625
      ],
      [
        -200.806640625,
        -3123.862548828125,
        0.0
      ],
      [
        -1942.9771728515625,
        -3113.202392578125,
        638.1046142578125
      ],
      [
        -2286.8662109375,
        -3329.22607421875,
        794.213623046875
      ],
      [
        -2912.14697265625,
        -4693.75146484375,
        1212.388916015625
      ],
      [
        -1700.7498779296875,
        -2507.029541015625,
        -300.0
      ],
      [
        -2870.094970703125,
        -2950.574462890625,
        -300.0
      ],
      [
        -2808.593505859375,
        -3513.30859375,
        1011.1946411132812
      ],
      [
        -2908.152099609375,
        -3548.43603515625,
        1052.5999755859375
      ],
      [
        -3058.93505859375,
        -3479.345703125,
        1098.404052734375
      ],
      [
        -3009.681640625,
        -3300.586181640625,
        1055.611572265625
      ],
      [
        -3058.93505859375,
        -3479.345703125,
        1098.404052734375
      ],
      [
        -3123.772216796875,
        -3589.257568359375,
        1137.4005126953125
      ],
      [
        -3403.8046875,
        -3443.094970703125,
        1220.0
      ],
      [
        -3714.02197265625,
        -2323.558349609375,
        1179.126708984375
      ],
      [
        -3605.181640625,
        -2269.120849609375,
        0.0
      ],
      [
        -3605.1806640625,
        -2269.11083984375,
        -0.022125244140625
      ],
      [
        -2286.865966796875,
        -3329.22607421875,
        794.213623046875
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.5367431640625
      ],
      [
        -2981.017578125,
        -3196.55322265625,
        1030.70751953125
      ],
      [
        -2981.017578125,
        -3196.55322265625,
        1030.70751953125
      ],
      [
        -3070.88916015625,
        -3126.308349609375,
        1053.9906005859375
      ],
      [
        -3662.39306640625,
        -2424.959228515625,
        1174.18994140625
      ],
      [
        -3070.88916015625,
        -3126.308349609375,
        1053.9906005859375
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.53662109375
      ],
      [
        -3662.39306640625,
        -2424.959228515625,
        1174.18994140625
      ],
      [
        -2298.42333984375,
        -803.4613037109375,
        100.0
      ],
      [
        -2895.29443359375,
        -145.8916015625,
        100.0
      ],
      [
        -1529.63916015625,
        -2745.022216796875,
        435.4664001464844
      ],
      [
        -1180.669189453125,
        -2147.973876953125,
        224.8211669921875
      ],
      [
        -1288.892333984375,
        -1953.526123046875,
        -300.0
      ],
      [
        -1942.9771728515625,
        -3113.202392578125,
        638.1046142578125
      ],
      [
        -1655.49462890625,
        -2876.868896484375,
        499.8956298828125
      ],
      [
        -1655.49462890625,
        -2876.868896484375,
        499.8956604003906
      ],
      [
        -1529.63916015625,
        -2745.02197265625,
        435.46630859375
      ],
      [
        -1180.669189453125,
        -2147.973876953125,
        224.82118225097656
      ],
      [
        -1156.463623046875,
        -2051.8349609375,
        202.6451416015625
      ],
      [
        -1609.5274658203125,
        -106.07269287109375,
        100.0
      ],
      [
        -1881.24951171875,
        615.5504760742188,
        100.0
      ],
      [
        -2178.24560546875,
        2200.042724609375,
        -10.0
      ],
      [
        -2215.506103515625,
        2298.9970703125,
        -10.0
      ],
      [
        -2215.506103515625,
        2298.9970703125,
        -10.0
      ],
      [
        -2310.01953125,
        2550.0,
        -10.0
      ],
      [
        -1988.80078125,
        1696.926513671875,
        -10.0
      ],
      [
        -2178.24560546875,
        2200.042724609375,
        -10.0
      ],
      [
        -1849.3822021484375,
        1326.6666259765625,
        -10.0
      ],
      [
        -1846.306884765625,
        1326.306884765625,
        -11.079254150390625
      ],
      [
        -2723.333251953125,
        1326.6666259765625,
        -10.000000953674316
      ],
      [
        -1817.047119140625,
        3338.672607421875,
        -300.0
      ],
      [
        -1807.8961181640625,
        2057.896240234375,
        -126.31155395507812
      ],
      [
        -1846.306884765625,
        1326.306884765625,
        -11.07925033569336
      ],
      [
        -1445.5028076171875,
        2015.5028076171875,
        -253.49160766601562
      ],
      [
        -1807.8961181640625,
        2057.896240234375,
        -126.31155395507812
      ],
      [
        -1430.0,
        2310.7763671875,
        -300.0
      ],
      [
        -1445.5028076171875,
        2015.5028076171875,
        -253.49160766601562
      ],
      [
        -1414.9208984375,
        85.6016616821289,
        -10.0
      ],
      [
        -1890.3839111328125,
        -614.66748046875,
        -10.000000953674316
      ],
      [
        -1440.376708984375,
        240.45449829101562,
        -10.0
      ],
      [
        -1508.86181640625,
        750.1992797851562,
        -55.32252502441406
      ],
      [
        -1414.9208984375,
        85.6016616821289,
        -10.000000953674316
      ],
      [
        -1102.856201171875,
        -1547.4232177734375,
        -10.0
      ],
      [
        -565.42431640625,
        -1336.6162109375,
        -113.20272827148438
      ],
      [
        -803.7601928710938,
        -1450.233642578125,
        -10.0
      ],
      [
        -1204.166259765625,
        -2019.4130859375,
        -10.0
      ],
      [
        -1102.856201171875,
        -1547.4232177734375,
        -10.000000953674316
      ],
      [
        -565.42431640625,
        -1336.6162109375,
        -113.20274353027344
      ],
      [
        -157.67498779296875,
        -1068.1884765625,
        -300.0
      ],
      [
        -1877.876708984375,
        1330.0,
        0.0
      ],
      [
        -2337.2587890625,
        2550.0,
        0.0
      ],
      [
        -2310.01953125,
        2550.0,
        -10.0
      ],
      [
        -2337.2587890625,
        2550.0,
        0.0
      ],
      [
        -2700.0,
        2550.0,
        100.0
      ],
      [
        -2609.652587890625,
        2550.0,
        100.0
      ],
      [
        -1609.5274658203125,
        -106.07270812988281,
        100.0
      ],
      [
        -1420.4962158203125,
        86.82951354980469,
        3.937878131866455
      ],
      [
        -2150.2705078125,
        1330.0,
        100.0
      ],
      [
        -1877.876708984375,
        1330.0,
        0.0
      ],
      [
        -2720.0,
        1330.0,
        100.0
      ],
      [
        -2000.4400634765625,
        197.02618408203125,
        100.0
      ],
      [
        -1787.7803955078125,
        -327.48968505859375,
        100.00000762939453
      ],
      [
        -2340.0,
        702.5,
        45.000003814697266
      ],
      [
        -2340.0,
        702.5,
        45.000003814697266
      ],
      [
        -2340.0,
        666.3665161132812,
        55.3238525390625
      ],
      [
        -1425.26611328125,
        127.9840087890625,
        0.0
      ],
      [
        -1425.26611328125,
        127.98397827148438,
        0.0
      ],
      [
        -1420.4962158203125,
        86.82951354980469,
        3.9378738403320312
      ],
      [
        -1126.4197998046875,
        -2028.718017578125,
        100.0
      ],
      [
        -1050.3228759765625,
        -1674.1927490234375,
        100.0
      ],
      [
        -1050.3228759765625,
        -1674.1927490234375,
        100.0
      ],
      [
        -826.8541259765625,
        -1461.2427978515625,
        0.0
      ],
      [
        -1022.4708251953125,
        -1665.1424560546875,
        100.0
      ],
      [
        -826.8541259765625,
        -1461.2427978515625,
        0.0
      ],
      [
        -1995.020751953125,
        199.22341918945312,
        199.3180694580078
      ],
      [
        -1782.6578369140625,
        -325.4127502441406,
        193.87930297851562
      ],
      [
        -2453.439453125,
        1330.0,
        200.0
      ],
      [
        -2459.79296875,
        1330.0,
        100.0
      ],
      [
        -2707.393310546875,
        1337.393310546875,
        303.50665283203125
      ],
      [
        -2712.474609375,
        1337.5252685546875,
        305.3538818359375
      ],
      [
        -2707.393310546875,
        1337.393310546875,
        303.5066223144531
      ],
      [
        -2707.33984375,
        1342.6600341796875,
        302.75897216796875
      ],
      [
        -1094.052734375,
        -2031.7603759765625,
        143.25726318359375
      ],
      [
        -1116.5941162109375,
        -1982.9415283203125,
        100.0
      ],
      [
        -1074.1181640625,
        -2033.634033203125,
        169.8988800048828
      ],
      [
        -1044.6822509765625,
        -1688.2943115234375,
        111.35455322265625
      ],
      [
        -1044.6822509765625,
        -1688.2943115234375,
        111.35456085205078
      ],
      [
        -2422.6640625,
        1330.0,
        200.0
      ],
      [
        -2700.0,
        2550.0,
        133.16798400878906
      ],
      [
        4526.4208984375,
        -1556.87548828125,
        543.49267578125
      ],
      [
        -1145.6080322265625,
        -2059.143798828125,
        251.769287109375
      ],
      [
        -158.70803833007812,
        -3106.798095703125,
        670.1329345703125
      ],
      [
        334.5896301269531,
        -3672.376220703125,
        892.7235107421875
      ],
      [
        -158.7080078125,
        -3106.79833984375,
        670.1329345703125
      ],
      [
        -1527.4627685546875,
        -2745.952392578125,
        440.9891052246094
      ],
      [
        -1174.739013671875,
        -2184.3720703125,
        289.6177673339844
      ],
      [
        -1174.739013671875,
        -2184.3720703125,
        289.6177978515625
      ],
      [
        -1145.6080322265625,
        -2059.143798828125,
        251.769287109375
      ],
      [
        -1549.2021484375,
        -2765.516357421875,
        445.481201171875
      ],
      [
        -1527.4627685546875,
        -2745.9521484375,
        440.989013671875
      ],
      [
        3250.0,
        -696.68505859375,
        -300.0
      ],
      [
        3250.0,
        -796.6849975585938,
        0.0
      ],
      [
        3250.0,
        -796.6849365234375,
        0.0
      ],
      [
        3250.0,
        -1312.6414794921875,
        368.87933349609375
      ],
      [
        3250.0,
        -1320.0,
        372.2240905761719
      ],
      [
        -794.8798828125,
        -1446.0003662109375,
        -13.845283508300781
      ],
      [
        -504.59906005859375,
        -1467.1614990234375,
        114.45516967773438
      ],
      [
        -1018.4613037109375,
        -1753.8465576171875,
        164.13726806640625
      ],
      [
        -681.8505859375,
        -1625.7083740234375,
        150.7703399658203
      ],
      [
        -1009.0797729492188,
        -2039.7471923828125,
        256.8197326660156
      ],
      [
        -1018.4613037109375,
        -1753.8466796875,
        164.1372833251953
      ],
      [
        -504.59906005859375,
        -1467.1614990234375,
        114.45515441894531
      ],
      [
        -681.8506469726562,
        -1625.7083740234375,
        150.77035522460938
      ],
      [
        -1143.648681640625,
        -2061.2236328125,
        252.59988403320312
      ],
      [
        -236.08407592773438,
        -3010.201904296875,
        790.0325927734375
      ],
      [
        353.0361328125,
        -3680.16650390625,
        1163.4200439453125
      ],
      [
        -236.08407592773438,
        -3010.2021484375,
        790.0326538085938
      ],
      [
        -1492.434326171875,
        -2760.922119140625,
        529.8773803710938
      ],
      [
        -1172.828125,
        -2196.1005859375,
        310.4969482421875
      ],
      [
        -1939.5810546875,
        -3110.41064453125,
        636.471923828125
      ],
      [
        -1648.24072265625,
        -2909.402099609375,
        579.1571655273438
      ],
      [
        -1648.24072265625,
        -2909.402099609375,
        579.1571044921875
      ],
      [
        -1492.434326171875,
        -2760.921875,
        529.8773193359375
      ],
      [
        -1172.828125,
        -2196.1005859375,
        310.49688720703125
      ],
      [
        -1146.247314453125,
        -2061.89208984375,
        252.5998992919922
      ],
      [
        -1007.5953979492188,
        -2039.88671875,
        258.80352783203125
      ],
      [
        -1009.5068969726562,
        -2026.730712890625,
        252.60006713867188
      ],
      [
        1019.5872192382812,
        -1695.0367431640625,
        431.564697265625
      ],
      [
        -1088.6651611328125,
        -2097.481689453125,
        509.4501647949219
      ],
      [
        -317.6634521484375,
        -2908.3583984375,
        916.4456787109375
      ],
      [
        362.5467224121094,
        -3684.182861328125,
        1302.98486328125
      ],
      [
        -317.6634521484375,
        -2908.3583984375,
        916.4457397460938
      ],
      [
        -2101.2802734375,
        -3399.51513671875,
        1050.8297119140625
      ],
      [
        -2144.14453125,
        -3408.108154296875,
        1052.5999755859375
      ],
      [
        -1378.6275634765625,
        -2809.558349609375,
        818.6739501953125
      ],
      [
        -1143.2017822265625,
        -2377.942626953125,
        634.2151489257812
      ],
      [
        -2099.20068359375,
        -3398.540283203125,
        1050.490234375
      ],
      [
        -1617.5257568359375,
        -3047.155029296875,
        914.7692260742188
      ],
      [
        -2099.20068359375,
        -3398.540283203125,
        1050.490234375
      ],
      [
        -2101.2802734375,
        -3399.51513671875,
        1050.829833984375
      ],
      [
        -1617.5257568359375,
        -3047.155029296875,
        914.769287109375
      ],
      [
        -1378.6275634765625,
        -2809.55810546875,
        818.673828125
      ],
      [
        -1143.2017822265625,
        -2377.942626953125,
        634.215087890625
      ],
      [
        -1088.6651611328125,
        -2097.481689453125,
        509.4501647949219
      ],
      [
        544.5404052734375,
        -1746.02099609375,
        431.070068359375
      ],
      [
        -52.86126708984375,
        -1691.1806640625,
        376.37701416015625
      ],
      [
        -436.7973327636719,
        -1689.80029296875,
        356.619873046875
      ],
      [
        -778.3904418945312,
        -2110.8046875,
        530.9656372070312
      ],
      [
        -614.9921264648438,
        -1565.9052734375,
        137.07241821289062
      ],
      [
        -1012.9479370117188,
        -1921.8662109375,
        218.60536193847656
      ],
      [
        544.5404052734375,
        -1746.02099609375,
        431.070068359375
      ],
      [
        1019.5872802734375,
        -1695.0367431640625,
        431.564697265625
      ],
      [
        -411.2253112792969,
        -1658.2835693359375,
        343.5682067871094
      ],
      [
        -411.225341796875,
        -1658.283447265625,
        343.56817626953125
      ],
      [
        2400.0,
        -1844.385986328125,
        749.0462646484375
      ],
      [
        4526.4208984375,
        -1556.87548828125,
        543.49267578125
      ],
      [
        85.42315673828125,
        -3334.0634765625,
        1814.080322265625
      ],
      [
        -560.6012573242188,
        -2605.0751953125,
        1292.895263671875
      ],
      [
        -1025.829345703125,
        -2139.787109375,
        793.7977294921875
      ],
      [
        -560.601318359375,
        -2605.074951171875,
        1292.895263671875
      ],
      [
        -869.4028930664062,
        -2286.437255859375,
        1065.087646484375
      ],
      [
        -4123.98779296875,
        -2759.122802734375,
        1403.0306396484375
      ],
      [
        -4131.109375,
        -2740.787109375,
        1389.9215087890625
      ],
      [
        -1100.671875,
        -2928.344970703125,
        1524.014892578125
      ],
      [
        -1067.298095703125,
        -2843.8271484375,
        1463.5894775390625
      ],
      [
        -1067.298095703125,
        -2843.8271484375,
        1463.5894775390625
      ],
      [
        -1025.829345703125,
        -2139.787353515625,
        793.7977294921875
      ],
      [
        -1001.381103515625,
        -2304.28173828125,
        1077.845458984375
      ],
      [
        -1100.671875,
        -2928.344970703125,
        1524.014892578125
      ],
      [
        -1247.748291015625,
        -3108.19873046875,
        1652.5999755859375
      ],
      [
        -3557.677978515625,
        -2549.120361328125,
        1152.9107666015625
      ],
      [
        -3528.30859375,
        -2586.1181640625,
        1220.0
      ],
      [
        -2988.559814453125,
        -3223.927001953125,
        1037.2603759765625
      ],
      [
        191.95574951171875,
        -2234.215087890625,
        1027.7518310546875
      ],
      [
        360.59320068359375,
        -2000.717041015625,
        742.3653564453125
      ],
      [
        1109.864501953125,
        -2018.8233642578125,
        873.759033203125
      ],
      [
        -166.50149536132812,
        -2318.328857421875,
        1087.8883056640625
      ],
      [
        -193.138916015625,
        -2403.4306640625,
        1148.731201171875
      ],
      [
        -609.4232788085938,
        -1902.55712890625,
        444.7264709472656
      ],
      [
        -476.12396240234375,
        -1980.4971923828125,
        595.6363525390625
      ],
      [
        -164.9033203125,
        -2162.4677734375,
        947.973388671875
      ],
      [
        -136.1424102783203,
        -2221.3369140625,
        1018.5446166992188
      ],
      [
        -136.14242553710938,
        -2221.3369140625,
        1018.5445556640625
      ],
      [
        -164.90333557128906,
        -2162.4677734375,
        947.9732666015625
      ],
      [
        360.59344482421875,
        -2000.716796875,
        742.3649291992188
      ],
      [
        191.9557342529297,
        -2234.215087890625,
        1027.7518310546875
      ],
      [
        1721.03564453125,
        -1875.4091796875,
        771.22607421875
      ],
      [
        2400.0,
        -1844.385986328125,
        749.0462646484375
      ],
      [
        1721.03564453125,
        -1875.4091796875,
        771.22607421875
      ],
      [
        -476.12396240234375,
        -1980.4971923828125,
        595.6364135742188
      ],
      [
        -580.3717041015625,
        -1866.7518310546875,
        429.8988037109375
      ],
      [
        -374.7521057128906,
        -1732.938720703125,
        433.063232421875
      ],
      [
        -52.86126708984375,
        -1691.1806640625,
        376.37701416015625
      ],
      [
        -374.75189208984375,
        -1732.9390869140625,
        433.06378173828125
      ],
      [
        -436.7973327636719,
        -1689.80029296875,
        356.619873046875
      ],
      [
        -987.384765625,
        -2165.6708984375,
        967.7686157226562
      ],
      [
        -963.984130859375,
        -2188.843505859375,
        995.3135986328125
      ],
      [
        -987.384765625,
        -2165.6708984375,
        967.7688598632812
      ],
      [
        -987.1666259765625,
        -2187.933349609375,
        994.6629028320312
      ],
      [
        -3652.813720703125,
        -2436.3173828125,
        1172.2432861328125
      ],
      [
        -3597.956298828125,
        -2503.115234375,
        1220.0
      ],
      [
        -984.6701049804688,
        -2167.49853515625,
        980.05322265625
      ],
      [
        -984.6701049804688,
        -2167.49853515625,
        980.05322265625
      ],
      [
        3250.0,
        -1320.0,
        374.1402282714844
      ],
      [
        6992.10693359375,
        -1390.9158935546875,
        590.9097290039062
      ],
      [
        1109.865478515625,
        -2018.8232421875,
        873.7589111328125
      ],
      [
        -233.89088439941406,
        -2962.61669921875,
        1774.980712890625
      ],
      [
        -556.13720703125,
        -2604.275634765625,
        1411.13330078125
      ],
      [
        -596.04345703125,
        -2560.8291015625,
        1347.8153076171875
      ],
      [
        -1027.7886962890625,
        -2520.433837890625,
        1232.3817138671875
      ],
      [
        -1020.4502563476562,
        -2691.333984375,
        1460.0020751953125
      ],
      [
        -1033.012451171875,
        -2899.037109375,
        1656.375
      ],
      [
        -713.9907836914062,
        -2446.799560546875,
        1179.737548828125
      ],
      [
        -596.0433959960938,
        -2560.8291015625,
        1347.8153076171875
      ],
      [
        -166.50149536132812,
        -2318.328857421875,
        1087.8883056640625
      ],
      [
        -1001.381103515625,
        -2304.281982421875,
        1077.8455810546875
      ],
      [
        -998.296142578125,
        -2325.03857421875,
        1113.68798828125
      ],
      [
        -869.4028930664062,
        -2286.437255859375,
        1065.087646484375
      ],
      [
        -602.8601684570312,
        -2552.319091796875,
        1358.37841796875
      ],
      [
        -841.7435302734375,
        -2312.3681640625,
        1113.0572509765625
      ],
      [
        -602.8602294921875,
        -2552.319091796875,
        1358.37841796875
      ],
      [
        -987.463623046875,
        -2397.92236328125,
        1239.543212890625
      ],
      [
        -1014.5529174804688,
        -2843.65869140625,
        1660.47705078125
      ],
      [
        -274.4960021972656,
        -2915.382080078125,
        1770.0086669921875
      ],
      [
        -620.4630126953125,
        -2530.34375,
        1385.6552734375
      ],
      [
        -620.4630126953125,
        -2530.34375,
        1385.6552734375
      ],
      [
        -773.8843383789062,
        -2375.986328125,
        1230.745361328125
      ],
      [
        -4125.63671875,
        -2756.2802734375,
        1402.974609375
      ],
      [
        -4128.15283203125,
        -2748.39892578125,
        1395.3636474609375
      ],
      [
        6992.10546875,
        -1390.916015625,
        590.90966796875
      ],
      [
        3366.189453125,
        -1334.8734130859375,
        384.77392578125
      ],
      [
        -973.9004516601562,
        -2174.74951171875,
        1028.7884521484375
      ],
      [
        -973.9004516601562,
        -2174.74951171875,
        1028.7884521484375
      ],
      [
        2962.536376953125,
        -1257.63720703125,
        329.55450439453125
      ],
      [
        3250.0,
        -1312.6414794921875,
        368.87933349609375
      ],
      [
        3250.0,
        -1218.346923828125,
        301.464111328125
      ],
      [
        3250.0,
        -1263.3626708984375,
        346.4798583984375
      ],
      [
        3250.0,
        -1320.0,
        403.1172180175781
      ],
      [
        2455.53076171875,
        -1160.6253662109375,
        260.196533203125
      ],
      [
        2621.0673828125,
        -1158.5025634765625,
        267.4795227050781
      ],
      [
        3250.0,
        -1263.3626708984375,
        346.4798583984375
      ],
      [
        3250.0,
        -1094.629150390625,
        213.0130615234375
      ],
      [
        3250.0,
        -1182.6922607421875,
        309.8115234375
      ],
      [
        3250.0,
        -1320.0,
        455.8563232421875
      ],
      [
        3250.0,
        -1287.7525634765625,
        425.2932434082031
      ],
      [
        -903.2229614257812,
        -2222.334716796875,
        1348.62158203125
      ],
      [
        -909.1630249023438,
        -2527.489013671875,
        1683.8970947265625
      ],
      [
        -575.9976196289062,
        -2564.65576171875,
        1733.090087890625
      ],
      [
        -725.1876220703125,
        -2399.605712890625,
        1547.93359375
      ],
      [
        -903.2229614257812,
        -2222.334716796875,
        1348.62158203125
      ],
      [
        -725.1875610351562,
        -2399.605712890625,
        1547.9334716796875
      ],
      [
        3250.0,
        -1320.0,
        460.73944091796875
      ],
      [
        -3749.496337890625,
        -2237.32958984375,
        1293.859130859375
      ],
      [
        -3766.849609375,
        -2126.165771484375,
        1171.234130859375
      ],
      [
        -3725.157958984375,
        -2329.201904296875,
        1299.860595703125
      ],
      [
        -3714.01416015625,
        -2323.6279296875,
        1179.1334228515625
      ],
      [
        -3697.798095703125,
        -2384.52392578125,
        1182.3121337890625
      ],
      [
        -3697.73974609375,
        -2384.451171875,
        1181.5667724609375
      ],
      [
        -3697.797607421875,
        -2384.524658203125,
        1182.310546875
      ],
      [
        -3702.450439453125,
        -2378.30322265625,
        1210.55859375
      ],
      [
        -3702.450439453125,
        -2378.30322265625,
        1210.55859375
      ],
      [
        -3703.801513671875,
        -2376.973876953125,
        1220.0
      ],
      [
        -4022.8212890625,
        -1204.943603515625,
        1224.7767333984375
      ],
      [
        -4021.5146484375,
        -1174.40478515625,
        1133.1591796875
      ],
      [
        3250.0,
        -996.68505859375,
        600.0
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        3108.39404296875,
        6871.484375,
        547.1160278320312
      ],
      [
        -2708.39404296875,
        6871.484375,
        470.39349365234375
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        -2282.5439453125,
        6956.19140625,
        297.51165771484375
      ],
      [
        -2525.290771484375,
        6907.90625,
        150.0
      ],
      [
        -2702.27099609375,
        6872.70263671875,
        150.0
      ],
      [
        -2525.290771484375,
        6907.90625,
        150.0
      ],
      [
        3108.39404296875,
        6871.484375,
        547.1160278320312
      ],
      [
        5574.01171875,
        5224.01171875,
        89.70620727539062
      ],
      [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      [
        -3988.779052734375,
        5850.89794921875,
        150.0
      ],
      [
        -1146.684326171875,
        5724.8427734375,
        150.0
      ],
      [
        259.23272705078125,
        5158.08642578125,
        0.0
      ],
      [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      [
        588.0418701171875,
        7262.134765625,
        150.0
      ],
      [
        445.29931640625,
        5654.2333984375,
        150.0
      ],
      [
        -2708.39404296875,
        6871.484375,
        150.0
      ],
      [
        -4038.4375,
        5982.77783203125,
        150.0
      ],
      [
        -1857.3211669921875,
        6954.4736328125,
        506.298583984375
      ],
      [
        -1146.6842041015625,
        5724.8427734375,
        150.0
      ],
      [
        -2708.39404296875,
        6871.484375,
        470.39349365234375
      ],
      [
        -4095.87744140625,
        5944.39794921875,
        176.392578125
      ],
      [
        3966.75,
        4947.60009765625,
        -13.693603515625
      ],
      [
        3108.39404296875,
        6871.484375,
        589.1253662109375
      ],
      [
        4128.34375,
        6189.97607421875,
        976.300048828125
      ],
      [
        3108.39404296875,
        6871.484375,
        589.1253662109375
      ],
      [
        3052.0458984375,
        6882.69287109375,
        549.7059936523438
      ],
      [
        3956.6728515625,
        4948.55078125,
        -13.543867111206055
      ],
      [
        3020.6171875,
        6729.98193359375,
        570.58251953125
      ],
      [
        2769.303955078125,
        7185.4150390625,
        710.5693969726562
      ],
      [
        3020.6171875,
        6729.98193359375,
        570.58251953125
      ],
      [
        3108.39404296875,
        6871.484375,
        620.9074096679688
      ],
      [
        2816.62109375,
        6929.521484375,
        560.5269165039062
      ],
      [
        2922.08447265625,
        6908.54345703125,
        625.4671020507812
      ],
      [
        3018.3056640625,
        6889.404296875,
        624.2335205078125
      ],
      [
        3108.39404296875,
        6871.484375,
        620.9074096679688
      ],
      [
        3163.70068359375,
        6834.52978515625,
        610.119873046875
      ],
      [
        3955.45556640625,
        4948.66552734375,
        -13.525781631469727
      ],
      [
        2925.637451171875,
        6907.8369140625,
        627.6549072265625
      ],
      [
        3108.39404296875,
        6871.484375,
        740.189208984375
      ],
      [
        3968.13720703125,
        6297.0224609375,
        976.300048828125
      ],
      [
        3108.39404296875,
        6871.484375,
        740.1891479492188
      ],
      [
        3038.7060546875,
        5480.240234375,
        150.0
      ],
      [
        3720.545654296875,
        5419.32177734375,
        150.0
      ],
      [
        3923.18212890625,
        5039.8720703125,
        28.237018585205078
      ],
      [
        3038.7060546875,
        5480.24072265625,
        150.0
      ],
      [
        2532.767578125,
        5561.64794921875,
        150.00003051757812
      ],
      [
        4399.7919921875,
        4196.43994140625,
        150.0
      ],
      [
        4153.3125,
        4966.6630859375,
        150.0
      ],
      [
        3250.0,
        -484.3836669921875,
        -300.0
      ],
      [
        3250.0,
        214.89837646484375,
        0.0
      ],
      [
        3250.0,
        214.8983154296875,
        0.0
      ],
      [
        3250.0,
        820.0,
        150.0
      ],
      [
        3250.0,
        564.539306640625,
        150.0
      ],
      [
        2900.0,
        -350.48101806640625,
        -300.0
      ],
      [
        2900.0,
        348.8009033203125,
        0.0
      ],
      [
        2950.0,
        329.6719055175781,
        0.0
      ],
      [
        2986.593994140625,
        600.0,
        121.98004150390625
      ],
      [
        2900.0,
        348.8009033203125,
        0.0
      ],
      [
        2934.004638671875,
        600.0,
        113.34847259521484
      ],
      [
        -1550.0,
        2550.0,
        150.0
      ],
      [
        -2496.7783203125,
        2550.0,
        58.562110900878906
      ],
      [
        -1939.6748046875,
        2550.0,
        150.0
      ],
      [
        -2975.755615234375,
        3160.571044921875,
        150.0
      ],
      [
        -1530.0,
        2550.0,
        0.0
      ],
      [
        -1430.0,
        2550.0,
        -300.0
      ],
      [
        -1530.0,
        2570.0,
        150.0
      ],
      [
        -1530.0,
        2550.0,
        0.0
      ],
      [
        -1530.0,
        2550.0,
        150.0
      ],
      [
        -2208.28271484375,
        2279.813232421875,
        -10.0
      ],
      [
        -2094.317626953125,
        2236.212646484375,
        -10.0
      ],
      [
        -1790.555908203125,
        2120.0,
        -10.0
      ],
      [
        -2094.318115234375,
        2236.212890625,
        -10.0
      ],
      [
        434.6666564941406,
        1842.583740234375,
        -10.0
      ],
      [
        434.6666564941406,
        2415.303466796875,
        -10.000000953674316
      ],
      [
        2850.0,
        -331.35205078125,
        -300.0
      ],
      [
        2850.0,
        -270.0,
        -273.67926025390625
      ],
      [
        -1526.6666259765625,
        2550.0,
        -10.0
      ],
      [
        -1526.6666259765625,
        2096.666748046875,
        -10.0
      ],
      [
        -1526.6666259765625,
        2096.666748046875,
        -10.0
      ],
      [
        -1839.6396484375,
        2089.6396484375,
        -31.08110809326172
      ],
      [
        -1729.56640625,
        2096.666748046875,
        -10.0
      ],
      [
        -1839.6396484375,
        2089.6396484375,
        -31.08110809326172
      ],
      [
        -1815.5555419921875,
        1912.010498046875,
        -103.33314514160156
      ],
      [
        -712.9918212890625,
        1315.3206787109375,
        -178.35519409179688
      ],
      [
        -616.7625732421875,
        1534.800537109375,
        -68.4015884399414
      ],
      [
        -716.4713745117188,
        1241.915283203125,
        -210.41812133789062
      ],
      [
        -712.9917602539062,
        1315.3206787109375,
        -178.35519409179688
      ],
      [
        -723.2968139648438,
        1097.9208984375,
        -273.3135986328125
      ],
      [
        -716.4713745117188,
        1241.915283203125,
        -210.4181365966797
      ],
      [
        -690.84814453125,
        1023.30224609375,
        -300.0
      ],
      [
        -723.296875,
        1097.9208984375,
        -273.3135986328125
      ],
      [
        1630.0001220703125,
        1270.0,
        150.0
      ],
      [
        1400.0,
        1270.0,
        149.0087890625
      ],
      [
        1406.0391845703125,
        1270.0,
        150.0
      ],
      [
        680.0,
        2185.0,
        150.0
      ],
      [
        900.0,
        2185.0,
        150.0
      ],
      [
        680.0,
        2350.0,
        150.0
      ],
      [
        680.0,
        2185.0,
        150.0
      ],
      [
        466.0,
        2340.0,
        140.0
      ],
      [
        468.0,
        2340.0,
        150.0
      ],
      [
        590.0,
        2340.0,
        150.0
      ],
      [
        460.0,
        2350.0,
        110.0
      ],
      [
        466.0,
        2350.0,
        140.0
      ],
      [
        1200.0,
        1300.0,
        129.052978515625
      ],
      [
        1030.0,
        1300.0,
        101.1507568359375
      ],
      [
        1030.0,
        1300.0,
        101.15074157714844
      ],
      [
        1030.0,
        1390.0,
        139.76181030273438
      ],
      [
        466.0,
        2035.0,
        140.0
      ],
      [
        460.0,
        2035.0,
        110.0
      ],
      [
        468.0,
        2035.0,
        150.0
      ],
      [
        560.0,
        2035.0,
        150.0
      ],
      [
        466.0,
        2035.0,
        140.0
      ],
      [
        450.0,
        2285.0,
        150.0
      ],
      [
        450.0,
        2035.0,
        150.0
      ],
      [
        450.0,
        2035.0,
        150.0
      ],
      [
        450.0,
        2340.0,
        140.0
      ],
      [
        450.0,
        2340.0,
        150.0
      ],
      [
        -1677.3521728515625,
        2100.0,
        0.0
      ],
      [
        -1677.3521728515625,
        2100.0,
        0.0
      ],
      [
        -1537.6434326171875,
        2100.0,
        22.930511474609375
      ],
      [
        -1530.0,
        2100.0,
        24.185043334960938
      ],
      [
        -1530.0,
        2393.26708984375,
        150.0
      ],
      [
        -1530.0,
        2100.0,
        24.185041427612305
      ],
      [
        440.0,
        2500.0,
        150.0
      ],
      [
        440.0,
        2340.0,
        150.0
      ],
      [
        440.0,
        1980.0,
        150.0
      ],
      [
        440.0,
        1820.0,
        150.0
      ],
      [
        440.0,
        2340.0,
        150.0
      ],
      [
        175.019775390625,
        1671.0340576171875,
        120.0
      ],
      [
        199.82778930664062,
        1708.161865234375,
        140.0
      ],
      [
        175.019775390625,
        1671.0340576171875,
        120.0
      ],
      [
        145.1197509765625,
        1626.2855224609375,
        95.8948974609375
      ],
      [
        1489.9708251953125,
        7193.40869140625,
        643.8284301757812
      ],
      [
        2922.0849609375,
        6908.54345703125,
        625.4671020507812
      ],
      [
        -5174.01171875,
        5224.01171875,
        766.3274536132812
      ],
      [
        -4708.220703125,
        5535.2431640625,
        976.300048828125
      ],
      [
        -2982.139404296875,
        3224.859619140625,
        268.4219055175781
      ],
      [
        -3086.99365234375,
        3102.7578125,
        198.8291015625
      ],
      [
        -5174.01171875,
        5224.01171875,
        766.3274536132812
      ],
      [
        -5242.5185546875,
        5121.48388671875,
        711.0977783203125
      ],
      [
        -1635.039794921875,
        2550.0,
        200.0
      ],
      [
        1240.0,
        2774.375244140625,
        258.0
      ],
      [
        1240.0,
        2774.375244140625,
        338.0
      ],
      [
        -1530.0,
        2550.0,
        200.0
      ],
      [
        -1530.0,
        2550.0,
        150.0
      ],
      [
        -1531.2552490234375,
        2551.255126953125,
        217.57269287109375
      ],
      [
        -1531.7694091796875,
        2568.230712890625,
        224.7709503173828
      ],
      [
        -1548.9588623046875,
        2551.041015625,
        214.57510375976562
      ],
      [
        -1531.2552490234375,
        2551.255126953125,
        217.57269287109375
      ],
      [
        3250.0,
        820.0,
        259.5955505371094
      ],
      [
        1360.0,
        2461.5791015625,
        210.0
      ],
      [
        1360.0,
        2530.0,
        318.33306884765625
      ],
      [
        450.0,
        2340.0,
        160.0
      ],
      [
        450.0,
        2340.0,
        150.0
      ],
      [
        456.1405029296875,
        2185.0,
        205.0
      ],
      [
        456.1405029296875,
        2185.0,
        180.0
      ],
      [
        1630.0001220703125,
        1270.0,
        186.75889587402344
      ],
      [
        1350.0,
        1384.677001953125,
        190.0
      ],
      [
        1350.0,
        1550.0,
        260.92547607421875
      ],
      [
        1563.76904296875,
        2025.4847412109375,
        500.0
      ],
      [
        1588.2843017578125,
        2050.0,
        514.5410766601562
      ],
      [
        -1530.0,
        2509.814208984375,
        200.0
      ],
      [
        -5579.1611328125,
        4617.6630859375,
        976.300048828125
      ],
      [
        -5573.556640625,
        4626.05029296875,
        901.11328125
      ],
      [
        2900.0,
        -39.689483642578125,
        -166.66685485839844
      ],
      [
        2900.0,
        -680.0,
        -166.66685485839844
      ],
      [
        3071.500244140625,
        -320.0,
        405.0
      ],
      [
        3100.0,
        -580.0,
        499.9997863769531
      ],
      [
        3043.431396484375,
        -556.275634765625,
        311.43756103515625
      ],
      [
        3043.431396484375,
        -441.724365234375,
        311.43756103515625
      ],
      [
        3100.0,
        -418.0,
        499.9997863769531
      ],
      [
        3170.0,
        -388.6426086425781,
        500.0
      ],
      [
        3170.0,
        -388.6426696777344,
        650.0
      ],
      [
        3043.431396484375,
        -556.275634765625,
        311.43756103515625
      ],
      [
        3020.0,
        -499.0,
        233.33306884765625
      ],
      [
        3020.0,
        -499.0,
        233.3330841064453
      ],
      [
        3043.431396484375,
        -441.724365234375,
        311.43756103515625
      ],
      [
        3170.0,
        -331.7283935546875,
        500.0
      ],
      [
        3170.0,
        -350.2469177246094,
        650.0
      ],
      [
        3043.431396484375,
        458.275634765625,
        311.43756103515625
      ],
      [
        3100.0,
        482.0,
        499.9997863769531
      ],
      [
        3100.0,
        320.0,
        499.9997863769531
      ],
      [
        3043.431396484375,
        343.724365234375,
        311.43756103515625
      ],
      [
        3170.0,
        290.64276123046875,
        500.0
      ],
      [
        3170.0,
        290.6427001953125,
        650.0
      ],
      [
        3043.431396484375,
        343.724365234375,
        311.43756103515625
      ],
      [
        3027.118408203125,
        383.6000061035156,
        232.0
      ],
      [
        3029.937744140625,
        376.708251953125,
        266.4587707519531
      ],
      [
        3020.0,
        401.0,
        233.3330841064453
      ],
      [
        3043.431396484375,
        458.275634765625,
        311.43756103515625
      ],
      [
        3020.0,
        401.0,
        233.33306884765625
      ],
      [
        3100.0,
        -280.0,
        499.9997863769531
      ],
      [
        3043.431396484375,
        -256.275634765625,
        311.43756103515625
      ],
      [
        3170.0,
        -309.35723876953125,
        500.0
      ],
      [
        3170.0,
        -309.357177734375,
        650.0
      ],
      [
        3043.431396484375,
        -256.275634765625,
        311.43756103515625
      ],
      [
        3020.0,
        -199.0,
        233.33306884765625
      ],
      [
        3021.500244140625,
        -320.0,
        405.0
      ],
      [
        2900.0,
        -270.0,
        0.0
      ],
      [
        3043.431396484375,
        -556.275634765625,
        478.10467529296875
      ],
      [
        3065.0,
        -565.3212890625,
        550.0
      ],
      [
        3043.431396484375,
        -441.724365234375,
        478.10467529296875
      ],
      [
        3065.0,
        -432.6787109375,
        550.0
      ],
      [
        3043.431396484375,
        -556.275634765625,
        478.10467529296875
      ],
      [
        3020.0,
        -499.0,
        400.00018310546875
      ],
      [
        3020.0,
        -499.0,
        400.00018310546875
      ],
      [
        3043.431396484375,
        -441.724365234375,
        478.10467529296875
      ],
      [
        3043.431396484375,
        343.724365234375,
        478.10467529296875
      ],
      [
        3065.0,
        334.6787109375,
        550.0
      ],
      [
        3043.431396484375,
        458.275634765625,
        478.10467529296875
      ],
      [
        3065.0,
        467.3212890625,
        550.0
      ],
      [
        3043.431396484375,
        343.724365234375,
        478.10467529296875
      ],
      [
        3020.0,
        401.0,
        400.00018310546875
      ],
      [
        3020.0,
        401.0,
        400.00018310546875
      ],
      [
        3043.431396484375,
        458.275634765625,
        478.10467529296875
      ],
      [
        3043.431396484375,
        -256.275634765625,
        478.10467529296875
      ],
      [
        3065.0,
        -265.3212890625,
        550.0
      ],
      [
        3043.431396484375,
        -256.275634765625,
        478.10467529296875
      ],
      [
        3020.0,
        -199.0,
        400.00018310546875
      ],
      [
        2850.0,
        -270.0,
        -166.6669158935547
      ],
      [
        2850.0,
        -430.0,
        -166.66685485839844
      ],
      [
        2849.819580078125,
        -368.1968994140625,
        -167.26806640625
      ],
      [
        2849.819580078125,
        -331.8028869628906,
        -167.26806640625
      ],
      [
        -1846.666748046875,
        2120.0,
        -10.0
      ],
      [
        -1846.666748046875,
        2141.466796875,
        -10.0
      ],
      [
        -1846.666748046875,
        1750.0,
        -10.0
      ],
      [
        -1846.6666259765625,
        1950.0,
        -10.0
      ],
      [
        -1846.6666259765625,
        1326.6666259765625,
        -10.0
      ],
      [
        -1849.3822021484375,
        1326.6666259765625,
        -10.0
      ],
      [
        -2150.2705078125,
        1330.0,
        100.0
      ],
      [
        -1883.3333740234375,
        1330.0,
        100.0
      ],
      [
        -1880.0,
        1950.0,
        0.0
      ],
      [
        -1850.0,
        1950.0,
        0.0
      ],
      [
        -1850.0001220703125,
        1750.0,
        0.0
      ],
      [
        -1880.0,
        1950.0,
        89.999755859375
      ],
      [
        -1850.0001220703125,
        1750.0,
        0.0
      ],
      [
        -1880.0,
        1750.0,
        89.99977111816406
      ],
      [
        -1850.0,
        2100.0,
        100.0
      ],
      [
        -1850.0,
        2000.0,
        100.0
      ],
      [
        -1850.0,
        1750.0,
        100.0
      ],
      [
        -1850.0,
        1330.0,
        100.0
      ],
      [
        -1850.0,
        1330.0,
        100.0
      ],
      [
        -1850.0,
        1950.0,
        -6.103515625e-05
      ],
      [
        -1880.0,
        1950.0,
        100.0
      ],
      [
        -1850.0,
        1950.0,
        100.00001525878906
      ],
      [
        -1880.0,
        1750.0,
        100.0
      ],
      [
        -1850.0,
        1750.0,
        100.0
      ],
      [
        -1749.4398193359375,
        2100.0,
        0.0
      ],
      [
        -1850.0,
        2100.0,
        100.0
      ],
      [
        -1800.110595703125,
        2100.0,
        100.0
      ],
      [
        -1840.0,
        1800.0,
        100.00001525878906
      ],
      [
        -1840.0,
        1750.0,
        100.0
      ],
      [
        -1840.0,
        2000.0,
        100.0
      ],
      [
        -1840.0,
        1950.0,
        100.0
      ],
      [
        -1840.0,
        1950.0,
        100.00001525878906
      ],
      [
        -1840.0,
        2100.0,
        0.0
      ],
      [
        -1840.0,
        2090.0,
        -30.000051498413086
      ],
      [
        -1840.0,
        1750.0,
        100.0
      ],
      [
        -1749.4398193359375,
        2100.0,
        0.0
      ],
      [
        -1744.3985595703125,
        2095.7197265625,
        -12.840654373168945
      ],
      [
        -1580.0,
        423.6956481933594,
        100.0
      ],
      [
        -1580.0,
        460.0,
        100.0
      ],
      [
        -1580.0,
        530.0,
        100.0
      ],
      [
        -1580.0,
        566.3043212890625,
        100.0
      ],
      [
        -1655.0,
        423.6956481933594,
        100.0
      ],
      [
        -1655.0,
        566.3043212890625,
        100.0
      ],
      [
        -1615.0,
        460.0,
        100.0
      ],
      [
        -1580.0,
        460.0,
        100.0
      ],
      [
        -1580.0,
        530.0,
        100.0
      ],
      [
        -1615.0,
        530.0,
        100.0
      ],
      [
        -1783.220458984375,
        2100.0,
        100.0
      ],
      [
        2867.77783203125,
        -277.40740966796875,
        60.0
      ],
      [
        2867.77783203125,
        -422.59259033203125,
        60.000003814697266
      ],
      [
        2867.77783203125,
        -277.40740966796875,
        60.000003814697266
      ],
      [
        2918.0,
        -277.40740966796875,
        60.0
      ],
      [
        2850.0,
        -331.8028869628906,
        0.6703224182128906
      ],
      [
        2867.697509765625,
        -331.8028564453125,
        60.0
      ],
      [
        2867.697509765625,
        -368.1968994140625,
        60.0
      ],
      [
        2850.0,
        -368.1968994140625,
        0.6703224778175354
      ],
      [
        -641.163330078125,
        1193.11767578125,
        0.0
      ],
      [
        -719.397705078125,
        1180.1795654296875,
        -237.38375854492188
      ],
      [
        -638.3679809570312,
        1286.7738037109375,
        60.0
      ],
      [
        -635.3445434570312,
        1256.204833984375,
        60.0
      ],
      [
        -635.927734375,
        1249.881591796875,
        53.98616027832031
      ],
      [
        -641.163330078125,
        1193.11767578125,
        0.0
      ],
      [
        -635.927734375,
        1249.881591796875,
        53.98616027832031
      ],
      [
        -619.3822631835938,
        1099.7568359375,
        0.0
      ],
      [
        -708.8112182617188,
        1064.60986328125,
        -285.22686767578125
      ],
      [
        -500.0,
        676.0741577148438,
        60.0
      ],
      [
        -619.3822631835938,
        1099.7568359375,
        0.0
      ],
      [
        -594.2252197265625,
        1079.9539794921875,
        60.0
      ],
      [
        -629.2988891601562,
        1195.0802001953125,
        60.0
      ],
      [
        -608.0948486328125,
        1104.192626953125,
        60.0
      ],
      [
        -624.7881469726562,
        1149.4739990234375,
        60.0
      ],
      [
        -1530.0,
        2100.0,
        60.0
      ],
      [
        -1769.708251953125,
        2100.0,
        60.0
      ],
      [
        -1530.0,
        2183.482666015625,
        60.0
      ],
      [
        -1530.0,
        2100.0,
        59.999996185302734
      ],
      [
        -500.0,
        690.0,
        80.0
      ],
      [
        -50.0,
        690.0,
        80.0
      ],
      [
        -1530.0,
        2100.0,
        80.0
      ],
      [
        -1776.46435546875,
        2100.0,
        80.0
      ],
      [
        -1530.0,
        2230.1015625,
        80.0
      ],
      [
        -1530.0,
        2100.0,
        80.0
      ],
      [
        -533.3333740234375,
        1413.333251953125,
        80.0
      ],
      [
        -350.0,
        1413.333251953125,
        80.0
      ],
      [
        -300.0,
        1413.333251953125,
        80.0
      ],
      [
        -66.66667175292969,
        1413.333251953125,
        80.0
      ],
      [
        -300.0,
        1430.0,
        80.0
      ],
      [
        -300.0,
        1413.333251953125,
        80.0
      ],
      [
        -550.0,
        1410.0,
        60.0
      ],
      [
        -550.0,
        1430.0,
        80.0
      ],
      [
        -550.0,
        1413.3333740234375,
        80.0
      ],
      [
        -160.0,
        1050.0,
        80.0
      ],
      [
        -160.0,
        830.0,
        80.0
      ],
      [
        310.0,
        690.0,
        80.0
      ],
      [
        310.0,
        690.0,
        78.0
      ],
      [
        -550.0,
        1250.0,
        80.0
      ],
      [
        -500.0,
        830.0,
        80.0
      ],
      [
        -500.0,
        690.0,
        80.0
      ],
      [
        -359.5035400390625,
        850.55029296875,
        80.0
      ],
      [
        -394.507080078125,
        911.17822265625,
        80.0
      ],
      [
        -394.507080078125,
        911.17822265625,
        80.0
      ],
      [
        -359.5035400390625,
        971.80615234375,
        80.0
      ],
      [
        -339.506103515625,
        971.80615234375,
        80.0
      ],
      [
        -359.5,
        1011.7999267578125,
        60.00611877441406
      ],
      [
        -339.506103515625,
        1006.4426879882812,
        80.0
      ],
      [
        -424.4977722167969,
        1115.09033203125,
        80.0
      ],
      [
        -434.4964599609375,
        1097.7720947265625,
        80.0
      ],
      [
        -500.0,
        1077.7781982421875,
        60.00611877441406
      ],
      [
        -500.0,
        1097.7720947265625,
        80.0
      ],
      [
        -339.506103515625,
        1051.7982177734375,
        80.0
      ],
      [
        -339.506103515625,
        1051.7982177734375,
        80.0
      ],
      [
        -539.507080078125,
        1158.39990234375,
        80.0
      ],
      [
        -550.0,
        1158.39990234375,
        70.91284942626953
      ],
      [
        -550.0,
        1180.21337890625,
        60.00611877441406
      ],
      [
        -504.5035400390625,
        1219.02783203125,
        80.0
      ],
      [
        -504.5035400390625,
        1097.7720947265625,
        80.0
      ],
      [
        -550.0,
        1136.58642578125,
        60.00611877441406
      ],
      [
        -550.0,
        1158.39990234375,
        70.91284942626953
      ],
      [
        -539.507080078125,
        1158.39990234375,
        80.0
      ],
      [
        -504.5035400390625,
        1097.7720947265625,
        80.0
      ],
      [
        -550.0,
        1250.0,
        80.0
      ],
      [
        -533.3333740234375,
        1250.0,
        80.0
      ],
      [
        -200.0,
        570.0,
        60.0
      ],
      [
        -200.0,
        580.0,
        80.0
      ],
      [
        310.0,
        580.0,
        80.0
      ],
      [
        310.0,
        579.0,
        78.0
      ],
      [
        700.0,
        570.0,
        60.0
      ],
      [
        724.1421508789062,
        580.0,
        80.0
      ],
      [
        643.85791015625,
        580.0,
        80.0
      ],
      [
        642.85791015625,
        579.0,
        78.0
      ],
      [
        550.0,
        579.0,
        78.0
      ],
      [
        -355.0,
        569.9999389648438,
        60.0
      ],
      [
        -355.0,
        573.48486328125,
        66.9697265625
      ],
      [
        -390.0,
        573.48486328125,
        66.9697265625
      ],
      [
        -390.0,
        569.9999389648438,
        60.0
      ],
      [
        -315.0,
        573.48486328125,
        66.9697265625
      ],
      [
        -315.0,
        569.9999389648438,
        60.0
      ],
      [
        670.0,
        540.0,
        60.0
      ],
      [
        684.1421508789062,
        540.0,
        80.0
      ],
      [
        -200.0,
        540.0,
        60.0
      ],
      [
        -200.0,
        540.0,
        80.0
      ],
      [
        310.0,
        540.0,
        80.0
      ],
      [
        310.0,
        540.0,
        78.0
      ],
      [
        -355.0,
        540.0,
        60.0
      ],
      [
        -355.0,
        540.0,
        80.0
      ],
      [
        -355.0,
        570.6521606445312,
        80.0
      ],
      [
        -390.0,
        570.6521606445312,
        80.0
      ],
      [
        -390.0,
        540.0,
        80.0
      ],
      [
        -390.0,
        540.0,
        60.0
      ],
      [
        -315.0,
        570.6521606445312,
        80.0
      ],
      [
        -315.0,
        540.0,
        80.0
      ],
      [
        -315.0,
        540.0,
        60.0
      ],
      [
        -345.0,
        540.0,
        73.33333587646484
      ],
      [
        -325.0,
        540.0,
        73.33333587646484
      ],
      [
        -345.0,
        540.0,
        73.33333587646484
      ],
      [
        -345.0,
        540.0,
        71.33333587646484
      ],
      [
        664.1421508789062,
        520.0,
        80.0
      ],
      [
        -355.0,
        530.0,
        80.0
      ],
      [
        -390.0,
        530.0,
        80.0
      ],
      [
        -200.0,
        530.0,
        60.0
      ],
      [
        -200.0,
        530.0,
        80.0
      ],
      [
        625.9052734375,
        530.0,
        78.0
      ],
      [
        625.9052734375,
        530.0,
        80.0
      ],
      [
        480.0,
        530.0,
        80.0
      ],
      [
        480.0,
        530.0,
        78.0
      ],
      [
        310.0,
        530.0,
        80.0
      ],
      [
        310.0,
        530.0,
        78.0
      ],
      [
        -355.0,
        530.0,
        80.0
      ],
      [
        -390.0,
        530.0,
        80.0
      ],
      [
        627.95263671875,
        520.0,
        78.0
      ],
      [
        627.95263671875,
        520.0,
        80.0
      ],
      [
        480.0,
        520.0,
        80.0
      ],
      [
        480.0,
        520.0,
        78.0
      ],
      [
        310.0,
        520.0,
        80.0
      ],
      [
        310.0,
        520.0,
        78.0
      ],
      [
        -390.0,
        520.0,
        80.0
      ],
      [
        -390.0,
        520.0,
        78.0
      ],
      [
        350.0,
        459.9999694824219,
        60.0
      ],
      [
        360.0,
        450.0,
        80.0
      ],
      [
        2873.70361328125,
        -279.87652587890625,
        80.0
      ],
      [
        2873.70361328125,
        -420.12347412109375,
        80.0
      ],
      [
        2873.70361328125,
        -279.87652587890625,
        80.0
      ],
      [
        2924.0,
        -279.87652587890625,
        80.0
      ],
      [
        650.0,
        459.9999694824219,
        60.0
      ],
      [
        660.0,
        450.0,
        80.0
      ],
      [
        2873.663330078125,
        -331.8028564453125,
        80.0
      ],
      [
        2873.663330078125,
        -368.1968994140625,
        80.0
      ],
      [
        290.0,
        451.0,
        78.0
      ],
      [
        290.0,
        450.0,
        80.0
      ],
      [
        320.0,
        457.5,
        65.0
      ],
      [
        330.0,
        457.5,
        65.0
      ],
      [
        320.0,
        457.5,
        65.0
      ],
      [
        320.0,
        458.25,
        63.5
      ],
      [
        -355.0,
        419.34783935546875,
        80.0
      ],
      [
        -355.0,
        450.0,
        80.0
      ],
      [
        -390.0,
        450.0,
        80.0
      ],
      [
        -390.0,
        419.34783935546875,
        80.0
      ],
      [
        -315.0,
        450.0,
        80.0
      ],
      [
        -315.0,
        419.34783935546875,
        80.0
      ],
      [
        -345.0,
        452.5,
        74.99999237060547
      ],
      [
        -325.0,
        452.5,
        74.99999237060547
      ],
      [
        -345.0,
        452.5,
        74.99999237060547
      ],
      [
        -345.0,
        453.25,
        73.50000762939453
      ],
      [
        237.3333282470703,
        480.0,
        80.0
      ],
      [
        -390.0,
        460.0,
        80.0
      ],
      [
        -355.0,
        460.0,
        80.0
      ],
      [
        360.0,
        460.0,
        80.0
      ],
      [
        660.0,
        460.0,
        80.0
      ],
      [
        320.0,
        460.0,
        66.66666412353516
      ],
      [
        330.0,
        460.0,
        66.66666412353516
      ],
      [
        320.0,
        460.0,
        66.66666412353516
      ],
      [
        320.0,
        460.0,
        64.66666412353516
      ],
      [
        290.0,
        460.0,
        78.0
      ],
      [
        290.0,
        460.0,
        80.0
      ],
      [
        -355.0,
        460.0,
        80.0
      ],
      [
        -390.0,
        460.0,
        80.0
      ],
      [
        350.0,
        480.0,
        60.0
      ],
      [
        360.0,
        480.0,
        80.0
      ],
      [
        650.0,
        480.0,
        60.0
      ],
      [
        660.0,
        480.0,
        80.0
      ],
      [
        237.3333282470703,
        480.0,
        80.0
      ],
      [
        237.3333282470703,
        470.0,
        80.0
      ],
      [
        350.0,
        500.0,
        60.0
      ],
      [
        360.0,
        500.0,
        80.0
      ],
      [
        650.0,
        500.0,
        60.0
      ],
      [
        660.0,
        500.0,
        80.0
      ],
      [
        480.0,
        500.0,
        80.0
      ],
      [
        480.0,
        500.0,
        78.0
      ],
      [
        -300.0,
        500.0,
        80.0
      ],
      [
        -300.0,
        500.0,
        78.0
      ],
      [
        350.0,
        510.0,
        60.0
      ],
      [
        650.0,
        510.0,
        60.0
      ],
      [
        660.0,
        510.0,
        80.0
      ],
      [
        629.7952880859375,
        511.0,
        78.0
      ],
      [
        480.0,
        510.0,
        80.0
      ],
      [
        480.0,
        510.0,
        78.0
      ],
      [
        480.0,
        511.0,
        78.0
      ],
      [
        40.0,
        510.0,
        78.0
      ],
      [
        40.0,
        511.0,
        78.0
      ],
      [
        40.0,
        510.0,
        80.0
      ],
      [
        310.0,
        510.0,
        80.0
      ],
      [
        310.0,
        510.0,
        78.0
      ],
      [
        310.0,
        511.0,
        78.0
      ],
      [
        -390.0,
        511.0,
        78.0
      ],
      [
        360.0,
        266.0564880371094,
        100.0
      ],
      [
        360.0,
        450.0,
        80.0
      ],
      [
        360.0,
        450.0,
        100.00000762939453
      ],
      [
        2879.629638671875,
        -282.3456726074219,
        100.0
      ],
      [
        2879.629638671875,
        -417.6543273925781,
        100.0
      ],
      [
        2879.629638671875,
        -282.3456726074219,
        100.0
      ],
      [
        2930.0,
        -282.3456726074219,
        100.0
      ],
      [
        660.0,
        450.0,
        80.0
      ],
      [
        660.0,
        450.0,
        100.0
      ],
      [
        -315.0,
        450.0,
        100.0
      ],
      [
        -315.0,
        423.6956481933594,
        100.0
      ],
      [
        -315.0,
        450.0,
        80.0
      ],
      [
        -305.0,
        435.0,
        100.0
      ],
      [
        -290.0,
        435.0,
        100.00000762939453
      ],
      [
        -290.0,
        450.0,
        100.0
      ],
      [
        -290.0,
        450.0,
        80.0
      ],
      [
        -390.0,
        450.0,
        100.0
      ],
      [
        -390.0,
        423.6956481933594,
        100.0
      ],
      [
        -390.0,
        450.0,
        80.0
      ],
      [
        -355.0,
        423.6956481933594,
        100.0
      ],
      [
        -355.0,
        450.0,
        100.0
      ],
      [
        -355.0,
        450.0,
        80.0
      ],
      [
        -500.0,
        690.0,
        100.0
      ],
      [
        -50.0,
        690.0,
        100.0
      ],
      [
        -1530.0,
        2100.0,
        100.00000762939453
      ],
      [
        -1530.0,
        2276.72021484375,
        100.0
      ],
      [
        -1530.0,
        2100.0,
        100.0
      ],
      [
        -536.6666870117188,
        1416.6666259765625,
        100.0
      ],
      [
        -350.0,
        1416.6666259765625,
        100.0
      ],
      [
        -300.0,
        1416.6666259765625,
        100.0
      ],
      [
        -63.333335876464844,
        1416.6666259765625,
        100.0
      ],
      [
        -300.0,
        1430.0,
        100.0
      ],
      [
        -300.0,
        1416.6666259765625,
        100.0
      ],
      [
        145.1197509765625,
        1626.2855224609375,
        100.0
      ],
      [
        150.21173095703125,
        1633.90625,
        100.0
      ],
      [
        -550.0,
        1430.0,
        100.0
      ],
      [
        -550.0,
        1416.666748046875,
        100.0
      ],
      [
        -550.0,
        1413.3333740234375,
        80.0
      ],
      [
        -160.0,
        1050.0,
        100.0
      ],
      [
        -160.0,
        830.0,
        100.0
      ],
      [
        15.056183815002441,
        842.9404907226562,
        100.0
      ],
      [
        50.15289306640625,
        866.391357421875,
        100.0
      ],
      [
        360.0,
        690.0,
        80.0
      ],
      [
        360.0,
        699.9679565429688,
        100.0
      ],
      [
        360.0,
        690.0,
        100.0
      ],
      [
        -550.0,
        1250.0,
        100.0
      ],
      [
        -500.0,
        830.0,
        100.0
      ],
      [
        -500.0,
        690.0,
        100.0
      ],
      [
        -424.5,
        1115.0986328125,
        100.0
      ],
      [
        -339.5,
        1051.800048828125,
        100.0
      ],
      [
        -339.5,
        971.800048828125,
        100.0
      ],
      [
        -359.5,
        971.800048828125,
        100.0
      ],
      [
        -394.5,
        911.17822265625,
        100.0
      ],
      [
        -394.5,
        911.17822265625,
        100.0
      ],
      [
        -359.5,
        850.556396484375,
        100.0
      ],
      [
        -394.5035705566406,
        911.172119140625,
        80.0
      ],
      [
        -500.0,
        1097.7781982421875,
        80.00611877441406
      ],
      [
        -500.0,
        1097.7781982421875,
        100.0
      ],
      [
        -434.5,
        1097.7781982421875,
        100.0
      ],
      [
        -500.0,
        1097.7781982421875,
        80.00611877441406
      ],
      [
        -500.0,
        1097.7720947265625,
        80.0
      ],
      [
        -339.5,
        1051.800048828125,
        100.0
      ],
      [
        -504.5,
        1219.021728515625,
        100.0
      ],
      [
        -539.5,
        1158.39990234375,
        100.0
      ],
      [
        -539.5,
        1158.39990234375,
        100.0
      ],
      [
        -504.5,
        1097.7781982421875,
        100.0
      ],
      [
        -504.5,
        1097.7781982421875,
        100.0
      ],
      [
        -504.4964904785156,
        1097.7720947265625,
        80.0
      ],
      [
        -539.5034790039062,
        1158.3936767578125,
        80.0
      ],
      [
        -550.0,
        1250.0,
        100.0
      ],
      [
        -536.6666870117188,
        1250.0,
        100.0
      ],
      [
        360.0,
        600.0,
        80.0
      ],
      [
        360.0,
        600.0,
        100.0
      ],
      [
        744.1421508789062,
        600.0,
        80.0
      ],
      [
        744.1421508789062,
        600.0,
        100.0
      ],
      [
        360.0,
        580.0,
        100.0
      ],
      [
        724.1421508789062,
        580.0,
        80.0
      ],
      [
        724.1421508789062,
        580.0,
        100.0
      ],
      [
        360.0,
        580.0,
        100.0
      ],
      [
        620.0,
        510.0,
        100.00000762939453
      ],
      [
        360.0,
        510.0,
        100.0
      ],
      [
        455.27862548828125,
        510.0,
        100.00000762939453
      ],
      [
        360.0,
        510.0,
        100.00000762939453
      ],
      [
        660.0,
        510.0,
        80.0
      ],
      [
        660.0,
        510.0,
        100.0
      ],
      [
        -390.0,
        460.0,
        100.0
      ],
      [
        -355.0,
        460.0,
        100.0
      ],
      [
        -390.0,
        460.0,
        100.0
      ],
      [
        -355.0,
        460.0,
        100.0
      ],
      [
        210.6666717529297,
        480.0,
        100.0
      ],
      [
        210.6666717529297,
        470.0,
        100.0
      ],
      [
        213.3333282470703,
        480.0,
        100.0
      ],
      [
        210.6666717529297,
        480.0,
        100.0
      ],
      [
        -315.0,
        566.3043212890625,
        100.0
      ],
      [
        -290.0,
        555.0,
        100.0
      ],
      [
        -305.0,
        555.0,
        100.00000762939453
      ],
      [
        -390.0,
        566.3043212890625,
        100.0
      ],
      [
        -390.0,
        530.0,
        100.0
      ],
      [
        -355.0,
        530.0,
        100.0
      ],
      [
        -355.0,
        566.3043212890625,
        100.0
      ],
      [
        -355.0,
        530.0,
        100.0
      ],
      [
        -390.0,
        530.0,
        100.0
      ],
      [
        1910.0,
        1896.0,
        1059.422119140625
      ],
      [
        1910.0,
        1895.4892578125,
        1060.0
      ],
      [
        1917.3709716796875,
        1888.11865234375,
        1060.0
      ],
      [
        1910.0,
        1895.4896240234375,
        1060.0
      ],
      [
        1910.0,
        1876.693359375,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      [
        1704.19970703125,
        1830.0,
        1060.0
      ],
      [
        1704.19970703125,
        1830.0,
        1059.6480712890625
      ],
      [
        1549.9996337890625,
        1270.0,
        490.0
      ],
      [
        1549.9996337890625,
        1270.0,
        636.4673461914062
      ],
      [
        1549.9996337890625,
        1270.0,
        490.0
      ],
      [
        1549.9996337890625,
        1270.0,
        173.62835693359375
      ],
      [
        1549.999755859375,
        1400.0,
        728.391357421875
      ],
      [
        1549.9996337890625,
        1270.0,
        636.4673461914062
      ],
      [
        -1850.0,
        1950.0,
        185.0
      ],
      [
        -1850.0,
        1800.0,
        185.0
      ],
      [
        -1851.7857666015625,
        1950.0,
        225.0
      ],
      [
        -1850.0,
        1950.0,
        199.99978637695312
      ],
      [
        -1850.0,
        1950.0,
        185.0
      ],
      [
        -1850.0,
        1750.0,
        185.0
      ],
      [
        -1851.7857666015625,
        1750.0,
        225.0
      ],
      [
        -1850.0,
        1750.0,
        199.99978637695312
      ],
      [
        -1850.0,
        1950.0,
        225.0
      ],
      [
        -1850.0,
        1750.0,
        225.0
      ],
      [
        -1850.0,
        1750.0,
        150.0
      ],
      [
        -1850.0,
        1750.0,
        185.0
      ],
      [
        -1850.0,
        1750.0,
        150.0
      ],
      [
        -1850.0,
        1750.0,
        100.0
      ],
      [
        -1850.0,
        1950.0,
        185.0
      ],
      [
        -1850.0,
        1950.0,
        150.0
      ],
      [
        -1850.0,
        1950.0,
        100.00001525878906
      ],
      [
        -1850.0,
        1950.0,
        150.0
      ],
      [
        1030.0,
        1330.0,
        515.0
      ],
      [
        1030.0,
        1330.0,
        114.0210952758789
      ],
      [
        1350.0,
        1330.0,
        537.4725952148438
      ],
      [
        1350.0,
        1330.0,
        490.0
      ],
      [
        1350.0,
        1330.0,
        490.0
      ],
      [
        1350.0,
        1330.0,
        190.0
      ],
      [
        1460.0,
        1330.0,
        615.25439453125
      ],
      [
        1549.9996337890625,
        1330.0,
        678.893798828125
      ],
      [
        1350.0,
        1330.0,
        537.47265625
      ],
      [
        1360.0,
        1330.0,
        544.543701171875
      ],
      [
        1460.0,
        1330.0,
        410.0
      ],
      [
        1460.0,
        1330.0,
        490.0
      ],
      [
        1460.0,
        1330.0,
        615.2544555664062
      ],
      [
        1460.0,
        1330.0,
        490.0
      ],
      [
        1075.0,
        1330.0,
        515.0
      ],
      [
        1075.0,
        1330.0,
        780.0
      ],
      [
        -1764.8831787109375,
        2341.45556640625,
        429.5688781738281
      ],
      [
        -1688.00927734375,
        2338.93994140625,
        426.9678039550781
      ],
      [
        -1726.93994140625,
        2306.168212890625,
        426.9507751464844
      ],
      [
        -1698.7020263671875,
        2321.26171875,
        485.0
      ],
      [
        -1696.6204833984375,
        2325.9521484375,
        531.0
      ],
      [
        -1696.6878662109375,
        2317.318359375,
        429.10174560546875
      ],
      [
        -1680.0238037109375,
        2326.370849609375,
        460.0
      ],
      [
        -1696.6883544921875,
        2317.318359375,
        429.10040283203125
      ],
      [
        -1698.7020263671875,
        2321.26171875,
        485.0
      ],
      [
        -1679.344970703125,
        2327.900390625,
        475.0
      ],
      [
        -1680.0238037109375,
        2326.370849609375,
        460.0
      ],
      [
        -1679.344970703125,
        2327.900390625,
        475.0
      ],
      [
        -1689.564697265625,
        2329.5244140625,
        541.0
      ],
      [
        -1695.4891357421875,
        2328.501220703125,
        556.0
      ],
      [
        -1696.6204833984375,
        2325.9521484375,
        531.0
      ],
      [
        -1689.564697265625,
        2329.5244140625,
        541.0
      ],
      [
        -1724.3612060546875,
        2309.22998046875,
        475.0
      ],
      [
        -1723.2684326171875,
        2309.652587890625,
        485.0
      ],
      [
        -1724.3612060546875,
        2309.22998046875,
        475.0
      ],
      [
        -1723.2684326171875,
        2309.65234375,
        485.0
      ],
      [
        -1718.2430419921875,
        2311.59521484375,
        531.0
      ],
      [
        -1680.0235595703125,
        2326.37158203125,
        475.0
      ],
      [
        -1680.0235595703125,
        2326.37158203125,
        475.0
      ],
      [
        -1693.22998046875,
        2321.265869140625,
        541.0
      ],
      [
        -1693.22998046875,
        2321.265869140625,
        541.0
      ],
      [
        -1695.2646484375,
        2316.68115234375,
        541.0
      ],
      [
        -1695.2646484375,
        2316.68115234375,
        541.0
      ],
      [
        -1710.2176513671875,
        2309.33740234375,
        541.0
      ],
      [
        -1715.5118408203125,
        2312.651123046875,
        556.0
      ],
      [
        -1718.2431640625,
        2311.59521484375,
        531.0
      ],
      [
        -1710.2176513671875,
        2309.33740234375,
        541.0
      ],
      [
        -1761.6485595703125,
        2340.0,
        555.9052124023438
      ],
      [
        -1761.60546875,
        2339.98095703125,
        556.0
      ],
      [
        -1761.6077880859375,
        2339.98583984375,
        531.0
      ],
      [
        -1761.6396484375,
        2340.0,
        531.0468139648438
      ],
      [
        -1762.4354248046875,
        2329.52490234375,
        541.0
      ],
      [
        -1756.510986328125,
        2328.501708984375,
        556.0
      ],
      [
        -1755.379638671875,
        2325.952392578125,
        531.0
      ],
      [
        -1762.4354248046875,
        2329.52490234375,
        541.0
      ],
      [
        -1758.769775390625,
        2321.265380859375,
        541.0
      ],
      [
        -1758.769775390625,
        2321.265380859375,
        541.0
      ],
      [
        -1719.0673828125,
        2305.916015625,
        541.0
      ],
      [
        -1719.0673828125,
        2305.916015625,
        541.0
      ],
      [
        -1727.800537109375,
        2303.931884765625,
        541.0
      ],
      [
        -1727.80029296875,
        2303.931884765625,
        541.0
      ],
      [
        -1840.0,
        1950.0,
        225.0
      ],
      [
        -1840.0,
        1950.0,
        185.0
      ],
      [
        -1840.0,
        1750.0,
        185.0
      ],
      [
        -1840.0,
        1750.0,
        225.0
      ],
      [
        -1840.0,
        1750.0,
        185.0
      ],
      [
        -1840.0,
        1950.0,
        185.0
      ],
      [
        -540.0,
        1330.0,
        120.0
      ],
      [
        -550.0,
        1330.0,
        120.0
      ],
      [
        -550.0,
        1420.0,
        120.0
      ],
      [
        -550.0,
        1416.666748046875,
        100.0
      ],
      [
        -550.0,
        1330.0,
        120.0
      ],
      [
        -550.0,
        1330.0,
        100.0
      ],
      [
        270.0,
        1330.0,
        240.0
      ],
      [
        270.0,
        1330.0,
        180.0
      ],
      [
        195.3977813720703,
        820.0,
        140.0
      ],
      [
        183.3708953857422,
        820.0,
        140.0
      ],
      [
        -160.0,
        1050.0,
        140.0
      ],
      [
        -160.0,
        830.0,
        140.0
      ],
      [
        1200.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1330.0,
        140.0
      ],
      [
        254.03262329101562,
        970.0,
        140.0
      ],
      [
        236.40264892578125,
        881.3681640625,
        140.0
      ],
      [
        221.82235717773438,
        859.5471801757812,
        120.0
      ],
      [
        236.40264892578125,
        881.3681640625,
        140.0
      ],
      [
        221.82235717773438,
        859.5471801757812,
        140.0
      ],
      [
        88.72040557861328,
        820.0,
        120.0
      ],
      [
        24.558452606201172,
        820.0,
        120.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        120.0
      ],
      [
        107.05951690673828,
        934.9437866210938,
        120.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        120.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        120.0
      ],
      [
        107.05951690673828,
        934.9437866210938,
        120.0
      ],
      [
        113.52975463867188,
        967.471923828125,
        120.0
      ],
      [
        88.72041320800781,
        820.0,
        130.0
      ],
      [
        119.87760925292969,
        820.0,
        130.0
      ],
      [
        183.3708953857422,
        820.0,
        120.0
      ],
      [
        226.98284912109375,
        885.2699584960938,
        130.0
      ],
      [
        183.3708953857422,
        820.0,
        130.0
      ],
      [
        195.3977813720703,
        820.0,
        120.0
      ],
      [
        221.82235717773438,
        859.5471801757812,
        130.0
      ],
      [
        195.3977813720703,
        820.0,
        130.0
      ],
      [
        -50.0,
        820.0,
        130.0
      ],
      [
        18.957992553710938,
        833.5206909179688,
        130.0
      ],
      [
        -144.5,
        1097.7781982421875,
        130.0
      ],
      [
        -109.5,
        1158.39990234375,
        130.0
      ],
      [
        -160.0,
        1097.7781982421875,
        120.00611877441406
      ],
      [
        -160.0,
        1097.7781982421875,
        130.0
      ],
      [
        -144.5,
        1097.7781982421875,
        130.0
      ],
      [
        120.0,
        1000.0,
        130.0
      ],
      [
        107.05952453613281,
        934.9437866210938,
        130.0
      ],
      [
        107.05952453613281,
        934.9437866210938,
        130.0
      ],
      [
        120.0,
        1000.0,
        130.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        130.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        130.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        130.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        130.0
      ],
      [
        107.05952453613281,
        934.9437866210938,
        130.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        130.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        130.0
      ],
      [
        107.05952453613281,
        934.9437866210938,
        130.0
      ],
      [
        88.72041320800781,
        820.0,
        120.0
      ],
      [
        88.72040557861328,
        820.0,
        130.0
      ],
      [
        183.3708953857422,
        820.0,
        140.0
      ],
      [
        195.3977813720703,
        820.0,
        140.0
      ],
      [
        -144.5,
        1097.7781982421875,
        140.0
      ],
      [
        -109.5,
        1158.39990234375,
        140.0
      ],
      [
        -160.0,
        1097.7781982421875,
        140.0
      ],
      [
        -144.5,
        1097.7781982421875,
        140.0
      ],
      [
        107.05952453613281,
        934.9437866210938,
        140.0
      ],
      [
        120.0,
        1000.0,
        140.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        140.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        140.0
      ],
      [
        70.2081527709961,
        879.7918701171875,
        140.0
      ],
      [
        107.05952453613281,
        934.9437866210938,
        140.0
      ],
      [
        -50.0,
        830.0,
        140.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        140.0
      ],
      [
        -100.0,
        830.0,
        140.0
      ],
      [
        -50.0,
        830.0,
        140.0
      ],
      [
        -339.5,
        1051.800048828125,
        140.0
      ],
      [
        -339.5,
        971.800048828125,
        140.0
      ],
      [
        -289.5,
        850.556396484375,
        140.0
      ],
      [
        -254.5,
        911.17822265625,
        140.0
      ],
      [
        -214.5,
        1097.7781982421875,
        140.0
      ],
      [
        -339.5,
        850.556396484375,
        120.00611877441406
      ],
      [
        -339.5,
        850.556396484375,
        140.0
      ],
      [
        -289.5,
        850.556396484375,
        140.0
      ],
      [
        -424.5,
        1115.0986328125,
        140.0
      ],
      [
        -355.21795654296875,
        1075.0986328125,
        140.0
      ],
      [
        -529.5,
        1175.720458984375,
        100.00611877441406
      ],
      [
        -504.5,
        1219.021728515625,
        120.0
      ],
      [
        -529.5,
        1175.720458984375,
        120.0
      ],
      [
        -529.5,
        1175.720458984375,
        100.00611877441406
      ],
      [
        -529.5,
        1175.720458984375,
        100.0
      ],
      [
        -529.5,
        1175.720458984375,
        120.00611877441406
      ],
      [
        -529.5,
        1175.720458984375,
        120.00611877441406
      ],
      [
        -504.5,
        1219.021728515625,
        140.0
      ],
      [
        -529.5,
        1175.720458984375,
        140.0
      ],
      [
        -504.5,
        1097.7781982421875,
        140.0
      ],
      [
        -434.5,
        1097.7781982421875,
        140.0
      ],
      [
        -539.5,
        1158.39990234375,
        140.0
      ],
      [
        -504.5,
        1097.7781982421875,
        140.0
      ],
      [
        -539.5,
        1158.39990234375,
        140.0
      ],
      [
        -434.5,
        1097.7781982421875,
        140.0
      ],
      [
        -424.5,
        1115.0986328125,
        140.0
      ],
      [
        -359.5,
        971.800048828125,
        140.0
      ],
      [
        -394.5,
        911.17822265625,
        140.0
      ],
      [
        -394.5,
        911.17822265625,
        140.0
      ],
      [
        -359.5,
        850.556396484375,
        140.0
      ],
      [
        -359.5,
        850.556396484375,
        140.0
      ],
      [
        -355.21795654296875,
        1075.0986328125,
        140.0
      ],
      [
        -339.5,
        1051.800048828125,
        140.0
      ],
      [
        -500.0,
        820.0,
        120.0
      ],
      [
        -500.0,
        820.0,
        100.0
      ],
      [
        1154.050048828125,
        962.9500122070312,
        750.0
      ],
      [
        1152.43212890625,
        964.5679321289062,
        796.2269287109375
      ],
      [
        1173.0,
        964.9143676757812,
        806.125732421875
      ],
      [
        1152.43212890625,
        964.5679321289062,
        796.2269287109375
      ],
      [
        1044.56787109375,
        1072.43212890625,
        796.2268676757812
      ],
      [
        1042.949951171875,
        1074.050048828125,
        750.0
      ],
      [
        1042.949951171875,
        975.9603881835938,
        750.0
      ],
      [
        1044.5675048828125,
        977.5806884765625,
        796.2144165039062
      ],
      [
        1044.914306640625,
        957.0,
        806.125732421875
      ],
      [
        1042.949951171875,
        957.0,
        750.0
      ],
      [
        1042.949951171875,
        957.0,
        750.0
      ],
      [
        210.0,
        1217.30712890625,
        340.0
      ],
      [
        210.0,
        1217.30712890625,
        210.0
      ],
      [
        260.0,
        1198.322265625,
        140.0
      ],
      [
        260.0,
        1198.322265625,
        190.0
      ],
      [
        260.0,
        1198.322265625,
        190.0
      ],
      [
        210.0,
        1217.30712890625,
        210.0
      ],
      [
        -146.7665557861328,
        1097.7781982421875,
        500.0
      ],
      [
        -146.76654052734375,
        1097.7781982421875,
        140.0
      ],
      [
        -254.4998779296875,
        1097.7781982421875,
        225.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        225.0
      ],
      [
        -254.4998779296875,
        1097.7781982421875,
        300.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        300.0
      ],
      [
        -254.4998779296875,
        1097.7781982421875,
        200.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        200.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        210.0
      ],
      [
        -214.49998474121094,
        1097.7781982421875,
        225.0
      ],
      [
        -339.5,
        850.556396484375,
        500.0
      ],
      [
        -339.5,
        850.556396484375,
        140.0
      ],
      [
        760.0,
        820.0,
        220.0
      ],
      [
        811.1951904296875,
        820.0,
        458.91082763671875
      ],
      [
        360.0,
        820.0,
        140.0
      ],
      [
        360.0,
        820.0,
        460.0
      ],
      [
        360.0,
        980.0,
        190.0
      ],
      [
        360.0,
        980.0,
        340.0
      ],
      [
        254.03260803222656,
        820.0,
        160.0
      ],
      [
        254.03260803222656,
        820.0,
        420.0
      ],
      [
        254.03262329101562,
        1000.0,
        192.38694763183594
      ],
      [
        254.03262329101562,
        980.0,
        192.38694763183594
      ],
      [
        254.03265380859375,
        1200.5880126953125,
        192.38693237304688
      ],
      [
        254.03262329101562,
        1000.0,
        192.38694763183594
      ],
      [
        254.03262329101562,
        980.0,
        192.38694763183594
      ],
      [
        254.03262329101562,
        980.0,
        340.0
      ],
      [
        241.07882690429688,
        820.0,
        350.0
      ],
      [
        210.0,
        841.853759765625,
        350.0
      ],
      [
        210.0,
        820.0,
        350.0
      ],
      [
        254.03260803222656,
        820.0,
        350.0
      ],
      [
        241.07882690429688,
        820.0,
        350.0
      ],
      [
        210.0,
        841.853759765625,
        370.0
      ],
      [
        210.0,
        841.853759765625,
        350.0
      ],
      [
        241.07882690429688,
        820.0,
        210.0
      ],
      [
        210.0,
        841.853759765625,
        210.0
      ],
      [
        210.0,
        820.0,
        210.0
      ],
      [
        254.03260803222656,
        820.0,
        210.0
      ],
      [
        241.07882690429688,
        820.0,
        210.0
      ],
      [
        241.07882690429688,
        820.0,
        280.0
      ],
      [
        224.19573974609375,
        820.0,
        280.0
      ],
      [
        210.0,
        841.853759765625,
        280.0
      ],
      [
        210.0,
        820.0,
        280.0
      ],
      [
        210.0,
        841.853759765625,
        300.0
      ],
      [
        210.0,
        841.853759765625,
        280.0
      ],
      [
        210.0,
        841.853759765625,
        230.0
      ],
      [
        210.0,
        841.853759765625,
        210.0
      ],
      [
        241.07882690429688,
        820.0,
        160.0
      ],
      [
        224.19573974609375,
        820.0,
        160.0
      ],
      [
        210.0,
        841.853759765625,
        160.0
      ],
      [
        210.0,
        820.0,
        160.0
      ],
      [
        210.0,
        841.853759765625,
        160.0
      ],
      [
        210.0,
        841.853759765625,
        140.0
      ],
      [
        202.07957458496094,
        830.0,
        300.0
      ],
      [
        202.07957458496094,
        830.0,
        280.0
      ],
      [
        202.07957458496094,
        830.0,
        230.0
      ],
      [
        202.07957458496094,
        830.0,
        210.0
      ],
      [
        202.07957458496094,
        830.0,
        370.0
      ],
      [
        202.07957458496094,
        830.0,
        350.0
      ],
      [
        202.07957458496094,
        830.0,
        160.0
      ],
      [
        202.07957458496094,
        830.0,
        140.0
      ],
      [
        202.07957458496094,
        830.0,
        280.0
      ],
      [
        210.0,
        830.0,
        280.0
      ],
      [
        202.07957458496094,
        830.0,
        350.0
      ],
      [
        210.0,
        830.0,
        350.0
      ],
      [
        202.07957458496094,
        830.0,
        210.0
      ],
      [
        210.0,
        830.0,
        210.0
      ],
      [
        202.07957458496094,
        830.0,
        160.0
      ],
      [
        210.0,
        830.0,
        160.0
      ],
      [
        195.3977813720703,
        820.0,
        300.0
      ],
      [
        195.3977813720703,
        820.0,
        280.0
      ],
      [
        195.3977813720703,
        820.0,
        230.0
      ],
      [
        195.3977813720703,
        820.0,
        210.0
      ],
      [
        195.3977813720703,
        820.0,
        370.0
      ],
      [
        195.3977813720703,
        820.0,
        350.0
      ],
      [
        195.3977813720703,
        820.0,
        160.0
      ],
      [
        195.3977813720703,
        820.0,
        280.0
      ],
      [
        195.3977813720703,
        820.0,
        350.0
      ],
      [
        195.3977813720703,
        820.0,
        160.0
      ],
      [
        195.3977813720703,
        820.0,
        210.0
      ],
      [
        -529.5,
        1175.720458984375,
        500.0
      ],
      [
        -529.5,
        1175.720458984375,
        140.0
      ],
      [
        -359.5000305175781,
        971.800048828125,
        350.0
      ],
      [
        -359.5000305175781,
        971.800048828125,
        300.0
      ],
      [
        -359.5000305175781,
        971.800048828125,
        250.0
      ],
      [
        -359.5000305175781,
        971.800048828125,
        200.0
      ],
      [
        -359.5000305175781,
        971.800048828125,
        300.0
      ],
      [
        -339.5,
        1006.441162109375,
        300.0
      ],
      [
        -359.5000305175781,
        971.800048828125,
        200.0
      ],
      [
        -339.5,
        1006.441162109375,
        200.0
      ],
      [
        -502.2333984375,
        1097.7781982421875,
        500.0
      ],
      [
        -502.2334289550781,
        1097.7781982421875,
        140.0
      ],
      [
        -434.5,
        1097.7781982421875,
        350.0
      ],
      [
        -434.5,
        1097.7781982421875,
        300.0
      ],
      [
        -434.5,
        1097.7781982421875,
        250.0
      ],
      [
        -434.5,
        1097.7781982421875,
        200.0
      ],
      [
        -538.36669921875,
        1160.3629150390625,
        500.0
      ],
      [
        -538.36669921875,
        1160.3629150390625,
        140.0
      ],
      [
        -434.5,
        1097.7781982421875,
        300.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        300.0
      ],
      [
        -434.5,
        1097.7781982421875,
        200.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        200.0
      ],
      [
        -1680.0,
        520.0,
        140.0
      ],
      [
        -1665.0,
        520.0,
        140.0
      ],
      [
        -1680.0,
        520.0,
        140.0
      ],
      [
        -1717.22216796875,
        520.0,
        140.0
      ],
      [
        -1560.0,
        520.0,
        140.0
      ],
      [
        -1665.0,
        520.0,
        140.0
      ],
      [
        -305.0,
        520.0,
        140.0
      ],
      [
        -410.0,
        520.0,
        140.0
      ],
      [
        169.20310974121094,
        780.796875,
        140.0
      ],
      [
        68.63186645507812,
        713.5973510742188,
        140.0
      ],
      [
        360.0,
        690.0,
        140.0
      ],
      [
        360.0,
        690.0,
        100.0
      ],
      [
        183.72076416015625,
        802.5241088867188,
        120.0
      ],
      [
        183.72076416015625,
        802.5241088867188,
        140.0
      ],
      [
        169.20310974121094,
        780.796875,
        140.0
      ],
      [
        183.3708953857422,
        820.0,
        130.0
      ],
      [
        161.99351501464844,
        788.0064697265625,
        130.0
      ],
      [
        195.3977813720703,
        820.0,
        130.0
      ],
      [
        183.72076416015625,
        802.5241088867188,
        130.0
      ],
      [
        195.3977813720703,
        820.0,
        140.0
      ],
      [
        360.0,
        600.0,
        140.0
      ],
      [
        360.0,
        600.0,
        100.0
      ],
      [
        840.0,
        640.0,
        140.0
      ],
      [
        840.0,
        600.0,
        140.0
      ],
      [
        840.0,
        600.0,
        120.0
      ],
      [
        840.0,
        600.0,
        100.0
      ],
      [
        840.0,
        600.0,
        120.0
      ],
      [
        -200.0,
        600.0,
        120.0
      ],
      [
        -200.0,
        690.0,
        140.0
      ],
      [
        -200.0,
        600.0,
        140.0
      ],
      [
        840.0,
        580.0,
        140.0
      ],
      [
        840.0,
        580.0,
        120.0
      ],
      [
        840.0,
        580.0,
        100.0
      ],
      [
        840.0,
        580.0,
        120.0
      ],
      [
        -200.0,
        580.0,
        120.0
      ],
      [
        -200.0,
        580.0,
        140.0
      ],
      [
        -200.0,
        520.0,
        140.0
      ],
      [
        840.0,
        520.0,
        140.0
      ],
      [
        840.0,
        520.0,
        120.0
      ],
      [
        840.0,
        520.0,
        100.0
      ],
      [
        840.0,
        520.0,
        120.0
      ],
      [
        1290.0,
        520.0,
        120.0
      ],
      [
        1290.0,
        574.7734375,
        140.0
      ],
      [
        1290.0,
        520.0,
        140.0
      ],
      [
        -1655.0,
        520.0,
        116.0
      ],
      [
        -1690.0,
        520.0,
        116.0
      ],
      [
        -280.0,
        520.0,
        116.0
      ],
      [
        -315.0,
        520.0,
        116.0
      ],
      [
        -1580.0,
        530.0,
        116.0
      ],
      [
        -390.0,
        530.0,
        116.0
      ],
      [
        -390.0,
        530.0,
        116.0
      ],
      [
        -390.0,
        565.0,
        116.0
      ],
      [
        -290.0,
        555.0,
        116.0
      ],
      [
        -290.0,
        535.0,
        116.0
      ],
      [
        -290.0,
        555.0,
        116.0
      ],
      [
        -305.0,
        555.0,
        116.0
      ],
      [
        -1580.0,
        565.0,
        116.0
      ],
      [
        -1580.0,
        530.0,
        116.0
      ],
      [
        -1655.0,
        520.0,
        106.0
      ],
      [
        -1655.0,
        520.0,
        116.0
      ],
      [
        -315.0,
        520.0,
        116.0
      ],
      [
        -315.0,
        520.0,
        106.0
      ],
      [
        -290.0,
        555.0,
        140.0
      ],
      [
        -305.0,
        555.0,
        140.0
      ],
      [
        1290.0,
        520.0,
        300.0
      ],
      [
        840.0,
        520.0,
        190.0
      ],
      [
        840.0,
        520.0,
        250.0
      ],
      [
        840.0,
        520.0,
        190.0
      ],
      [
        -410.0,
        520.0,
        170.0
      ],
      [
        -252.77777099609375,
        520.0,
        170.0
      ],
      [
        -1717.22216796875,
        520.0,
        170.0
      ],
      [
        -1560.0,
        520.0,
        170.0
      ],
      [
        -1690.0,
        520.0,
        165.0
      ],
      [
        -1712.5,
        520.0,
        165.0
      ],
      [
        -257.5,
        520.0,
        165.0
      ],
      [
        -280.0,
        520.0,
        165.0
      ],
      [
        -1690.0,
        520.0,
        165.0
      ],
      [
        -1560.0,
        520.0,
        165.0
      ],
      [
        -410.0,
        520.0,
        165.0
      ],
      [
        -280.0,
        520.0,
        165.0
      ],
      [
        -1560.0,
        555.0,
        165.0
      ],
      [
        -1560.0,
        520.0,
        165.0
      ],
      [
        -1560.0,
        520.0,
        170.0
      ],
      [
        -410.0,
        555.0,
        165.0
      ],
      [
        -410.0,
        520.0,
        170.0
      ],
      [
        -410.0,
        520.0,
        165.0
      ],
      [
        -1665.0,
        520.0,
        145.0
      ],
      [
        -1680.0,
        520.0,
        145.0
      ],
      [
        -290.0,
        520.0,
        145.0
      ],
      [
        -305.0,
        520.0,
        145.0
      ],
      [
        -1690.0,
        520.0,
        145.0
      ],
      [
        -1680.0,
        520.0,
        145.0
      ],
      [
        -290.0,
        520.0,
        145.0
      ],
      [
        -280.0,
        520.0,
        145.0
      ],
      [
        -1712.5,
        520.0,
        145.0
      ],
      [
        -1690.0,
        520.0,
        145.0
      ],
      [
        -280.0,
        520.0,
        145.0
      ],
      [
        -257.5,
        520.0,
        145.0
      ],
      [
        -1665.0,
        520.0,
        145.0
      ],
      [
        -1560.0,
        520.0,
        145.0
      ],
      [
        -410.0,
        520.0,
        145.0
      ],
      [
        -305.0,
        520.0,
        145.0
      ],
      [
        -410.0,
        555.0,
        145.0
      ],
      [
        -410.0,
        520.0,
        145.0
      ],
      [
        -410.0,
        520.0,
        140.0
      ],
      [
        -290.0,
        550.0,
        145.0
      ],
      [
        -290.0,
        555.0,
        145.0
      ],
      [
        -290.0,
        555.0,
        145.0
      ],
      [
        -305.0,
        555.0,
        145.0
      ],
      [
        -390.0,
        563.0,
        145.0
      ],
      [
        -390.0,
        555.0,
        145.0
      ],
      [
        -1560.0,
        555.0,
        145.0
      ],
      [
        -1560.0,
        520.0,
        140.0
      ],
      [
        -1560.0,
        520.0,
        145.0
      ],
      [
        -1580.0,
        555.0,
        145.0
      ],
      [
        -1580.0,
        563.0,
        145.0
      ],
      [
        -1712.5,
        520.0,
        165.0
      ],
      [
        -1712.5,
        520.0,
        145.0
      ],
      [
        -257.5,
        520.0,
        145.0
      ],
      [
        -257.5,
        520.0,
        165.0
      ],
      [
        360.0,
        440.0,
        100.00000762939453
      ],
      [
        360.0,
        440.0,
        220.0
      ],
      [
        360.0,
        450.0000305175781,
        100.00000762939453
      ],
      [
        360.0,
        470.0,
        119.99998474121094
      ],
      [
        360.0,
        470.0,
        220.0
      ],
      [
        840.0,
        470.0,
        190.0
      ],
      [
        840.0,
        470.0,
        120.0
      ],
      [
        840.0,
        470.0,
        120.0
      ],
      [
        840.0,
        460.0,
        109.99999237060547
      ],
      [
        660.0,
        470.0,
        140.0
      ],
      [
        660.0,
        470.0,
        190.0
      ],
      [
        205.0,
        470.0,
        300.0
      ],
      [
        205.0,
        470.0,
        350.0
      ],
      [
        205.0,
        470.0,
        300.0
      ],
      [
        255.0,
        470.0,
        300.0
      ],
      [
        25.0,
        470.0,
        300.0
      ],
      [
        25.0,
        470.0,
        350.0
      ],
      [
        25.0,
        470.0,
        300.0
      ],
      [
        75.0,
        470.0,
        300.0
      ],
      [
        -155.0,
        470.0,
        300.0
      ],
      [
        -155.0,
        470.0,
        350.0
      ],
      [
        -155.0,
        470.0,
        300.0
      ],
      [
        -105.0,
        470.0,
        300.0
      ],
      [
        -252.77777099609375,
        470.0,
        170.0
      ],
      [
        -410.0,
        470.0,
        170.0
      ],
      [
        -1560.0,
        470.0,
        170.0
      ],
      [
        -1717.22216796875,
        470.0,
        170.0
      ],
      [
        -1712.5,
        470.0,
        165.0
      ],
      [
        -1690.0,
        470.0,
        165.0
      ],
      [
        -280.0,
        470.0,
        165.0
      ],
      [
        -257.5,
        470.0,
        165.0
      ],
      [
        -1560.0,
        470.0,
        165.0
      ],
      [
        -1690.0,
        470.0,
        165.0
      ],
      [
        -280.0,
        470.0,
        165.0
      ],
      [
        -410.0,
        470.0,
        165.0
      ],
      [
        -1560.0,
        435.0,
        165.0
      ],
      [
        -1560.0,
        470.0,
        170.0
      ],
      [
        -1560.0,
        470.0,
        165.0
      ],
      [
        -410.0,
        435.0,
        165.0
      ],
      [
        -410.0,
        470.0,
        165.0
      ],
      [
        -410.0,
        470.0,
        170.0
      ],
      [
        -1665.0,
        470.0,
        140.0
      ],
      [
        -1680.0,
        470.0,
        140.0
      ],
      [
        -1717.22216796875,
        470.0,
        140.0
      ],
      [
        -1680.0,
        470.0,
        140.0
      ],
      [
        -1665.0,
        470.0,
        140.0
      ],
      [
        -1560.0,
        470.0,
        140.0
      ],
      [
        -410.0,
        470.0,
        140.0
      ],
      [
        -305.0,
        470.0,
        140.0
      ],
      [
        -1680.0,
        470.0,
        145.0
      ],
      [
        -1665.0,
        470.0,
        145.0
      ],
      [
        -305.0,
        470.0,
        145.0
      ],
      [
        -290.0,
        470.0,
        145.0
      ],
      [
        -1680.0,
        470.0,
        145.0
      ],
      [
        -1690.0,
        470.0,
        145.0
      ],
      [
        -280.0,
        470.0,
        145.0
      ],
      [
        -290.0,
        470.0,
        145.0
      ],
      [
        -1690.0,
        470.0,
        145.0
      ],
      [
        -1712.5,
        470.0,
        145.0
      ],
      [
        -257.5,
        470.0,
        145.0
      ],
      [
        -280.0,
        470.0,
        145.0
      ],
      [
        -1560.0,
        470.0,
        145.0
      ],
      [
        -1665.0,
        470.0,
        145.0
      ],
      [
        -305.0,
        470.0,
        145.0
      ],
      [
        -410.0,
        470.0,
        145.0
      ],
      [
        -410.0,
        435.0,
        145.0
      ],
      [
        -410.0,
        470.0,
        140.0
      ],
      [
        -410.0,
        470.0,
        145.0
      ],
      [
        -290.0,
        440.0,
        145.0
      ],
      [
        -290.0,
        435.0,
        145.0
      ],
      [
        -305.0,
        435.0,
        145.0
      ],
      [
        -305.0,
        435.0,
        140.0
      ],
      [
        -290.0,
        435.0,
        140.0
      ],
      [
        -290.0,
        435.0,
        145.0
      ],
      [
        -390.0,
        435.0,
        145.0
      ],
      [
        -390.0,
        427.0,
        145.0
      ],
      [
        -1560.0,
        435.0,
        145.0
      ],
      [
        -1560.0,
        470.0,
        145.0
      ],
      [
        -1560.0,
        470.0,
        140.0
      ],
      [
        -1580.0,
        427.0,
        145.0
      ],
      [
        -1580.0,
        435.0,
        145.0
      ],
      [
        -1712.5,
        470.0,
        145.0
      ],
      [
        -1712.5,
        470.0,
        165.0
      ],
      [
        -257.5,
        470.0,
        165.0
      ],
      [
        -257.5,
        470.0,
        145.0
      ],
      [
        -1655.0,
        466.0,
        116.0
      ],
      [
        -1690.0,
        466.0,
        116.0
      ],
      [
        -280.0,
        466.0,
        116.0
      ],
      [
        -315.0,
        466.0,
        116.0
      ],
      [
        -1615.0,
        460.0,
        110.0
      ],
      [
        -1655.0,
        460.0,
        110.0
      ],
      [
        -315.0,
        460.0,
        110.0
      ],
      [
        -355.0,
        460.0,
        110.0
      ],
      [
        -1615.0,
        460.0,
        110.0
      ],
      [
        -1580.0,
        460.0,
        110.0
      ],
      [
        -1580.0,
        460.0,
        116.0
      ],
      [
        -390.0,
        460.0,
        116.0
      ],
      [
        -390.0,
        460.0,
        110.0
      ],
      [
        -355.0,
        460.0,
        110.0
      ],
      [
        -390.0,
        425.0,
        116.0
      ],
      [
        -390.0,
        456.0,
        106.0
      ],
      [
        -390.0,
        460.0,
        110.0
      ],
      [
        -390.0,
        460.0,
        116.0
      ],
      [
        -390.0,
        456.0,
        106.0
      ],
      [
        -390.0,
        450.0,
        100.0
      ],
      [
        -315.0,
        456.0,
        106.0
      ],
      [
        -315.0,
        450.0,
        100.0
      ],
      [
        -290.0,
        450.0,
        100.0
      ],
      [
        -290.0,
        455.0,
        105.0
      ],
      [
        -290.0,
        455.0,
        116.0
      ],
      [
        -290.0,
        435.0,
        116.0
      ],
      [
        -305.0,
        435.0,
        116.0
      ],
      [
        -290.0,
        435.0,
        116.0
      ],
      [
        -355.0,
        456.0,
        106.0
      ],
      [
        -355.0,
        450.0,
        100.0
      ],
      [
        -1580.0,
        460.0,
        116.0
      ],
      [
        -1580.0,
        460.0,
        110.0
      ],
      [
        -1580.0,
        456.0,
        106.0
      ],
      [
        -1580.0,
        425.0,
        116.0
      ],
      [
        -1580.0,
        456.0,
        106.0
      ],
      [
        -1580.0,
        450.0,
        100.0
      ],
      [
        -1655.0,
        456.0,
        106.0
      ],
      [
        -1655.0,
        450.0,
        100.0
      ],
      [
        -1655.0,
        460.0,
        110.0
      ],
      [
        -1655.0,
        466.0,
        116.0
      ],
      [
        -315.0,
        466.0,
        116.0
      ],
      [
        -315.0,
        460.0,
        110.0
      ],
      [
        360.0,
        460.0,
        100.00000762939453
      ],
      [
        360.0,
        460.0,
        109.99998474121094
      ],
      [
        -1655.0,
        470.0,
        116.0
      ],
      [
        -1690.0,
        470.0,
        116.0
      ],
      [
        -280.0,
        470.0,
        116.0
      ],
      [
        -315.0,
        470.0,
        116.0
      ],
      [
        360.0,
        470.0,
        100.00000762939453
      ],
      [
        360.0,
        470.0,
        116.0
      ],
      [
        360.0,
        466.0,
        116.0
      ],
      [
        840.0,
        470.0,
        100.0
      ],
      [
        840.0,
        470.0,
        116.0
      ],
      [
        840.0,
        466.0,
        116.0
      ],
      [
        -1655.0,
        470.0,
        106.0
      ],
      [
        -1655.0,
        470.0,
        116.0
      ],
      [
        -315.0,
        470.0,
        116.0
      ],
      [
        -315.0,
        470.0,
        106.0
      ],
      [
        360.0,
        480.0,
        170.0
      ],
      [
        360.0,
        470.0,
        170.0
      ],
      [
        360.0,
        470.0,
        165.0
      ],
      [
        360.0,
        480.0,
        165.0
      ],
      [
        660.0,
        480.0,
        170.0
      ],
      [
        660.0,
        470.0,
        170.0
      ],
      [
        660.0,
        470.0,
        165.0
      ],
      [
        660.0,
        480.0,
        165.0
      ],
      [
        840.0,
        470.0,
        170.0
      ],
      [
        840.0,
        470.0,
        165.0
      ],
      [
        840.0,
        480.0,
        165.0
      ],
      [
        840.0,
        480.0,
        170.0
      ],
      [
        360.0,
        510.0,
        165.0
      ],
      [
        360.0,
        510.0,
        170.0
      ],
      [
        660.0,
        510.0,
        165.0
      ],
      [
        660.0,
        510.0,
        170.0
      ],
      [
        840.0,
        510.0,
        165.0
      ],
      [
        840.0,
        510.0,
        170.0
      ],
      [
        360.0,
        480.0,
        140.0
      ],
      [
        360.0,
        480.0,
        145.0
      ],
      [
        360.0,
        470.0,
        145.0
      ],
      [
        360.0,
        470.0,
        140.0
      ],
      [
        660.0,
        480.0,
        140.0
      ],
      [
        660.0,
        480.0,
        145.0
      ],
      [
        660.0,
        470.0,
        145.0
      ],
      [
        840.0,
        470.0,
        145.0
      ],
      [
        840.0,
        470.0,
        140.0
      ],
      [
        840.0,
        480.0,
        140.0
      ],
      [
        840.0,
        480.0,
        145.0
      ],
      [
        660.0,
        480.0,
        165.0
      ],
      [
        840.0,
        480.0,
        165.0
      ],
      [
        360.0,
        480.0,
        165.0
      ],
      [
        360.0,
        480.0,
        100.00000762939453
      ],
      [
        840.0,
        480.0,
        120.0
      ],
      [
        840.0,
        480.0,
        100.0
      ],
      [
        840.0,
        480.0,
        120.0
      ],
      [
        -1655.0,
        480.0,
        116.0
      ],
      [
        -1690.0,
        480.0,
        116.0
      ],
      [
        -280.0,
        480.0,
        116.0
      ],
      [
        -315.0,
        480.0,
        116.0
      ],
      [
        -315.0,
        480.0,
        116.0
      ],
      [
        -315.0,
        480.0,
        106.0
      ],
      [
        190.0,
        480.0,
        110.0
      ],
      [
        190.0,
        480.0,
        110.0
      ],
      [
        190.0,
        480.0,
        108.0
      ],
      [
        -1655.0,
        480.0,
        106.0
      ],
      [
        -1655.0,
        480.0,
        116.0
      ],
      [
        840.0,
        510.0,
        120.0
      ],
      [
        840.0,
        510.0,
        100.0
      ],
      [
        840.0,
        510.0,
        120.0
      ],
      [
        660.0,
        510.0,
        140.0
      ],
      [
        197.33334350585938,
        490.0,
        108.0
      ],
      [
        -1655.0,
        510.0,
        116.0
      ],
      [
        -1690.0,
        510.0,
        116.0
      ],
      [
        -280.0,
        510.0,
        116.0
      ],
      [
        -315.0,
        510.0,
        116.0
      ],
      [
        -315.0,
        510.0,
        116.0
      ],
      [
        -315.0,
        510.0,
        106.0
      ],
      [
        -1655.0,
        510.0,
        106.0
      ],
      [
        -1655.0,
        510.0,
        116.0
      ],
      [
        840.0,
        510.0,
        190.0
      ],
      [
        840.0,
        510.0,
        250.0
      ],
      [
        840.0,
        510.0,
        190.0
      ],
      [
        840.0,
        500.0,
        170.0
      ],
      [
        25.0,
        510.0,
        300.0
      ],
      [
        25.0,
        500.0,
        300.0
      ],
      [
        75.0,
        500.0,
        300.0
      ],
      [
        75.0,
        510.0,
        300.0
      ],
      [
        -155.0,
        510.0,
        300.0
      ],
      [
        -155.0,
        500.0,
        300.0
      ],
      [
        -105.0,
        500.0,
        300.0
      ],
      [
        -105.0,
        510.0,
        300.0
      ],
      [
        205.0,
        510.0,
        300.0
      ],
      [
        205.0,
        500.0,
        300.0
      ],
      [
        255.0,
        500.0,
        300.0
      ],
      [
        255.0,
        510.0,
        300.0
      ],
      [
        25.0,
        500.0,
        300.0
      ],
      [
        25.0,
        510.0,
        300.0
      ],
      [
        25.0,
        510.0,
        350.0
      ],
      [
        25.0,
        500.0,
        350.0
      ],
      [
        205.0,
        500.0,
        300.0
      ],
      [
        205.0,
        510.0,
        300.0
      ],
      [
        205.0,
        510.0,
        350.0
      ],
      [
        205.0,
        500.0,
        350.0
      ],
      [
        -155.0,
        500.0,
        300.0
      ],
      [
        -155.0,
        510.0,
        300.0
      ],
      [
        -155.0,
        510.0,
        350.0
      ],
      [
        -155.0,
        500.0,
        350.0
      ],
      [
        360.0,
        500.0,
        220.0
      ],
      [
        360.0,
        500.0,
        170.0
      ],
      [
        660.0,
        510.0,
        190.0
      ],
      [
        660.0,
        500.0,
        190.0
      ],
      [
        660.0,
        500.0,
        170.0
      ],
      [
        840.0,
        510.0,
        170.0
      ],
      [
        840.0,
        510.0,
        165.0
      ],
      [
        840.0,
        520.0,
        165.0
      ],
      [
        840.0,
        520.0,
        170.0
      ],
      [
        660.0,
        516.0,
        165.0
      ],
      [
        660.0,
        516.0,
        170.0
      ],
      [
        660.0,
        510.0,
        170.0
      ],
      [
        660.0,
        510.0,
        165.0
      ],
      [
        840.0,
        510.0,
        145.0
      ],
      [
        840.0,
        510.0,
        140.0
      ],
      [
        840.0,
        520.0,
        140.0
      ],
      [
        840.0,
        520.0,
        145.0
      ],
      [
        660.0,
        516.0,
        145.0
      ],
      [
        660.0,
        510.0,
        145.0
      ],
      [
        840.0,
        520.0,
        116.0
      ],
      [
        840.0,
        510.0,
        116.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.00011718011955963448
      ],
      "plane_d": 2849.800048828125,
      "bbox_min": [
        2849.835205078125,
        -368.1968994140625,
        -300.0188903808594
      ],
      "bbox_max": [
        2849.835205078125,
        -331.8028869628906,
        -300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8395622968673706,
        0.49151238799095154,
        0.231409952044487
      ],
      "plane_d": 4493.8125,
      "bbox_min": [
        -4205.1796875,
        -4636.2900390625,
        1040.098388671875
      ],
      "bbox_max": [
        -3093.3369140625,
        -2619.13720703125,
        1400.274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8469141721725464,
        0.5269691348075867,
        0.07099299877882004
      ],
      "plane_d": 4842.2216796875,
      "bbox_min": [
        -4205.1796875,
        -4636.2900390625,
        1040.098388671875
      ],
      "bbox_max": [
        -3093.3369140625,
        -2619.13720703125,
        1400.2685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31618040800094604,
        0.5486864447593689,
        0.7739335298538208
      ],
      "plane_d": -131.23565673828125,
      "bbox_min": [
        -3614.939453125,
        -3588.4169921875,
        1220.0
      ],
      "bbox_max": [
        -3411.630126953125,
        -3448.206787109375,
        1317.599365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011314941570162773,
        0.9574529528617859,
        0.2883673906326294
      ],
      "plane_d": 3096.69091796875,
      "bbox_min": [
        -3614.939453125,
        -3588.4169921875,
        1220.0
      ],
      "bbox_max": [
        -3502.183349609375,
        -3559.13720703125,
        1317.599365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.25,
      "bbox_min": [
        -3714.01416015625,
        -2363.246337890625,
        2.0755615234375
      ],
      "bbox_max": [
        -3605.362548828125,
        -2269.30224609375,
        1182.983154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6158.31884765625,
        3750.8916015625,
        347.8644714355469
      ],
      "bbox_max": [
        -5532.3203125,
        4687.76513671875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3910660445690155,
        0.31802985072135925,
        0.8636690974235535
      ],
      "plane_d": 372.213623046875,
      "bbox_min": [
        -5573.556640625,
        2154.178466796875,
        -22.699951171875
      ],
      "bbox_max": [
        -4474.53173828125,
        5688.64697265625,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -5573.556640625,
        4475.62646484375,
        -22.699951171875
      ],
      "bbox_max": [
        -4474.53173828125,
        5688.64697265625,
        901.1133422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5335.22314453125,
        4982.74169921875,
        -22.699951171875
      ],
      "bbox_max": [
        -4478.6357421875,
        5688.64697265625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5573.556640625,
        4626.0498046875,
        150.0
      ],
      "bbox_max": [
        -4599.86376953125,
        5607.64501953125,
        901.1133422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5174.01171875,
        5224.01171875,
        150.0
      ],
      "bbox_max": [
        -4599.86376953125,
        5607.64501953125,
        671.7750244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7111499905586243,
        0.6279056072235107,
        0.3162280023097992
      ],
      "plane_d": 3988.61865234375,
      "bbox_min": [
        -4485.7236328125,
        -2413.83203125,
        -300.0
      ],
      "bbox_max": [
        -3344.00830078125,
        5695.4521484375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5895068049430847,
        -0.7432911992073059,
        0.31622785329818726
      ],
      "plane_d": 4052.21826171875,
      "bbox_min": [
        -4485.7236328125,
        2156.023681640625,
        -300.0
      ],
      "bbox_max": [
        -3861.63232421875,
        5695.4521484375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -4485.7236328125,
        5683.9111328125,
        -22.699951171875
      ],
      "bbox_max": [
        -4468.451171875,
        5695.4521484375,
        -0.0005645751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5895068049430847,
        -0.7432911992073059,
        0.31622785329818726
      ],
      "plane_d": 4052.21826171875,
      "bbox_min": [
        -4599.8642578125,
        2200.0,
        -300.0
      ],
      "bbox_max": [
        -2501.9697265625,
        6233.91845703125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -4599.8642578125,
        5607.64501953125,
        -22.699951171875
      ],
      "bbox_max": [
        -3662.578857421875,
        6233.91845703125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1010662093758583,
        -0.9432846307754517,
        0.3162275552749634
      ],
      "plane_d": 3427.828857421875,
      "bbox_min": [
        -2650.5576171875,
        3253.654296875,
        -300.0
      ],
      "bbox_max": [
        -2501.9697265625,
        3351.36181640625,
        4.2407684326171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -4901.68505859375,
        5405.974609375,
        150.0
      ],
      "bbox_max": [
        -4038.4375,
        5982.77783203125,
        546.6460571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3364546000957489,
        0.8870165944099426,
        0.31622767448425293
      ],
      "plane_d": 1797.4375,
      "bbox_min": [
        -3095.20947265625,
        -4693.75146484375,
        -300.0
      ],
      "bbox_max": [
        -1700.7498779296875,
        -2507.029541015625,
        1271.65087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3095.20947265625,
        -4693.75146484375,
        1170.251708984375
      ],
      "bbox_max": [
        -2912.14697265625,
        -4604.0595703125,
        1271.65087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7519490718841553,
        0.5784223675727844,
        0.31622791290283203
      ],
      "plane_d": 266.113037109375,
      "bbox_min": [
        -2870.094970703125,
        -3111.68505859375,
        -300.0
      ],
      "bbox_max": [
        -1700.7498779296875,
        -2507.029541015625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965404748916626,
        -0.2439502775669098,
        0.09209758043289185
      ],
      "plane_d": 2003.16259765625,
      "bbox_min": [
        -3412.67578125,
        -3589.257568359375,
        0.0
      ],
      "bbox_max": [
        -2861.24462890625,
        -3111.68505859375,
        1224.3428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8451709151268005,
        -0.3576369881629944,
        0.3972178101539612
      ],
      "plane_d": 904.6746826171875,
      "bbox_min": [
        -3412.67578125,
        -3589.257568359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -3058.93505859375,
        -3443.094970703125,
        1224.3428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31618040800094604,
        0.5486864447593689,
        0.7739335298538208
      ],
      "plane_d": -131.23565673828125,
      "bbox_min": [
        -3412.67578125,
        -3453.730224609375,
        1220.0
      ],
      "bbox_max": [
        -3403.8046875,
        -3443.094970703125,
        1224.3428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.25,
      "bbox_min": [
        -3714.02197265625,
        -3513.30859375,
        -300.0
      ],
      "bbox_max": [
        -1156.463623046875,
        -145.8916015625,
        1181.5667724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7111499905586243,
        0.6279056072235107,
        0.3162280023097992
      ],
      "plane_d": 3988.61865234375,
      "bbox_min": [
        -3605.199951171875,
        -2269.120849609375,
        -0.022125244140625
      ],
      "bbox_max": [
        -3605.1806640625,
        -2269.10009765625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6317505836486816,
        0.763104259967804,
        0.13624615967273712
      ],
      "plane_d": 4182.1328125,
      "bbox_min": [
        -3697.488525390625,
        -3196.55322265625,
        0.0
      ],
      "bbox_max": [
        -2298.42333984375,
        -145.8916015625,
        1181.53662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3697.488525390625,
        -3126.308349609375,
        100.0
      ],
      "bbox_max": [
        -2298.42333984375,
        -145.8916015625,
        1181.53662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499687671661377,
        0.6611047983169556,
        -0.022072862833738327
      ],
      "plane_d": 4375.75,
      "bbox_min": [
        -3697.488525390625,
        -2969.13720703125,
        700.0
      ],
      "bbox_max": [
        -3195.179443359375,
        -2384.901123046875,
        1181.53662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        -2906.989501953125,
        -940.0,
        100.0
      ],
      "bbox_max": [
        -2298.42333984375,
        -145.8916015625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320768237113953,
        0.5631359815597534,
        0.38332945108413696
      ],
      "plane_d": 259.0802001953125,
      "bbox_min": [
        -1942.9771728515625,
        -3113.202392578125,
        -300.0
      ],
      "bbox_max": [
        -1156.463623046875,
        -1953.526123046875,
        638.1046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4769039750099182,
        0.7969357371330261,
        0.37075066566467285
      ],
      "plane_d": 1317.8310546875,
      "bbox_min": [
        -1942.9771728515625,
        -3113.202392578125,
        0.0
      ],
      "bbox_max": [
        -1156.463623046875,
        -2021.68505859375,
        638.1046142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5844033360481262,
        0.7305042147636414,
        0.35332190990448
      ],
      "plane_d": 957.4642333984375,
      "bbox_min": [
        -1701.24462890625,
        -2876.868896484375,
        0.0
      ],
      "bbox_max": [
        -1156.463623046875,
        -2021.68505859375,
        499.8956604003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1201.24462890625,
        -2147.973876953125,
        0.0
      ],
      "bbox_max": [
        -1156.463623046875,
        -2021.68505859375,
        224.82118225097656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486832618713379,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 1755.0640869140625,
      "bbox_min": [
        -1846.306884765625,
        1230.0,
        -300.0
      ],
      "bbox_max": [
        -1430.0,
        2310.7763671875,
        -11.07925033569336
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": 1992.23486328125,
      "bbox_min": [
        -1807.8961181640625,
        2000.0,
        -300.0
      ],
      "bbox_max": [
        -1430.0,
        2310.7763671875,
        -126.31155395507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 1451.4854736328125,
      "bbox_min": [
        -1445.5028076171875,
        2000.0,
        -300.0
      ],
      "bbox_max": [
        -1430.0,
        2310.7763671875,
        -253.49160766601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7848663926124573,
        -0.5329020619392395,
        0.31622785329818726
      ],
      "plane_d": 1159.303466796875,
      "bbox_min": [
        -1890.3839111328125,
        -2019.4130859375,
        -300.0
      ],
      "bbox_max": [
        -157.67498779296875,
        844.7424926757812,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9361191391944885,
        0.15388573706150055,
        0.31622791290283203
      ],
      "plane_d": 1314.5240478515625,
      "bbox_min": [
        -1508.86181640625,
        63.21640396118164,
        -300.0
      ],
      "bbox_max": [
        -1313.2769775390625,
        844.7424926757812,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29317936301231384,
        0.9022449254989624,
        0.31622767448425293
      ],
      "plane_d": 1075.9822998046875,
      "bbox_min": [
        -1288.892333984375,
        -2019.4130859375,
        -300.0
      ],
      "bbox_max": [
        -157.67498779296875,
        -1068.1884765625,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.927556574344635,
        0.1990949660539627,
        0.31622761487960815
      ],
      "plane_d": -711.715087890625,
      "bbox_min": [
        -1288.892333984375,
        -2019.4130859375,
        -300.0
      ],
      "bbox_max": [
        -1102.856201171875,
        -1472.69580078125,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4163157343864441,
        0.8524560332298279,
        0.3162277638912201
      ],
      "plane_d": 939.8093872070312,
      "bbox_min": [
        -588.8224487304688,
        -1336.6162109375,
        -300.0
      ],
      "bbox_max": [
        -157.67498779296875,
        -1068.1884765625,
        -113.20274353027344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": 1261.748779296875,
      "bbox_min": [
        -2723.333251953125,
        -2028.718017578125,
        -10.000000953674316
      ],
      "bbox_max": [
        -803.7601928710938,
        2550.0,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -35.0,
      "bbox_min": [
        -2600.0,
        580.0,
        25.0
      ],
      "bbox_max": [
        -2320.0,
        800.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 580.0,
      "bbox_min": [
        -2600.0,
        580.0,
        70.0
      ],
      "bbox_max": [
        -2560.0,
        580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29667314887046814,
        0.9549791812896729,
        0.0
      ],
      "plane_d": -1.76104736328125,
      "bbox_min": [
        -2360.0,
        720.0,
        47.5
      ],
      "bbox_max": [
        -2340.0,
        735.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8753690123558044,
        0.48345550894737244,
        0.0
      ],
      "plane_d": 1700.275634765625,
      "bbox_min": [
        -2345.85791015625,
        720.0,
        47.5
      ],
      "bbox_max": [
        -2340.0,
        730.6066284179688,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9361191391944885,
        0.15388573706150055,
        0.31622791290283203
      ],
      "plane_d": 1314.5240478515625,
      "bbox_min": [
        -1440.376708984375,
        85.6016616821289,
        -10.000000953674316
      ],
      "bbox_max": [
        -1414.9208984375,
        240.45449829101562,
        3.9378738403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8825817704200745,
        0.14508481323719025,
        0.4472133219242096
      ],
      "plane_d": 1239.3453369140625,
      "bbox_min": [
        -1425.26611328125,
        86.37356567382812,
        0.0
      ],
      "bbox_max": [
        -1418.4259033203125,
        127.98397827148438,
        3.9378738403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7835570573806763,
        0.1681862473487854,
        0.5981235504150391
      ],
      "plane_d": -601.2240600585938,
      "bbox_min": [
        -1201.24462890625,
        -2028.718017578125,
        -10.0
      ],
      "bbox_max": [
        -803.7601928710938,
        -1450.233642578125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791625976562,
      "bbox_min": [
        -1102.856201171875,
        -1674.1927490234375,
        -10.0
      ],
      "bbox_max": [
        -803.7601928710938,
        -1450.233642578125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29317936301231384,
        0.9022449254989624,
        0.31622767448425293
      ],
      "plane_d": 1075.9822998046875,
      "bbox_min": [
        -1102.856201171875,
        -1550.0,
        -10.0
      ],
      "bbox_max": [
        -803.7601928710938,
        -1450.233642578125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1330.0,
      "bbox_min": [
        -2720.0,
        -2031.7603759765625,
        100.0
      ],
      "bbox_max": [
        -1094.052734375,
        1350.0,
        305.3538818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9974586963653564,
        0.07124704867601395
      ],
      "plane_d": 1312.37060546875,
      "bbox_min": [
        -2720.0,
        1330.0,
        200.0
      ],
      "bbox_max": [
        -2700.0,
        1350.0,
        305.3538818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 2678.888916015625,
      "bbox_min": [
        -2707.393310546875,
        1330.0,
        200.0
      ],
      "bbox_max": [
        -2700.0,
        1350.0,
        303.5066223144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9482250213623047,
        -0.2540792226791382,
        0.19055941700935364
      ],
      "plane_d": 2399.01171875,
      "bbox_min": [
        -2490.0,
        325.0,
        125.0
      ],
      "bbox_max": [
        -2460.0,
        370.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20959734916687012,
        -0.7822301983833313,
        0.5866726636886597
      ],
      "plane_d": 702.7881469726562,
      "bbox_min": [
        -2490.0,
        325.0,
        125.0
      ],
      "bbox_max": [
        -2464.019287109375,
        355.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6246971487998962,
        -0.6246936321258545,
        0.46852022409439087
      ],
      "plane_d": 1693.0966796875,
      "bbox_min": [
        -2475.0,
        329.01922607421875,
        125.0
      ],
      "bbox_max": [
        -2464.019287109375,
        355.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43283241987228394,
        -0.5771098732948303,
        0.6925318241119385
      ],
      "plane_d": 1174.4185791015625,
      "bbox_min": [
        -2460.0,
        310.0,
        100.0
      ],
      "bbox_max": [
        -2440.0,
        385.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -474.9999694824219,
      "bbox_min": [
        -2440.0,
        475.0,
        100.0
      ],
      "bbox_max": [
        -2415.0,
        475.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7835570573806763,
        0.1681862473487854,
        0.5981235504150391
      ],
      "plane_d": -601.2240600585938,
      "bbox_min": [
        -1126.4197998046875,
        -2031.7603759765625,
        100.0
      ],
      "bbox_max": [
        -1094.052734375,
        -1982.9415283203125,
        143.25726318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7835570573806763,
        0.1681862473487854,
        0.5981235504150391
      ],
      "plane_d": -601.2240600585938,
      "bbox_min": [
        -2700.0,
        -2033.634033203125,
        100.0
      ],
      "bbox_max": [
        -1022.4708251953125,
        2550.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791625976562,
      "bbox_min": [
        -1050.3228759765625,
        -1688.2943115234375,
        100.0
      ],
      "bbox_max": [
        -1022.4708251953125,
        -1665.1424560546875,
        111.35456085205078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1330.0,
      "bbox_min": [
        -2700.0,
        1330.0,
        100.0
      ],
      "bbox_max": [
        -2150.2705078125,
        2550.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2550.0,
      "bbox_min": [
        -2700.0,
        2550.0,
        100.0
      ],
      "bbox_max": [
        -2609.652587890625,
        2550.0,
        133.16798400878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5815920829772949,
        0.8134806156158447
      ],
      "plane_d": 463.345703125,
      "bbox_min": [
        -4205.0,
        -5072.0185546875,
        -300.0
      ],
      "bbox_max": [
        7823.75537109375,
        -696.68505859375,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3461.15576171875,
        -5072.0185546875,
        1212.388916015625
      ],
      "bbox_max": [
        -2147.99658203125,
        -4521.4228515625,
        1390.116943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -1549.2021484375,
        -3672.376220703125,
        0.0
      ],
      "bbox_max": [
        334.5896301269531,
        -2051.8349609375,
        892.7235107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320768237113953,
        0.5631359815597534,
        0.38332945108413696
      ],
      "plane_d": 259.0802001953125,
      "bbox_min": [
        -1549.2021484375,
        -2765.516357421875,
        202.6451416015625
      ],
      "bbox_max": [
        -1145.6080322265625,
        -2051.8349609375,
        445.481201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1549.2021484375,
        -2765.516357421875,
        202.6451416015625
      ],
      "bbox_max": [
        -1145.6080322265625,
        -2051.8349609375,
        445.481201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5844033360481262,
        0.7305042147636414,
        0.35332190990448
      ],
      "plane_d": 957.4642333984375,
      "bbox_min": [
        -1549.2021484375,
        -2765.516357421875,
        435.46630859375
      ],
      "bbox_max": [
        -1527.4627685546875,
        -2745.02197265625,
        445.481201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14309725165367126,
        0.2930086553096771,
        0.9453407526016235
      ],
      "plane_d": 323.03399658203125,
      "bbox_min": [
        -1074.1181640625,
        -2039.7471923828125,
        -300.0
      ],
      "bbox_max": [
        3250.0,
        -696.68505859375,
        372.2240905761719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4163157343864441,
        0.8524560332298279,
        0.3162277638912201
      ],
      "plane_d": 939.8093872070312,
      "bbox_min": [
        -794.8798828125,
        -1446.0003662109375,
        -300.0
      ],
      "bbox_max": [
        3250.0,
        -696.68505859375,
        372.2240905761719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 3250.0,
      "bbox_min": [
        3250.0,
        -1320.0,
        -300.0
      ],
      "bbox_max": [
        3250.0,
        -696.68505859375,
        372.2240905761719
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.29317936301231384,
        0.9022449254989624,
        0.31622767448425293
      ],
      "plane_d": 1075.9822998046875,
      "bbox_min": [
        -794.8798828125,
        -1446.0003662109375,
        -113.20272827148438
      ],
      "bbox_max": [
        -551.24462890625,
        -1336.6162109375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791625976562,
      "bbox_min": [
        -1074.1181640625,
        -2039.7471923828125,
        -13.845283508300781
      ],
      "bbox_max": [
        -504.59906005859375,
        -1371.68505859375,
        256.8197326660156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -681.8506469726562,
        -1625.7083740234375,
        0.0
      ],
      "bbox_max": [
        -504.59906005859375,
        -1371.68505859375,
        150.77035522460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320768237113953,
        0.5631359815597534,
        0.38332945108413696
      ],
      "plane_d": 259.0802001953125,
      "bbox_min": [
        -1939.5810546875,
        -3110.41064453125,
        252.5998992919922
      ],
      "bbox_max": [
        -1146.247314453125,
        -2061.89208984375,
        636.471923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4769039750099182,
        0.7969357371330261,
        0.37075066566467285
      ],
      "plane_d": 1317.8310546875,
      "bbox_min": [
        -1939.5810546875,
        -3110.41064453125,
        252.5998992919922
      ],
      "bbox_max": [
        -1146.247314453125,
        -2061.89208984375,
        636.471923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5844033360481262,
        0.7305042147636414,
        0.35332190990448
      ],
      "plane_d": 957.4642333984375,
      "bbox_min": [
        -1655.49462890625,
        -2909.402099609375,
        252.5998992919922
      ],
      "bbox_max": [
        -1146.247314453125,
        -2061.89208984375,
        579.1571044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1174.739013671875,
        -2196.1005859375,
        252.5998992919922
      ],
      "bbox_max": [
        -1146.247314453125,
        -2061.89208984375,
        310.49688720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7835570573806763,
        0.1681862473487854,
        0.5981235504150391
      ],
      "plane_d": -601.2240600585938,
      "bbox_min": [
        -1009.5068969726562,
        -2039.88671875,
        252.60006713867188
      ],
      "bbox_max": [
        -1007.5953979492188,
        -2026.730712890625,
        258.80352783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3156070411205292,
        0.8320549726486206,
        0.45615431666374207
      ],
      "plane_d": 1686.0640869140625,
      "bbox_min": [
        -2286.8662109375,
        -3399.51513671875,
        251.769287109375
      ],
      "bbox_max": [
        -1088.6651611328125,
        -2059.143798828125,
        1050.829833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5844033360481262,
        0.7305042147636414,
        0.35332190990448
      ],
      "plane_d": 957.4642333984375,
      "bbox_min": [
        -1648.24072265625,
        -3047.155029296875,
        251.769287109375
      ],
      "bbox_max": [
        -1088.6651611328125,
        -2059.143798828125,
        914.769287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1172.828125,
        -2377.942626953125,
        251.769287109375
      ],
      "bbox_max": [
        -1088.6651611328125,
        -2059.143798828125,
        634.215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -1018.4613037109375,
        -2110.8046875,
        137.07241821289062
      ],
      "bbox_max": [
        -436.7973327636719,
        -1565.9052734375,
        530.9656372070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7835570573806763,
        0.1681862473487854,
        0.5981235504150391
      ],
      "plane_d": -601.2240600585938,
      "bbox_min": [
        -1012.9479370117188,
        -2050.0,
        218.60536193847656
      ],
      "bbox_max": [
        -900.0,
        -1921.8662109375,
        402.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791625976562,
      "bbox_min": [
        -1018.4613037109375,
        -2050.0,
        150.7703399658203
      ],
      "bbox_max": [
        -681.8505859375,
        -1625.7083740234375,
        402.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        544.5404052734375,
        -1746.02099609375,
        252.5999755859375
      ],
      "bbox_max": [
        1019.5872802734375,
        -1600.0,
        431.564697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -614.9921264648438,
        -1691.1806640625,
        114.45515441894531
      ],
      "bbox_max": [
        650.0,
        -1467.1614990234375,
        376.37701416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -614.9921264648438,
        -1689.80029296875,
        114.45515441894531
      ],
      "bbox_max": [
        -411.225341796875,
        -1467.1614990234375,
        356.619873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320768237113953,
        0.5631359815597534,
        0.38332945108413696
      ],
      "plane_d": 259.0802001953125,
      "bbox_min": [
        -3625.179443359375,
        -3623.86962890625,
        509.4501647949219
      ],
      "bbox_max": [
        -1001.381103515625,
        -2097.481689453125,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5160083770751953,
        0.7518967390060425,
        0.41034960746765137
      ],
      "plane_d": 1040.8973388671875,
      "bbox_min": [
        -2100.0,
        -3623.86962890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -1550.0,
        -3350.0,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31618040800094604,
        0.5486864447593689,
        0.7739335298538208
      ],
      "plane_d": -131.23565673828125,
      "bbox_min": [
        -3625.179443359375,
        -3619.13720703125,
        1037.2603759765625
      ],
      "bbox_max": [
        -2988.559814453125,
        -3212.1396484375,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011314941570162773,
        0.9574529528617859,
        0.2883673906326294
      ],
      "plane_d": 3096.69091796875,
      "bbox_min": [
        -3625.179443359375,
        -3619.13720703125,
        1274.598876953125
      ],
      "bbox_max": [
        -3260.67529296875,
        -3576.798583984375,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6317505836486816,
        0.763104259967804,
        0.13624615967273712
      ],
      "plane_d": 4182.1328125,
      "bbox_min": [
        -3070.88916015625,
        -3408.108154296875,
        1030.70751953125
      ],
      "bbox_max": [
        -2099.20068359375,
        -3126.308349609375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965404748916626,
        -0.2439502775669098,
        0.09209758043289185
      ],
      "plane_d": 2003.16259765625,
      "bbox_min": [
        -3003.01416015625,
        -3223.927001953125,
        1030.70751953125
      ],
      "bbox_max": [
        -2981.017578125,
        -3196.55322265625,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -2144.14453125,
        -3408.108154296875,
        1050.490234375
      ],
      "bbox_max": [
        -2099.20068359375,
        -3398.540283203125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3156070411205292,
        0.8320549726486206,
        0.45615431666374207
      ],
      "plane_d": 1686.0640869140625,
      "bbox_min": [
        -2101.2802734375,
        -3400.0,
        1050.490234375
      ],
      "bbox_max": [
        -2099.20068359375,
        -3398.540283203125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        -778.3904418945312,
        -2403.4306640625,
        444.7264709472656
      ],
      "bbox_max": [
        1109.864501953125,
        -1902.55712890625,
        1148.731201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -778.3904418945312,
        -2403.4306640625,
        444.7264709472656
      ],
      "bbox_max": [
        -166.50149536132812,
        -1902.55712890625,
        1148.731201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -476.12396240234375,
        -2318.328857421875,
        595.6363525390625
      ],
      "bbox_max": [
        360.59344482421875,
        -1980.4971923828125,
        1087.8883056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -164.90333557128906,
        -2234.215087890625,
        742.3649291992188
      ],
      "bbox_max": [
        360.59344482421875,
        -2000.716796875,
        1027.7518310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -3652.813720703125,
        -2586.1181640625,
        356.619873046875
      ],
      "bbox_max": [
        -164.9033203125,
        -1689.80029296875,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -3652.813720703125,
        -2586.1181640625,
        793.7977294921875
      ],
      "bbox_max": [
        -869.4028930664062,
        -2139.787109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -3652.813720703125,
        -2586.1181640625,
        793.7977294921875
      ],
      "bbox_max": [
        -987.1666259765625,
        -2139.787353515625,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3652.813720703125,
        -2586.1181640625,
        1152.9107666015625
      ],
      "bbox_max": [
        -3528.30859375,
        -2436.3173828125,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -987.384765625,
        -2188.843505859375,
        967.7686157226562
      ],
      "bbox_max": [
        -963.984130859375,
        -2165.6708984375,
        995.3135986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -987.384765625,
        -2187.933349609375,
        967.7688598632812
      ],
      "bbox_max": [
        -984.6701049804688,
        -2165.6708984375,
        994.6629028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -436.7973327636719,
        -1732.9390869140625,
        343.56817626953125
      ],
      "bbox_max": [
        3250.0,
        -1312.6414794921875,
        433.06378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -436.7973327636719,
        -1732.9390869140625,
        343.56817626953125
      ],
      "bbox_max": [
        -374.75189208984375,
        -1658.283447265625,
        433.06378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 3250.0,
      "bbox_min": [
        3250.0,
        -1320.0,
        368.87933349609375
      ],
      "bbox_max": [
        3250.0,
        -1312.6414794921875,
        374.1402282714844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -1247.748291015625,
        -3334.0634765625,
        1087.8883056640625
      ],
      "bbox_max": [
        85.42315673828125,
        -2318.328857421875,
        1814.080322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1247.748291015625,
        -3108.19873046875,
        1179.737548828125
      ],
      "bbox_max": [
        -560.601318359375,
        -2446.799560546875,
        1656.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -713.9907836914062,
        -2605.074951171875,
        1179.737548828125
      ],
      "bbox_max": [
        -560.601318359375,
        -2446.799560546875,
        1347.8153076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5844033360481262,
        0.7305042147636414,
        0.35332190990448
      ],
      "plane_d": 957.4642333984375,
      "bbox_min": [
        -1247.748291015625,
        -3108.19873046875,
        1463.5894775390625
      ],
      "bbox_max": [
        -1050.0,
        -2843.8271484375,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -193.138916015625,
        -2500.0,
        1087.8883056640625
      ],
      "bbox_max": [
        0.0,
        -2318.328857421875,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1027.7886962890625,
        -2691.333984375,
        1018.5446166992188
      ],
      "bbox_max": [
        0.0,
        -2221.3369140625,
        1460.0020751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -869.4028930664062,
        -2604.275634765625,
        1018.5446166992188
      ],
      "bbox_max": [
        0.0,
        -2221.3369140625,
        1411.13330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -869.4028930664062,
        -2604.275634765625,
        1065.087646484375
      ],
      "bbox_max": [
        -556.13720703125,
        -2286.437255859375,
        1411.13330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -602.8602294921875,
        -2604.275634765625,
        1347.8153076171875
      ],
      "bbox_max": [
        -556.13720703125,
        -2552.319091796875,
        1411.13330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -4128.15283203125,
        -2962.61669921875,
        1113.0572509765625
      ],
      "bbox_max": [
        -233.89088439941406,
        -2312.3681640625,
        1774.980712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8395622968673706,
        0.49151238799095154,
        0.231409952044487
      ],
      "plane_d": 4493.8125,
      "bbox_min": [
        -4128.15283203125,
        -2759.122802734375,
        1395.3636474609375
      ],
      "bbox_max": [
        -4123.98779296875,
        -2748.39892578125,
        1403.0306396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        -1001.381103515625,
        -2397.92236328125,
        749.0462646484375
      ],
      "bbox_max": [
        2400.0,
        -1844.385986328125,
        1239.543212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022904695942997932,
        0.8625975847244263,
        0.5053718686103821
      ],
      "plane_d": 1267.3873291015625,
      "bbox_min": [
        1721.03564453125,
        -2050.0,
        749.0462646484375
      ],
      "bbox_max": [
        2400.0,
        -1844.385986328125,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -1001.381103515625,
        -2397.92236328125,
        980.05322265625
      ],
      "bbox_max": [
        -773.8843383789062,
        -2167.49853515625,
        1239.543212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1001.381103515625,
        -2397.92236328125,
        980.05322265625
      ],
      "bbox_max": [
        -973.9004516601562,
        -2167.49853515625,
        1239.543212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.4123840332031,
      "bbox_min": [
        2962.536376953125,
        -1390.916015625,
        301.464111328125
      ],
      "bbox_max": [
        7600.0,
        -1218.346923828125,
        602.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.4123840332031,
      "bbox_min": [
        2455.53076171875,
        -1350.0,
        213.0130615234375
      ],
      "bbox_max": [
        7600.0,
        -1094.629150390625,
        602.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 3250.0,
      "bbox_min": [
        3250.0,
        -1263.3626708984375,
        213.0130615234375
      ],
      "bbox_max": [
        3250.0,
        -1094.629150390625,
        346.4798583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 3250.0,
      "bbox_min": [
        3250.0,
        -1320.0,
        309.8115234375
      ],
      "bbox_max": [
        3250.0,
        -1182.6922607421875,
        455.8563232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -4205.0,
        -2915.382080078125,
        252.5999755859375
      ],
      "bbox_max": [
        3250.0,
        -1150.0,
        1770.0086669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -973.9004516601562,
        -2915.382080078125,
        252.5999755859375
      ],
      "bbox_max": [
        3250.0,
        -1150.0,
        1770.0086669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8705313205718994,
        0.4785127639770508,
        0.11489474773406982
      ],
      "plane_d": 4224.23291015625,
      "bbox_min": [
        -3712.849365234375,
        -2384.524658203125,
        1181.5667724609375
      ],
      "bbox_max": [
        -3697.73974609375,
        -2363.246337890625,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499687671661377,
        0.6611047983169556,
        -0.022072862833738327
      ],
      "plane_d": 4375.75,
      "bbox_min": [
        -3712.849365234375,
        -2384.524658203125,
        1182.310546875
      ],
      "bbox_max": [
        -3697.797607421875,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3712.849365234375,
        -2378.30322265625,
        1210.55859375
      ],
      "bbox_max": [
        -3702.450439453125,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3725.179443359375,
        -2503.115234375,
        1172.2432861328125
      ],
      "bbox_max": [
        -3597.956298828125,
        -2323.558349609375,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.25,
      "bbox_min": [
        -3725.179443359375,
        -2329.201904296875,
        1179.126708984375
      ],
      "bbox_max": [
        -3714.01416015625,
        -2323.558349609375,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -909.1630249023438,
        -2564.65576171875,
        1348.62158203125
      ],
      "bbox_max": [
        -575.9976196289062,
        -2222.334716796875,
        1733.090087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -903.2229614257812,
        -2564.65576171875,
        1348.62158203125
      ],
      "bbox_max": [
        -575.9976196289062,
        -2222.334716796875,
        1733.090087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -825.0,
        -2564.65576171875,
        1547.93359375
      ],
      "bbox_max": [
        -575.9976196289062,
        -2275.0,
        1733.090087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -4095.87744140625,
        4858.1806640625,
        -300.0
      ],
      "bbox_max": [
        5574.01171875,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7881146669387817,
        0.06996545940637589,
        0.6115390658378601
      ],
      "plane_d": -136.38497924804688,
      "bbox_min": [
        249.411865234375,
        5047.4609375,
        -33.027774810791016
      ],
      "bbox_max": [
        588.0418701171875,
        7287.82421875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -4038.4375,
        5982.77783203125,
        -300.0
      ],
      "bbox_max": [
        448.3017578125,
        7287.82421875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05985559523105621,
        -0.9467930197715759,
        0.3162282705307007
      ],
      "plane_d": 6873.22802734375,
      "bbox_min": [
        -150.0,
        7155.99462890625,
        -300.0
      ],
      "bbox_max": [
        448.3017578125,
        7287.82421875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7881146669387817,
        0.06996545940637589,
        0.6115390658378601
      ],
      "plane_d": -136.38497924804688,
      "bbox_min": [
        -4095.87744140625,
        5654.2333984375,
        150.0
      ],
      "bbox_max": [
        943.3017578125,
        7262.134765625,
        615.3095092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3932375907897949,
        -0.4582340121269226,
        0.797110915184021
      ],
      "plane_d": 2052.83154296875,
      "bbox_min": [
        -4095.87744140625,
        5724.8427734375,
        150.0
      ],
      "bbox_max": [
        -1146.6842041015625,
        6956.19140625,
        506.298583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -4095.87744140625,
        5944.39794921875,
        150.0
      ],
      "bbox_max": [
        -2708.39404296875,
        6871.484375,
        470.39349365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0844237431883812,
        -0.9449194669723511,
        0.31622740626335144
      ],
      "plane_d": 5014.3017578125,
      "bbox_min": [
        3040.46826171875,
        4858.1806640625,
        -300.0
      ],
      "bbox_max": [
        3966.75,
        5034.5224609375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3052.0458984375,
        4947.60009765625,
        -13.693603515625
      ],
      "bbox_max": [
        5574.01171875,
        6882.69287109375,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4461669921875,
      "bbox_min": [
        2769.303955078125,
        4948.55078125,
        -13.543867111206055
      ],
      "bbox_max": [
        3970.173828125,
        7185.4150390625,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        2816.62109375,
        4948.55078125,
        -13.543867111206055
      ],
      "bbox_max": [
        3970.173828125,
        6929.521484375,
        625.4671020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        2922.08447265625,
        6889.404296875,
        624.2335205078125
      ],
      "bbox_max": [
        3018.3056640625,
        6908.54345703125,
        627.6549072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        2925.637451171875,
        6189.97607421875,
        610.119873046875
      ],
      "bbox_max": [
        4128.34375,
        6907.8369140625,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        2925.637451171875,
        6871.484375,
        620.9074096679688
      ],
      "bbox_max": [
        3108.39404296875,
        6907.8369140625,
        740.1891479492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        -2975.755615234375,
        -484.3836669921875,
        -300.0
      ],
      "bbox_max": [
        4399.7919921875,
        5561.64794921875,
        150.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        235.99966430664062,
        5034.5224609375,
        -36.837890625
      ],
      "bbox_max": [
        3923.18212890625,
        5561.64794921875,
        150.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4461669921875,
      "bbox_min": [
        2532.767578125,
        5034.5224609375,
        0.0
      ],
      "bbox_max": [
        3045.157470703125,
        5561.64794921875,
        150.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9449668526649475,
        0.08389011770486832,
        0.3162277042865753
      ],
      "plane_d": -187.74609375,
      "bbox_min": [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      "bbox_max": [
        259.23272705078125,
        5158.08642578125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0844237431883812,
        -0.9449194669723511,
        0.31622740626335144
      ],
      "plane_d": 5014.3017578125,
      "bbox_min": [
        3045.157470703125,
        4116.14306640625,
        -13.525781631469727
      ],
      "bbox_max": [
        4399.7919921875,
        5039.8720703125,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 2900.0,
      "bbox_min": [
        -2975.755615234375,
        -350.48101806640625,
        -300.0
      ],
      "bbox_max": [
        2986.593994140625,
        3398.1728515625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -2975.755615234375,
        2550.0,
        -300.0
      ],
      "bbox_max": [
        -1430.0,
        3398.1728515625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        -2310.01953125,
        -331.35205078125,
        -300.0
      ],
      "bbox_max": [
        2850.0,
        2550.0,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9168806076049805,
        0.24357743561267853,
        0.3162277340888977
      ],
      "plane_d": -917.7099609375,
      "bbox_min": [
        -754.0657958984375,
        1023.30224609375,
        -300.0
      ],
      "bbox_max": [
        -616.7625732421875,
        1612.0,
        -68.4015884399414
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9440768361091614,
        -0.09337516874074936,
        0.3162277936935425
      ],
      "plane_d": -493.8998718261719,
      "bbox_min": [
        -754.0657958984375,
        1023.30224609375,
        -300.0
      ],
      "bbox_max": [
        -690.84814453125,
        1318.6358642578125,
        -178.35519409179688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2340.0,
      "bbox_min": [
        450.0,
        2340.0,
        50.0
      ],
      "bbox_max": [
        590.0,
        2490.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2350.0,
      "bbox_min": [
        450.0,
        2350.0,
        50.0
      ],
      "bbox_max": [
        580.0,
        2490.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 450.0,
      "bbox_min": [
        450.0,
        2400.0,
        50.0
      ],
      "bbox_max": [
        450.0,
        2490.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        460.0,
        1300.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        2035.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        460.0,
        1300.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        2035.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2035.0,
      "bbox_min": [
        460.0,
        2035.0,
        110.0
      ],
      "bbox_max": [
        560.0,
        2035.0,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2035.0,
      "bbox_min": [
        450.0,
        2035.0,
        110.0
      ],
      "bbox_max": [
        468.0,
        2350.0,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2350.0,
      "bbox_min": [
        450.0,
        2340.0,
        110.0
      ],
      "bbox_max": [
        468.0,
        2350.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 1451.4854736328125,
      "bbox_min": [
        -1729.56640625,
        1626.2855224609375,
        -10.0
      ],
      "bbox_max": [
        450.0,
        2550.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2100.0,
      "bbox_min": [
        -1537.6434326171875,
        2100.0,
        0.0
      ],
      "bbox_max": [
        -1530.0,
        2100.0,
        24.185041427612305
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2340.0,
      "bbox_min": [
        440.0,
        2340.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        2340.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        145.1197509765625,
        1626.2855224609375,
        60.0
      ],
      "bbox_max": [
        216.65475463867188,
        1733.34521484375,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -5242.5185546875,
        564.539306640625,
        150.0
      ],
      "bbox_max": [
        6306.5068359375,
        7450.0,
        1913.5762939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3932375907897949,
        -0.4582340121269226,
        0.797110915184021
      ],
      "plane_d": 2052.83154296875,
      "bbox_min": [
        -5242.5185546875,
        564.539306640625,
        150.0
      ],
      "bbox_max": [
        3968.13720703125,
        7196.82421875,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4461669921875,
      "bbox_min": [
        943.3017578125,
        5419.32177734375,
        150.0
      ],
      "bbox_max": [
        3968.13720703125,
        7196.82421875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        3020.6171875,
        5419.32177734375,
        150.0
      ],
      "bbox_max": [
        3720.545654296875,
        6729.98193359375,
        570.58251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3108.39404296875,
        6297.0224609375,
        740.189208984375
      ],
      "bbox_max": [
        3968.13720703125,
        6871.484375,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4458966553211212,
        -0.5487951040267944,
        0.70710688829422
      ],
      "plane_d": 1836.47314453125,
      "bbox_min": [
        1390.0,
        2620.0,
        338.0
      ],
      "bbox_max": [
        1460.0,
        2665.384765625,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 1613.61767578125,
      "bbox_min": [
        1430.0,
        2620.0,
        338.0
      ],
      "bbox_max": [
        1460.0,
        2630.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.445895254611969,
        -0.548794150352478,
        0.7071084380149841
      ],
      "plane_d": 1836.46826171875,
      "bbox_min": [
        1240.0,
        2668.75,
        258.0
      ],
      "bbox_max": [
        1370.0,
        2830.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        1240.0,
        2750.0,
        258.0
      ],
      "bbox_max": [
        1280.0,
        2830.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 659.0234985351562,
      "bbox_min": [
        1270.0,
        2750.0,
        338.0
      ],
      "bbox_max": [
        1280.0,
        2800.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7757112979888916,
        -0.6237470507621765,
        0.0959770455956459
      ],
      "plane_d": 2353.7822265625,
      "bbox_min": [
        943.349853515625,
        2550.0,
        181.13720703125
      ],
      "bbox_max": [
        1270.0,
        2774.375244140625,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2750.0,
      "bbox_min": [
        1240.0,
        2750.0,
        258.0
      ],
      "bbox_max": [
        1270.0,
        2774.375244140625,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        1240.0,
        2750.0,
        258.0
      ],
      "bbox_max": [
        1240.0,
        2774.375244140625,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        -1550.0,
        2550.0,
        150.0
      ],
      "bbox_max": [
        -1530.0,
        2570.0,
        224.7709503173828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        0.0,
        0.07124704867601395
      ],
      "plane_d": 1511.8624267578125,
      "bbox_min": [
        -1550.0,
        2550.0,
        200.0
      ],
      "bbox_max": [
        -1530.0,
        2570.0,
        224.7709503173828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9974586963653564,
        0.07124704867601395
      ],
      "plane_d": 2529.270263671875,
      "bbox_min": [
        -1550.0,
        2550.0,
        200.0
      ],
      "bbox_max": [
        -1530.0,
        2551.255126953125,
        217.57269287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8454892635345459,
        1.1590022950258572e-06,
        0.5339924693107605
      ],
      "plane_d": 700.8634033203125,
      "bbox_min": [
        930.0,
        2430.0,
        160.0
      ],
      "bbox_max": [
        1360.0,
        2550.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1360.0,
      "bbox_min": [
        1360.0,
        2461.5791015625,
        210.0
      ],
      "bbox_max": [
        1360.0,
        2530.0,
        318.33306884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1360.0,
      "bbox_min": [
        1360.0,
        2420.0,
        210.0
      ],
      "bbox_max": [
        1360.0,
        2530.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2340.0,
      "bbox_min": [
        450.0,
        2185.0,
        150.0
      ],
      "bbox_max": [
        590.0,
        2340.0,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7371524572372437,
        0.6757264733314514,
        0.0
      ],
      "plane_d": -1142.690673828125,
      "bbox_min": [
        456.1405029296875,
        2185.0,
        180.0
      ],
      "bbox_max": [
        477.5,
        2211.96142578125,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9711352586746216,
        0.23852995038032532,
        0.0
      ],
      "plane_d": -78.21383666992188,
      "bbox_min": [
        456.1405029296875,
        2185.0,
        180.0
      ],
      "bbox_max": [
        457.36859130859375,
        2190.0,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -326.482421875,
      "bbox_min": [
        1563.76904296875,
        2025.4847412109375,
        500.0
      ],
      "bbox_max": [
        1588.2843017578125,
        2050.0,
        514.5410766601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2805706262588501,
        -0.9598334431648254,
        -0.0
      ],
      "plane_d": 2157.33837890625,
      "bbox_min": [
        450.0,
        2100.0,
        180.0
      ],
      "bbox_max": [
        532.5,
        2185.0,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2805706262588501,
        -0.9598334431648254,
        0.0
      ],
      "plane_d": 1873.962158203125,
      "bbox_min": [
        450.0,
        2100.0,
        180.0
      ],
      "bbox_max": [
        532.5,
        2185.0,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9711352586746216,
        0.23852995038032532,
        0.0
      ],
      "plane_d": -78.21383666992188,
      "bbox_min": [
        450.0,
        2160.0,
        180.0
      ],
      "bbox_max": [
        456.1405029296875,
        2185.0,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 440.0,
      "bbox_min": [
        -1530.0,
        1820.0,
        150.0
      ],
      "bbox_max": [
        450.0,
        2550.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2340.0,
      "bbox_min": [
        440.0,
        2340.0,
        150.0
      ],
      "bbox_max": [
        450.0,
        2340.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        -1530.0,
        2393.26708984375,
        150.0
      ],
      "bbox_max": [
        -1530.0,
        2550.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -5704.54443359375,
        -1204.943603515625,
        -300.0
      ],
      "bbox_max": [
        3250.0,
        5535.2431640625,
        1224.7767333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -5579.1611328125,
        -996.68505859375,
        -300.0
      ],
      "bbox_max": [
        3250.0,
        5535.2431640625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 3170.0,
      "bbox_min": [
        3020.0,
        -556.275634765625,
        232.0
      ],
      "bbox_max": [
        3170.0,
        -388.6426086425781,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9255444407463074,
        -0.37863919138908386,
        0.0
      ],
      "plane_d": 2606.203369140625,
      "bbox_min": [
        3020.0,
        -556.275634765625,
        232.0
      ],
      "bbox_max": [
        3043.431396484375,
        -441.724365234375,
        311.43756103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 3170.0,
      "bbox_min": [
        3170.0,
        -388.6426696777344,
        500.0
      ],
      "bbox_max": [
        3170.0,
        -331.7283935546875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9805806875228882,
        0.1961161345243454
      ],
      "plane_d": -421.6496887207031,
      "bbox_min": [
        3020.0,
        290.6427001953125,
        232.0
      ],
      "bbox_max": [
        3250.0,
        458.275634765625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 3170.0,
      "bbox_min": [
        3027.118408203125,
        290.6427001953125,
        232.0
      ],
      "bbox_max": [
        3170.0,
        383.6000061035156,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9255444407463074,
        0.37863919138908386,
        0.0
      ],
      "plane_d": 2643.31005859375,
      "bbox_min": [
        3020.0,
        376.708251953125,
        232.0
      ],
      "bbox_max": [
        3043.431396484375,
        458.275634765625,
        311.43756103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9255444407463074,
        -0.37863919138908386,
        0.0
      ],
      "plane_d": 2946.978515625,
      "bbox_min": [
        3020.0,
        376.708251953125,
        232.0
      ],
      "bbox_max": [
        3029.937744140625,
        401.0,
        266.4587707519531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 3170.0,
      "bbox_min": [
        3020.0,
        -309.35723876953125,
        232.0
      ],
      "bbox_max": [
        3250.0,
        290.64276123046875,
        650.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9805806875228882,
        0.1961161345243454
      ],
      "plane_d": 166.69869995117188,
      "bbox_min": [
        3170.0,
        -300.0,
        500.0
      ],
      "bbox_max": [
        3250.0,
        -270.0,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9255444407463074,
        -0.37863919138908386,
        0.0
      ],
      "plane_d": 2719.795166015625,
      "bbox_min": [
        3020.0,
        -256.275634765625,
        232.0
      ],
      "bbox_max": [
        3043.431396484375,
        -199.0,
        311.43756103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 3170.0,
      "bbox_min": [
        3170.0,
        -350.2469177246094,
        500.0
      ],
      "bbox_max": [
        3170.0,
        -309.357177734375,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3867550790309906,
        0.9221825003623962,
        0.0
      ],
      "plane_d": 1584.4129638671875,
      "bbox_min": [
        3020.0,
        -556.275634765625,
        233.33306884765625
      ],
      "bbox_max": [
        3100.0,
        -418.0,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9255444407463074,
        -0.37863919138908386,
        0.0
      ],
      "plane_d": 2606.203369140625,
      "bbox_min": [
        3020.0,
        -556.275634765625,
        233.33306884765625
      ],
      "bbox_max": [
        3043.431396484375,
        -441.724365234375,
        478.10467529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9255444407463074,
        0.37863919138908386,
        0.0
      ],
      "plane_d": 2984.085205078125,
      "bbox_min": [
        3020.0,
        -499.0,
        233.3330841064453
      ],
      "bbox_max": [
        3043.431396484375,
        -441.724365234375,
        478.10467529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3867550790309906,
        0.9221825003623962,
        0.0
      ],
      "plane_d": 754.44873046875,
      "bbox_min": [
        3020.0,
        343.724365234375,
        233.33306884765625
      ],
      "bbox_max": [
        3100.0,
        482.0,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9255444407463074,
        -0.37863919138908386,
        0.0
      ],
      "plane_d": 2946.978515625,
      "bbox_min": [
        3020.0,
        343.724365234375,
        233.33306884765625
      ],
      "bbox_max": [
        3043.431396484375,
        458.275634765625,
        478.10467529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3867550790309906,
        -0.9221825003623962,
        0.0
      ],
      "plane_d": 940.729736328125,
      "bbox_min": [
        3020.0,
        -280.0,
        233.33306884765625
      ],
      "bbox_max": [
        3100.0,
        -199.0,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9255444407463074,
        -0.37863919138908386,
        0.0
      ],
      "plane_d": 2719.795166015625,
      "bbox_min": [
        3020.0,
        -256.275634765625,
        233.33306884765625
      ],
      "bbox_max": [
        3043.431396484375,
        -199.0,
        478.10467529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 2850.0,
      "bbox_min": [
        2849.819580078125,
        -430.0,
        -300.0
      ],
      "bbox_max": [
        2850.0,
        -270.0,
        -166.66685485839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 2678.888916015625,
      "bbox_min": [
        -2710.0,
        2550.0,
        200.0
      ],
      "bbox_max": [
        -1531.2552490234375,
        2570.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1880.0,
        1326.306884765625,
        -30.0
      ],
      "bbox_max": [
        -1840.0,
        1950.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -0.0,
      "bbox_min": [
        -1880.0,
        1750.0,
        -10.0
      ],
      "bbox_max": [
        -1846.6666259765625,
        1950.0,
        89.99977111816406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1949.9998779296875,
      "bbox_min": [
        -1880.0,
        1750.0,
        -10.0
      ],
      "bbox_max": [
        -1846.6666259765625,
        1950.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1949.9998779296875,
      "bbox_min": [
        -1880.0,
        1750.0,
        0.0
      ],
      "bbox_max": [
        -1850.0,
        1950.0,
        89.99977111816406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1880.0,
        1750.0,
        0.0
      ],
      "bbox_max": [
        -1850.0001220703125,
        1750.0,
        89.99977111816406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": 1261.748779296875,
      "bbox_min": [
        -1877.876708984375,
        1326.6666259765625,
        -10.0
      ],
      "bbox_max": [
        -1846.6666259765625,
        1330.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1330.0,
      "bbox_min": [
        -1883.3333740234375,
        1330.0,
        -6.103515625e-05
      ],
      "bbox_max": [
        -1850.0,
        1950.0,
        100.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1949.9998779296875,
      "bbox_min": [
        -1880.0,
        1750.0,
        -6.103515625e-05
      ],
      "bbox_max": [
        -1850.0,
        1950.0,
        100.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7399791479110718,
        -0.5024248361587524,
        0.447213739156723
      ],
      "plane_d": 1093.001953125,
      "bbox_min": [
        -1850.0001220703125,
        -106.07270812988281,
        -31.08110809326172
      ],
      "bbox_max": [
        -1420.4962158203125,
        2141.466796875,
        100.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1840.0,
      "bbox_min": [
        -1850.0001220703125,
        415.0,
        -31.08110809326172
      ],
      "bbox_max": [
        -1580.0,
        2100.0,
        100.00001525878906
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        -1615.0,
        460.0,
        60.0
      ],
      "bbox_max": [
        -1580.0,
        530.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 530.0,
      "bbox_min": [
        -1615.0,
        530.0,
        60.0
      ],
      "bbox_max": [
        -1580.0,
        530.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2100.0,
      "bbox_min": [
        -1800.110595703125,
        2100.0,
        0.0
      ],
      "bbox_max": [
        -1749.4398193359375,
        2100.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9587981700897217,
        0.0,
        0.2840883433818817
      ],
      "plane_d": 2732.57470703125,
      "bbox_min": [
        2850.0,
        -430.0,
        0.0
      ],
      "bbox_max": [
        2918.0,
        -270.0,
        60.000003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9924651980400085,
        0.12252657115459442
      ],
      "plane_d": 267.9656066894531,
      "bbox_min": [
        2850.0,
        -277.40740966796875,
        0.0
      ],
      "bbox_max": [
        2918.0,
        -270.0,
        60.000003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9582756161689758,
        0.0,
        0.2858458161354065
      ],
      "plane_d": 2730.893798828125,
      "bbox_min": [
        2850.0,
        -368.1968994140625,
        0.6703224182128906
      ],
      "bbox_max": [
        2867.697509765625,
        -331.8028564453125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.00011718011955963448
      ],
      "plane_d": 2849.800048828125,
      "bbox_min": [
        2849.800048828125,
        -368.1968994140625,
        -167.26806640625
      ],
      "bbox_max": [
        2850.0,
        -331.8028869628906,
        0.6703224778175354
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9440768361091614,
        -0.09337516874074936,
        0.3162277936935425
      ],
      "plane_d": -493.8998718261719,
      "bbox_min": [
        -719.397705078125,
        1180.1795654296875,
        -237.38375854492188
      ],
      "bbox_max": [
        -635.3445434570312,
        1315.3206787109375,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9805806875228882,
        0.0,
        0.1961161494255066
      ],
      "plane_d": -502.05731201171875,
      "bbox_min": [
        -619.3822631835938,
        639.4815673828125,
        0.0
      ],
      "bbox_max": [
        -500.0,
        1099.7568359375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9016833901405334,
        -0.38536393642425537,
        0.19611597061157227
      ],
      "plane_d": -118.83352661132812,
      "bbox_min": [
        -619.3822631835938,
        889.6224365234375,
        0.0
      ],
      "bbox_max": [
        -500.0,
        1099.7568359375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8510952591896057,
        -0.48700660467147827,
        0.19611585140228271
      ],
      "plane_d": 8.43548583984375,
      "bbox_min": [
        -619.3822631835938,
        978.4100341796875,
        0.0
      ],
      "bbox_max": [
        -539.185302734375,
        1099.7568359375,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.97581946849823,
        -0.09651471674442291,
        0.1961158812046051
      ],
      "plane_d": -510.5062255859375,
      "bbox_min": [
        -641.163330078125,
        639.4815673828125,
        0.0
      ],
      "bbox_max": [
        -500.0,
        1256.204833984375,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": 1992.23486328125,
      "bbox_min": [
        -1749.4398193359375,
        1099.7568359375,
        -12.840654373168945
      ],
      "bbox_max": [
        -608.0948486328125,
        2100.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8510953783988953,
        -0.4870060086250305,
        0.19611652195453644
      ],
      "plane_d": 8.434783935546875,
      "bbox_min": [
        -634.5513305664062,
        1099.7568359375,
        0.0
      ],
      "bbox_max": [
        -608.0948486328125,
        1149.4739990234375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.97581946849823,
        -0.09651471674442291,
        0.1961158812046051
      ],
      "plane_d": -510.5062255859375,
      "bbox_min": [
        -634.5513305664062,
        1126.266357421875,
        0.0
      ],
      "bbox_max": [
        -622.862060546875,
        1149.4739990234375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 690.0,
      "bbox_min": [
        -1776.46435546875,
        520.0,
        59.999996185302734
      ],
      "bbox_max": [
        784.1421508789062,
        2230.1015625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        -1530.0,
        2100.0,
        59.999996185302734
      ],
      "bbox_max": [
        -1530.0,
        2230.1015625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -550.0,
        1410.0,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1430.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        310.0,
        690.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        750.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123726963996887,
        0.35355326533317566,
        0.7071065902709961
      ],
      "plane_d": -620.3038940429688,
      "bbox_min": [
        -500.0,
        911.17822265625,
        60.0
      ],
      "bbox_max": [
        -339.506103515625,
        1367.835205078125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        -0.9238780736923218,
        -0.0
      ],
      "plane_d": 1091.50390625,
      "bbox_min": [
        -450.0,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -427.164794921875,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        -0.3826843500137329,
        -0.0
      ],
      "plane_d": 120.061767578125,
      "bbox_min": [
        -433.8530578613281,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -427.164794921875,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        0.3826843500137329,
        0.0
      ],
      "plane_d": -909.359130859375,
      "bbox_min": [
        -433.8530578613281,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -427.164794921875,
        1345.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 719.6735229492188,
      "bbox_min": [
        -500.0,
        1006.4426879882812,
        60.0
      ],
      "bbox_max": [
        -339.506103515625,
        1097.7720947265625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -296.6356201171875,
      "bbox_min": [
        -369.2159423828125,
        1006.4426879882812,
        60.0
      ],
      "bbox_max": [
        -339.506103515625,
        1075.0986328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5862517952919006,
        -0.3953181803226471,
        0.7071297764778137
      ],
      "plane_d": 160.18850708007812,
      "bbox_min": [
        -369.2159423828125,
        1045.6845703125,
        60.0
      ],
      "bbox_max": [
        -339.506103515625,
        1075.0986328125,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6123726963996887,
        0.35355326533317566,
        0.7071065902709961
      ],
      "plane_d": -796.5039672851562,
      "bbox_min": [
        -550.0,
        1077.7781982421875,
        60.0
      ],
      "bbox_max": [
        -500.0,
        1250.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123723387718201,
        -0.35355374217033386,
        0.7071067690849304
      ],
      "plane_d": 22.608856201171875,
      "bbox_min": [
        -550.0,
        1077.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -500.0,
        1158.39990234375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -550.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -530.0,
        1250.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123726963996887,
        0.35355326533317566,
        0.7071065902709961
      ],
      "plane_d": -796.5039672851562,
      "bbox_min": [
        -562.593994140625,
        1136.58642578125,
        60.00611877441406
      ],
      "bbox_max": [
        -550.0,
        1180.21337890625,
        70.91284942626953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123723387718201,
        -0.35355374217033386,
        0.7071067690849304
      ],
      "plane_d": 22.608856201171875,
      "bbox_min": [
        -562.593994140625,
        1136.58642578125,
        60.00611877441406
      ],
      "bbox_max": [
        -550.0,
        1158.39990234375,
        70.91284942626953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324553489685059,
        0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": 55.386383056640625,
      "bbox_min": [
        550.0,
        570.0,
        60.0
      ],
      "bbox_max": [
        784.1421508789062,
        650.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071071863174438,
        0.707106351852417,
        0.0
      ],
      "plane_d": 45.15484619140625,
      "bbox_min": [
        550.0,
        579.0,
        78.0
      ],
      "bbox_max": [
        675.5563354492188,
        611.698486328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 550.0,
      "bbox_min": [
        550.0,
        579.0,
        78.0
      ],
      "bbox_max": [
        550.0,
        580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -390.0,
        569.9999389648438,
        60.0
      ],
      "bbox_max": [
        -315.0,
        575.0,
        66.9697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        310.0,
        540.0,
        78.0
      ],
      "bbox_max": [
        643.85791015625,
        580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -314.9999694824219,
      "bbox_min": [
        -345.0,
        540.0,
        60.0
      ],
      "bbox_max": [
        -315.0,
        573.48486328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": -360.55517578125,
      "bbox_min": [
        -345.0,
        540.0,
        60.0
      ],
      "bbox_max": [
        -325.0,
        560.0,
        73.33333587646484
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -345.0,
      "bbox_min": [
        -345.0,
        540.0,
        60.0
      ],
      "bbox_max": [
        -345.0,
        560.0,
        73.33333587646484
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9796782732009888,
        -0.20057573914527893,
        0.0
      ],
      "plane_d": 719.490966796875,
      "bbox_min": [
        310.0,
        530.0,
        78.0
      ],
      "bbox_max": [
        625.9052734375,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        310.0,
        530.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        310.0,
        530.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -389.9999694824219,
      "bbox_min": [
        -390.0,
        530.0,
        60.0
      ],
      "bbox_max": [
        -390.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": -360.55517578125,
      "bbox_min": [
        -345.0,
        530.0,
        71.33333587646484
      ],
      "bbox_max": [
        -325.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -345.0,
      "bbox_min": [
        -345.0,
        530.0,
        71.33333587646484
      ],
      "bbox_max": [
        -345.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9796782732009888,
        -0.20057573914527893,
        0.0
      ],
      "plane_d": 719.490966796875,
      "bbox_min": [
        310.0,
        520.0,
        78.0
      ],
      "bbox_max": [
        627.95263671875,
        530.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        310.0,
        520.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        530.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        -390.0,
        520.0,
        78.0
      ],
      "bbox_max": [
        -390.0,
        530.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 286.2166748046875,
      "bbox_min": [
        -390.0,
        -422.59259033203125,
        60.0
      ],
      "bbox_max": [
        2924.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9924651980400085,
        0.12252657115459442
      ],
      "plane_d": 267.9656066894531,
      "bbox_min": [
        2867.77783203125,
        -279.87652587890625,
        60.0
      ],
      "bbox_max": [
        2924.0,
        -277.40740966796875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 554.5448608398438,
      "bbox_min": [
        650.0,
        -368.1968994140625,
        60.0
      ],
      "bbox_max": [
        2873.663330078125,
        459.9999694824219,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 290.0,
      "bbox_min": [
        290.0,
        280.0,
        60.0
      ],
      "bbox_max": [
        330.0,
        458.25,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": 199.6920928955078,
      "bbox_min": [
        320.0,
        450.0,
        60.0
      ],
      "bbox_max": [
        330.0,
        458.25,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        -390.0,
        415.0,
        60.0
      ],
      "bbox_max": [
        -390.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -345.0,
        415.0,
        60.0
      ],
      "bbox_max": [
        -315.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": 188.59808349609375,
      "bbox_min": [
        -345.0,
        430.0,
        60.0
      ],
      "bbox_max": [
        -325.0,
        453.25,
        74.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -345.0,
      "bbox_min": [
        -345.0,
        430.0,
        60.0
      ],
      "bbox_max": [
        -345.0,
        453.25,
        74.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 554.5448608398438,
      "bbox_min": [
        650.0,
        450.0,
        60.0
      ],
      "bbox_max": [
        660.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": 199.6920928955078,
      "bbox_min": [
        290.0,
        450.0,
        63.5
      ],
      "bbox_max": [
        330.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        320.0,
        457.5,
        63.5
      ],
      "bbox_max": [
        320.0,
        460.0,
        66.66666412353516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 290.0,
      "bbox_min": [
        290.0,
        450.0,
        78.0
      ],
      "bbox_max": [
        290.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        -390.0,
        450.0,
        60.0
      ],
      "bbox_max": [
        -390.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": 188.59808349609375,
      "bbox_min": [
        -345.0,
        452.5,
        73.50000762939453
      ],
      "bbox_max": [
        -325.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -345.0,
      "bbox_min": [
        -345.0,
        452.5,
        73.50000762939453
      ],
      "bbox_max": [
        -345.0,
        460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 554.5448608398438,
      "bbox_min": [
        650.0,
        459.9999694824219,
        60.0
      ],
      "bbox_max": [
        660.0,
        480.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": 199.6920928955078,
      "bbox_min": [
        320.0,
        460.0,
        66.66666412353516
      ],
      "bbox_max": [
        330.0,
        480.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        -390.0,
        460.0,
        78.0
      ],
      "bbox_max": [
        290.0,
        480.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 290.0,
      "bbox_min": [
        237.3333282470703,
        460.0,
        78.0
      ],
      "bbox_max": [
        290.0,
        480.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        -0.0,
        -0.8000000715255737
      ],
      "plane_d": 206.40000915527344,
      "bbox_min": [
        237.3333282470703,
        470.0,
        78.0
      ],
      "bbox_max": [
        240.0,
        480.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 286.2166748046875,
      "bbox_min": [
        -300.0,
        480.0,
        60.0
      ],
      "bbox_max": [
        660.0,
        500.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -300.0,
        480.0,
        78.0
      ],
      "bbox_max": [
        240.0,
        500.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 286.2166748046875,
      "bbox_min": [
        -390.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        660.0,
        520.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 554.5448608398438,
      "bbox_min": [
        480.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        660.0,
        520.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9796782732009888,
        -0.20057573914527893,
        0.0
      ],
      "plane_d": 719.490966796875,
      "bbox_min": [
        480.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 40.0,
      "bbox_min": [
        -390.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        310.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        -390.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        -390.0,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 286.2166748046875,
      "bbox_min": [
        -300.0,
        500.0,
        60.0
      ],
      "bbox_max": [
        660.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 554.5448608398438,
      "bbox_min": [
        480.0,
        500.0,
        60.0
      ],
      "bbox_max": [
        660.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        480.0,
        500.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 40.0,
      "bbox_min": [
        -300.0,
        500.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        310.0,
        500.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -300.0,
        500.0,
        78.0
      ],
      "bbox_max": [
        -300.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 40.0,
      "bbox_min": [
        -390.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        520.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        -390.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        -390.0,
        520.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9924651980400085,
        0.12252657115459442
      ],
      "plane_d": 267.9656066894531,
      "bbox_min": [
        2873.70361328125,
        -282.3456726074219,
        80.0
      ],
      "bbox_max": [
        2930.0,
        -279.87652587890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        660.0,
        -368.1968994140625,
        80.0
      ],
      "bbox_max": [
        2874.322509765625,
        450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -390.0,
        419.34783935546875,
        80.0
      ],
      "bbox_max": [
        -290.0,
        450.0,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        -390.0,
        419.34783935546875,
        80.0
      ],
      "bbox_max": [
        -355.0,
        450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 354.9999694824219,
      "bbox_min": [
        -355.0,
        419.34783935546875,
        80.0
      ],
      "bbox_max": [
        -355.0,
        450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 690.0,
      "bbox_min": [
        -1783.220458984375,
        450.0,
        80.0
      ],
      "bbox_max": [
        784.1421508789062,
        2276.72021484375,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        -1530.0,
        2100.0,
        80.0
      ],
      "bbox_max": [
        -1530.0,
        2276.72021484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        0.16439898312091827
      ],
      "plane_d": 1380.9515380859375,
      "bbox_min": [
        -550.0,
        690.0,
        80.0
      ],
      "bbox_max": [
        360.0,
        1633.90625,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -550.0,
        1413.333251953125,
        80.0
      ],
      "bbox_max": [
        150.21173095703125,
        1633.90625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        145.1197509765625,
        1626.2855224609375,
        95.8948974609375
      ],
      "bbox_max": [
        150.21173095703125,
        1633.90625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        -550.0,
        1413.3333740234375,
        80.0
      ],
      "bbox_max": [
        -550.0,
        1430.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        -550.0,
        690.0,
        80.0
      ],
      "bbox_max": [
        360.0,
        1416.666748046875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555703639984131,
        0.8314695358276367,
        -1.0388886195755731e-08
      ],
      "plane_d": -692.5145874023438,
      "bbox_min": [
        15.056183815002441,
        690.0,
        80.0
      ],
      "bbox_max": [
        360.0,
        866.391357421875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660256266593933,
        0.4999997317790985,
        0.0
      ],
      "plane_d": -797.2359619140625,
      "bbox_min": [
        -500.0,
        850.55029296875,
        80.0
      ],
      "bbox_max": [
        -339.5,
        1097.7781982421875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 719.6735229492188,
      "bbox_min": [
        -500.0,
        1051.7982177734375,
        80.0
      ],
      "bbox_max": [
        -339.5,
        1097.7781982421875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8289903998374939,
        -0.5592629313468933,
        0.0
      ],
      "plane_d": 306.7905578613281,
      "bbox_min": [
        -355.21795654296875,
        1051.7982177734375,
        80.0
      ],
      "bbox_max": [
        -339.5,
        1075.0986328125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5862517952919006,
        -0.3953181803226471,
        0.7071297764778137
      ],
      "plane_d": 160.18850708007812,
      "bbox_min": [
        -355.21795654296875,
        1051.7982177734375,
        80.0
      ],
      "bbox_max": [
        -339.5,
        1075.0986328125,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660252094268799,
        -0.5000004768371582,
        0.0
      ],
      "plane_d": 111.97991943359375,
      "bbox_min": [
        -539.5034790039062,
        1097.7720947265625,
        80.0
      ],
      "bbox_max": [
        -500.0,
        1158.39990234375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123723387718201,
        -0.35355374217033386,
        0.7071067690849304
      ],
      "plane_d": 22.608856201171875,
      "bbox_min": [
        -539.5034790039062,
        1097.7720947265625,
        80.0
      ],
      "bbox_max": [
        -504.4964904785156,
        1158.39990234375,
        80.00611877441406
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6123726963996887,
        0.35355326533317566,
        0.7071065902709961
      ],
      "plane_d": -796.5039672851562,
      "bbox_min": [
        -550.0,
        1158.3936767578125,
        80.0
      ],
      "bbox_max": [
        -504.5,
        1250.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -550.0,
        1250.0,
        80.0
      ],
      "bbox_max": [
        -533.3333740234375,
        1250.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        -390.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        784.1421508789062,
        690.0,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        -200.0,
        600.0,
        80.0
      ],
      "bbox_max": [
        784.1421508789062,
        690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.92391967773438,
      "bbox_min": [
        744.1421508789062,
        600.0,
        80.0
      ],
      "bbox_max": [
        784.1421508789062,
        640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -200.0,
      "bbox_min": [
        -200.0,
        600.0,
        80.0
      ],
      "bbox_max": [
        -200.0,
        690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 580.0,
      "bbox_min": [
        -390.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        744.1421508789062,
        600.0,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        -390.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        660.0,
        510.0,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        660.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        660.0,
        510.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -390.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        -290.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        -390.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        -355.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        -0.0,
        -0.8000000715255737
      ],
      "plane_d": 206.40000915527344,
      "bbox_min": [
        -310.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        240.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -310.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -290.0,
        462.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -290.0,
      "bbox_min": [
        -290.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -290.0,
        462.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        660.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        660.0,
        515.8578491210938,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 528.0,
      "bbox_min": [
        -290.0,
        528.0,
        80.0
      ],
      "bbox_max": [
        -285.0,
        528.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 530.0,
      "bbox_min": [
        -315.0,
        528.0,
        80.0
      ],
      "bbox_max": [
        -305.0,
        530.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 528.0,
      "bbox_min": [
        -310.0,
        528.0,
        80.0
      ],
      "bbox_max": [
        -305.0,
        530.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -310.0,
        528.0,
        80.0
      ],
      "bbox_max": [
        -310.0,
        530.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -389.9999694824219,
      "bbox_min": [
        -390.0,
        530.0,
        80.0
      ],
      "bbox_max": [
        -355.0,
        570.6521606445312,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -390.0,
        530.0,
        80.0
      ],
      "bbox_max": [
        -355.0,
        570.6521606445312,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 530.0,
      "bbox_min": [
        -390.0,
        530.0,
        80.0
      ],
      "bbox_max": [
        -355.0,
        530.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1550.0,
        1470.0,
        500.0
      ],
      "bbox_max": [
        2011.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1910.0,
        1829.8446044921875,
        980.0
      ],
      "bbox_max": [
        2011.0,
        1940.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588171064853668,
        -0.9659263491630554,
        6.86823625528632e-07
      ],
      "plane_d": 2263.1865234375,
      "bbox_min": [
        1840.0001220703125,
        1837.9423828125,
        1060.0
      ],
      "bbox_max": [
        1885.000244140625,
        1850.0001220703125,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1668.9998779296875,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1659.9998779296875,
        1654.800048828125,
        1059.6480712890625
      ],
      "bbox_max": [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1704.19970703125,
        1829.844482421875,
        1059.6480712890625
      ],
      "bbox_max": [
        1704.355224609375,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9255444407463074,
        0.37863919138908386,
        0.0
      ],
      "plane_d": 2984.085205078125,
      "bbox_min": [
        3020.0,
        -565.3212890625,
        400.00018310546875
      ],
      "bbox_max": [
        3065.0,
        -432.6787109375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3867550790309906,
        -0.9221825003623962,
        0.0
      ],
      "plane_d": 664.074951171875,
      "bbox_min": [
        3043.431396484375,
        -565.3212890625,
        478.10467529296875
      ],
      "bbox_max": [
        3065.0,
        -432.6787109375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3867550790309906,
        0.9221825003623962,
        0.0
      ],
      "plane_d": 1584.4129638671875,
      "bbox_min": [
        3043.431396484375,
        -441.724365234375,
        478.10467529296875
      ],
      "bbox_max": [
        3065.0,
        -432.6787109375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9255444407463074,
        0.37863919138908386,
        0.0
      ],
      "plane_d": 2643.31005859375,
      "bbox_min": [
        3020.0,
        334.6787109375,
        400.00018310546875
      ],
      "bbox_max": [
        3065.0,
        467.3212890625,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3867550790309906,
        0.9221825003623962,
        0.0
      ],
      "plane_d": 754.44873046875,
      "bbox_min": [
        3043.431396484375,
        334.6787109375,
        478.10467529296875
      ],
      "bbox_max": [
        3065.0,
        467.3212890625,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9255444407463074,
        -0.37863919138908386,
        0.0
      ],
      "plane_d": 2719.795166015625,
      "bbox_min": [
        3020.0,
        -265.3212890625,
        400.00018310546875
      ],
      "bbox_max": [
        3065.0,
        -199.0,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3867550790309906,
        -0.9221825003623962,
        0.0
      ],
      "plane_d": 940.729736328125,
      "bbox_min": [
        3043.431396484375,
        -265.3212890625,
        478.10467529296875
      ],
      "bbox_max": [
        3065.0,
        -256.275634765625,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1549.9996337890625,
        1270.0,
        173.62835693359375
      ],
      "bbox_max": [
        1630.0001220703125,
        1400.0,
        784.9600830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000008344650269,
        -0.4999992549419403,
        0.7071068286895752
      ],
      "plane_d": 959.9495849609375,
      "bbox_min": [
        1549.9996337890625,
        1270.0,
        636.4673461914062
      ],
      "bbox_max": [
        1630.0001220703125,
        1400.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9251258373260498,
        0.37508293986320496,
        -0.05877852067351341
      ],
      "plane_d": 1782.635498046875,
      "bbox_min": [
        -2712.474609375,
        -325.4127502441406,
        100.0
      ],
      "bbox_max": [
        1549.999755859375,
        2509.814208984375,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        -1900.0,
        1330.0,
        100.0
      ],
      "bbox_max": [
        -1850.0,
        2120.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 1831.0491943359375,
      "bbox_min": [
        -1860.0,
        2100.0,
        200.0
      ],
      "bbox_max": [
        -1850.0,
        2120.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 1831.0491943359375,
      "bbox_min": [
        -1900.0,
        1330.0,
        185.0
      ],
      "bbox_max": [
        -1850.0,
        1950.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1950.0,
      "bbox_min": [
        -1851.7857666015625,
        1750.0,
        199.99978637695312
      ],
      "bbox_max": [
        -1850.0,
        1950.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1851.7857666015625,
        1750.0,
        199.99978637695312
      ],
      "bbox_max": [
        -1850.0,
        1750.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1460.0,
        1330.0,
        410.0
      ],
      "bbox_max": [
        1530.0,
        1400.0,
        714.2493896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1075.0,
        1330.0,
        515.0
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112057685852051,
        -0.4043944478034973,
        0.07854446023702621
      ],
      "plane_d": 2450.442138671875,
      "bbox_min": [
        -1764.8831787109375,
        2298.338623046875,
        130.0
      ],
      "bbox_max": [
        -1661.9405517578125,
        2341.45556640625,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4056476056575775,
        -0.9140295386314392,
        -0.00014437820937018842
      ],
      "plane_d": 1424.3009033203125,
      "bbox_min": [
        -1764.8831787109375,
        2306.168212890625,
        426.8799133300781
      ],
      "bbox_max": [
        -1688.00927734375,
        2341.45556640625,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140291213989258,
        -0.40564870834350586,
        0.0
      ],
      "plane_d": 2479.280029296875,
      "bbox_min": [
        -1680.0238037109375,
        2326.370849609375,
        460.0
      ],
      "bbox_max": [
        -1676.675537109375,
        2333.915283203125,
        475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.867123544216156,
        -0.38483482599258423,
        0.3162263035774231
      ],
      "plane_d": 2190.465087890625,
      "bbox_min": [
        -1696.6204833984375,
        2325.9521484375,
        531.0
      ],
      "bbox_max": [
        -1684.9156494140625,
        2340.0,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8175334930419922,
        -0.3628236651420593,
        -0.447211354970932
      ],
      "plane_d": 2468.423828125,
      "bbox_min": [
        -1696.6204833984375,
        2325.9521484375,
        531.0
      ],
      "bbox_max": [
        -1684.9156494140625,
        2340.0,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140291213989258,
        -0.40564870834350586,
        0.0
      ],
      "plane_d": 2494.280029296875,
      "bbox_min": [
        -1699.8333740234375,
        2318.712646484375,
        460.0
      ],
      "bbox_max": [
        -1679.344970703125,
        2329.5244140625,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140291213989258,
        -0.40564870834350586,
        0.0
      ],
      "plane_d": 2479.280029296875,
      "bbox_min": [
        -1680.0238037109375,
        2326.370849609375,
        460.0
      ],
      "bbox_max": [
        -1679.344970703125,
        2327.900390625,
        475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.867123544216156,
        -0.38483482599258423,
        0.3162263035774231
      ],
      "plane_d": 2190.465087890625,
      "bbox_min": [
        -1699.8333740234375,
        2318.712646484375,
        531.0
      ],
      "bbox_max": [
        -1689.564697265625,
        2329.5244140625,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8175334930419922,
        -0.3628236651420593,
        -0.447211354970932
      ],
      "plane_d": 2468.423828125,
      "bbox_min": [
        -1699.8333740234375,
        2318.712646484375,
        531.0
      ],
      "bbox_max": [
        -1689.564697265625,
        2329.5244140625,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5070119500160217,
        -0.2250133454799652,
        0.8320504426956177
      ],
      "plane_d": 980.0325927734375,
      "bbox_min": [
        -1699.8333740234375,
        2312.6279296875,
        460.0
      ],
      "bbox_max": [
        -1680.0235595703125,
        2326.37158203125,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9140291213989258,
        -0.40564870834350586,
        0.0
      ],
      "plane_d": 2479.280029296875,
      "bbox_min": [
        -1686.1229248046875,
        2312.6279296875,
        460.0
      ],
      "bbox_max": [
        -1680.0235595703125,
        2326.37158203125,
        475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.867123544216156,
        -0.38483482599258423,
        0.3162263035774231
      ],
      "plane_d": 2190.465087890625,
      "bbox_min": [
        -1699.8333740234375,
        2316.68115234375,
        531.0
      ],
      "bbox_max": [
        -1693.22998046875,
        2321.265869140625,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32252857089042664,
        -0.8342534899711609,
        -0.44720956683158875
      ],
      "plane_d": 2720.107421875,
      "bbox_min": [
        -1718.2431640625,
        2309.33740234375,
        531.0
      ],
      "bbox_max": [
        -1695.2646484375,
        2318.712646484375,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.867123544216156,
        -0.38483482599258423,
        0.3162263035774231
      ],
      "plane_d": 2190.465087890625,
      "bbox_min": [
        -1699.8333740234375,
        2314.794677734375,
        531.0
      ],
      "bbox_max": [
        -1695.2646484375,
        2318.712646484375,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8175334930419922,
        -0.3628236651420593,
        -0.447211354970932
      ],
      "plane_d": 2468.423828125,
      "bbox_min": [
        -1699.8333740234375,
        2314.794677734375,
        531.0
      ],
      "bbox_max": [
        -1695.2646484375,
        2318.712646484375,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4056476056575775,
        -0.9140295386314392,
        -0.00014437820937018842
      ],
      "plane_d": 1424.3009033203125,
      "bbox_min": [
        -1775.324462890625,
        2325.952392578125,
        429.5688781738281
      ],
      "bbox_max": [
        -1755.379638671875,
        2346.084716796875,
        556.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8671222925186157,
        -0.38483428955078125,
        0.31623005867004395
      ],
      "plane_d": -802.846435546875,
      "bbox_min": [
        -1761.6485595703125,
        2339.98095703125,
        531.0
      ],
      "bbox_max": [
        -1761.60546875,
        2340.0,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8175309300422668,
        -0.3628225326538086,
        -0.4472169280052185
      ],
      "plane_d": -353.697021484375,
      "bbox_min": [
        -1761.6396484375,
        2339.98583984375,
        531.0
      ],
      "bbox_max": [
        -1761.6077880859375,
        2340.0,
        531.0468139648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8671222925186157,
        -0.38483428955078125,
        0.31623005867004395
      ],
      "plane_d": -802.846435546875,
      "bbox_min": [
        -1767.0843505859375,
        2325.952392578125,
        531.0
      ],
      "bbox_max": [
        -1755.379638671875,
        2340.0,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8175309300422668,
        -0.3628225326538086,
        -0.4472169280052185
      ],
      "plane_d": -353.697021484375,
      "bbox_min": [
        -1767.0843505859375,
        2325.952392578125,
        531.0
      ],
      "bbox_max": [
        -1755.379638671875,
        2340.0,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8671222925186157,
        -0.38483428955078125,
        0.31623005867004395
      ],
      "plane_d": -802.846435546875,
      "bbox_min": [
        -1762.4354248046875,
        2318.712646484375,
        531.0
      ],
      "bbox_max": [
        -1752.1666259765625,
        2329.52490234375,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8175309300422668,
        -0.3628225326538086,
        -0.4472169280052185
      ],
      "plane_d": -353.697021484375,
      "bbox_min": [
        -1762.4354248046875,
        2318.712646484375,
        531.0
      ],
      "bbox_max": [
        -1752.1666259765625,
        2329.52490234375,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34209343791007996,
        -0.884858250617981,
        0.31622451543807983
      ],
      "plane_d": 2457.4130859375,
      "bbox_min": [
        -1726.0,
        2305.916015625,
        531.0
      ],
      "bbox_max": [
        -1710.2176513671875,
        2312.651123046875,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3605971038341522,
        -0.9327216744422913,
        0.0
      ],
      "plane_d": 1515.887451171875,
      "bbox_min": [
        -1757.5755615234375,
        2294.605712890625,
        460.0
      ],
      "bbox_max": [
        -1731.408935546875,
        2304.721923828125,
        475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3225288689136505,
        -0.834254264831543,
        -0.44720810651779175
      ],
      "plane_d": 1606.739013671875,
      "bbox_min": [
        -1758.769775390625,
        2303.931884765625,
        531.0
      ],
      "bbox_max": [
        -1726.0,
        2321.265380859375,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8671222925186157,
        -0.38483428955078125,
        0.31623005867004395
      ],
      "plane_d": -802.846435546875,
      "bbox_min": [
        -1758.769775390625,
        2314.794677734375,
        531.0
      ],
      "bbox_max": [
        -1752.1666259765625,
        2321.265380859375,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8175309300422668,
        -0.3628225326538086,
        -0.4472169280052185
      ],
      "plane_d": -353.697021484375,
      "bbox_min": [
        -1758.769775390625,
        2314.794677734375,
        531.0
      ],
      "bbox_max": [
        -1752.1666259765625,
        2321.265380859375,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3420935571193695,
        -0.8848586082458496,
        0.3162234425544739
      ],
      "plane_d": 1276.5076904296875,
      "bbox_min": [
        -1727.800537109375,
        2303.23583984375,
        531.0
      ],
      "bbox_max": [
        -1719.0673828125,
        2308.596435546875,
        556.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32252857089042664,
        -0.8342534899711609,
        -0.44720956683158875
      ],
      "plane_d": 2720.107421875,
      "bbox_min": [
        -1727.80029296875,
        2303.23583984375,
        531.0
      ],
      "bbox_max": [
        -1719.0673828125,
        2308.596435546875,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3225288689136505,
        -0.834254264831543,
        -0.44720810651779175
      ],
      "plane_d": 1606.739013671875,
      "bbox_min": [
        -1727.80029296875,
        2303.23583984375,
        531.0
      ],
      "bbox_max": [
        -1726.0,
        2308.596435546875,
        541.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1840.0,
      "bbox_min": [
        -1850.0,
        1750.0,
        185.0
      ],
      "bbox_max": [
        -1820.0,
        2000.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1950.0,
      "bbox_min": [
        -1840.0,
        1750.0,
        185.0
      ],
      "bbox_max": [
        -1820.0,
        1950.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1840.0,
        1750.0,
        185.0
      ],
      "bbox_max": [
        -1820.0,
        1750.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8682432174682617,
        0.0,
        -0.49613896012306213
      ],
      "plane_d": 1671.9884033203125,
      "bbox_min": [
        -1840.0,
        1750.0,
        150.0
      ],
      "bbox_max": [
        -1820.0,
        2000.0,
        185.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        -550.0,
        1416.6666259765625,
        100.0
      ],
      "bbox_max": [
        175.019775390625,
        1671.0340576171875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -550.0,
        1416.6666259765625,
        100.0
      ],
      "bbox_max": [
        -300.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        -550.0,
        1416.666748046875,
        100.0
      ],
      "bbox_max": [
        -550.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        -550.0,
        1330.0,
        100.0
      ],
      "bbox_max": [
        -550.0,
        1420.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        145.1197509765625,
        1330.0,
        120.0
      ],
      "bbox_max": [
        450.0,
        1708.161865234375,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        145.1197509765625,
        1626.2855224609375,
        120.0
      ],
      "bbox_max": [
        199.82778930664062,
        1708.161865234375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        270.0,
        1330.0,
        180.0
      ],
      "bbox_max": [
        270.0,
        1415.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        -550.0,
        820.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1330.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1300.0,
        101.15074157714844
      ],
      "bbox_max": [
        1030.0,
        1330.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9804636240005493,
        0.19670069217681885,
        0.0
      ],
      "plane_d": 48.41522216796875,
      "bbox_min": [
        -160.0,
        820.0,
        100.0
      ],
      "bbox_max": [
        254.03262329101562,
        1158.39990234375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        221.82235717773438,
        859.5471801757812,
        120.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314693570137024,
        0.5555705428123474,
        0.0
      ],
      "plane_d": -430.4105224609375,
      "bbox_min": [
        15.056182861328125,
        842.9404907226562,
        100.0
      ],
      "bbox_max": [
        113.52975463867188,
        967.471923828125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555703639984131,
        0.8314695358276367,
        -1.0388886195755731e-08
      ],
      "plane_d": -692.5145874023438,
      "bbox_min": [
        15.056182861328125,
        842.9404907226562,
        100.0
      ],
      "bbox_max": [
        113.52975463867188,
        967.471923828125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314692974090576,
        0.5555707216262817,
        0.0
      ],
      "plane_d": -370.41070556640625,
      "bbox_min": [
        -160.0,
        820.0,
        120.0
      ],
      "bbox_max": [
        226.98284912109375,
        1158.39990234375,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314697742462158,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -303.1000061035156,
      "bbox_min": [
        183.3708953857422,
        820.0,
        120.0
      ],
      "bbox_max": [
        226.98284912109375,
        885.2699584960938,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660252094268799,
        -0.5000004768371582,
        0.0
      ],
      "plane_d": 674.0302734375,
      "bbox_min": [
        -160.0,
        842.9404907226562,
        120.0
      ],
      "bbox_max": [
        120.0,
        1158.39990234375,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555703639984131,
        0.8314694762229919,
        0.0
      ],
      "plane_d": -692.5145263671875,
      "bbox_min": [
        15.056182861328125,
        842.9404907226562,
        120.0
      ],
      "bbox_max": [
        107.05952453613281,
        934.9437866210938,
        130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314697742462158,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -303.1000061035156,
      "bbox_min": [
        -160.0,
        820.0,
        130.0
      ],
      "bbox_max": [
        226.98284912109375,
        1158.39990234375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        195.3977813720703,
        820.0,
        130.0
      ],
      "bbox_max": [
        221.82235717773438,
        859.5471801757812,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19240783154964447,
        -0.9813150763511658,
        0.0
      ],
      "plane_d": 814.2987670898438,
      "bbox_min": [
        -160.0,
        820.0,
        130.0
      ],
      "bbox_max": [
        120.0,
        1158.39990234375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.7781982421875,
      "bbox_min": [
        -160.0,
        1097.7781982421875,
        130.0
      ],
      "bbox_max": [
        -144.5,
        1097.7781982421875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314693570137024,
        0.555570662021637,
        0.0
      ],
      "plane_d": -430.41064453125,
      "bbox_min": [
        -100.0,
        830.0,
        130.0
      ],
      "bbox_max": [
        107.05952453613281,
        934.9437866210938,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.19509048759937286,
        -0.9807852506637573,
        0.0
      ],
      "plane_d": 823.8062744140625,
      "bbox_min": [
        -100.0,
        830.0,
        130.0
      ],
      "bbox_max": [
        15.056182861328125,
        842.9404907226562,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        -100.0,
        830.0,
        130.0
      ],
      "bbox_max": [
        -50.0,
        830.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        -0.4999997317790985,
        0.0
      ],
      "plane_d": 675.9923706054688,
      "bbox_min": [
        -339.5,
        850.556396484375,
        120.00611877441406
      ],
      "bbox_max": [
        -160.0,
        1097.7781982421875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.7781982421875,
      "bbox_min": [
        -339.5,
        850.556396484375,
        120.00611877441406
      ],
      "bbox_max": [
        -160.0,
        1097.7781982421875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        -550.0,
        1175.720458984375,
        100.0
      ],
      "bbox_max": [
        -504.5,
        1330.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660256266593933,
        0.4999997317790985,
        0.0
      ],
      "plane_d": -1046.42041015625,
      "bbox_min": [
        -550.0,
        1175.720458984375,
        100.0
      ],
      "bbox_max": [
        -504.5,
        1250.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -550.0,
        1250.0,
        100.0
      ],
      "bbox_max": [
        -536.6666870117188,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660245537757874,
        -0.5000016093254089,
        0.0
      ],
      "plane_d": 925.178466796875,
      "bbox_min": [
        -434.5,
        1097.7781982421875,
        120.0
      ],
      "bbox_max": [
        -424.5,
        1115.0986328125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 850.556396484375,
      "bbox_min": [
        -359.5,
        850.556396484375,
        120.00611877441406
      ],
      "bbox_max": [
        -339.5,
        850.556396484375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8289903998374939,
        -0.5592629313468933,
        0.0
      ],
      "plane_d": 306.7905578613281,
      "bbox_min": [
        -500.0,
        820.0,
        100.0
      ],
      "bbox_max": [
        -339.5,
        1075.0986328125,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5000008344650269,
        -0.4999992549419403,
        0.7071068286895752
      ],
      "plane_d": 959.9495849609375,
      "bbox_min": [
        1400.0,
        1270.0,
        410.0
      ],
      "bbox_max": [
        1549.9996337890625,
        1330.0,
        678.893798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 47.37615966796875,
      "bbox_min": [
        1042.949951171875,
        962.9500122070312,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40248748660087585,
        0.40248337388038635,
        0.8221988081932068
      ],
      "plane_d": -579.0397338867188,
      "bbox_min": [
        1135.85791015625,
        964.5679321289062,
        780.0
      ],
      "bbox_max": [
        1173.0,
        994.14208984375,
        806.125732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1496.945068359375,
      "bbox_min": [
        1042.949951171875,
        975.9603881835938,
        750.0
      ],
      "bbox_max": [
        1061.14208984375,
        1074.050048828125,
        796.2268676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707107663154602,
        -0.7071058750152588,
        0.0
      ],
      "plane_d": 1496.9451904296875,
      "bbox_min": [
        1152.43212890625,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        964.9143676757812,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40248748660087585,
        0.40248337388038635,
        0.8221988081932068
      ],
      "plane_d": -579.0397338867188,
      "bbox_min": [
        1152.43212890625,
        957.0,
        796.2269287109375
      ],
      "bbox_max": [
        1173.0,
        964.9143676757812,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1044.914306640625,
        1080.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1496.945068359375,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1044.56787109375,
        1080.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7077255845069885,
        0.7064874172210693,
        0.0
      ],
      "plane_d": 48.61865234375,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1044.5675048828125,
        977.5806884765625,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        270.0,
        1300.0,
        140.0
      ],
      "bbox_max": [
        1360.0,
        1330.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1075.0,
        1310.0,
        190.0
      ],
      "bbox_max": [
        1360.0,
        1330.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4999999701976776,
        -0.5000001788139343,
        0.7071067094802856
      ],
      "plane_d": 959.94970703125,
      "bbox_min": [
        1350.0,
        1320.0,
        530.4015502929688
      ],
      "bbox_max": [
        1360.0,
        1330.0,
        544.543701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        1075.0,
        1310.0,
        515.0
      ],
      "bbox_max": [
        1175.0,
        1330.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        270.0,
        1310.0,
        180.0
      ],
      "bbox_max": [
        270.0,
        1330.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        647.2877197265625,
        1185.6285400390625,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        582.7122802734375,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        602.2073974609375,
        1185.6285400390625,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        210.0,
        1198.322265625,
        140.0
      ],
      "bbox_max": [
        260.0,
        1240.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        210.0,
        1198.322265625,
        140.0
      ],
      "bbox_max": [
        260.0,
        1240.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        -0.0,
        -0.9284767508506775
      ],
      "plane_d": 272.97216796875,
      "bbox_min": [
        210.0,
        1198.322265625,
        190.0
      ],
      "bbox_max": [
        260.0,
        1240.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -254.4998779296875,
        1097.7781982421875,
        300.0
      ],
      "bbox_max": [
        -214.49998474121094,
        1115.0986328125,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        -254.4998779296875,
        1097.7781982421875,
        200.0
      ],
      "bbox_max": [
        -214.49998474121094,
        1115.0986328125,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        225.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -309.5,
        971.800048828125,
        225.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1045.8167724609375,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660241961479187,
        -0.5000022649765015,
        0.0
      ],
      "plane_d": 363.1294250488281,
      "bbox_min": [
        -214.49998474121094,
        1045.8167724609375,
        210.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1097.7781982421875,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.7781982421875,
      "bbox_min": [
        -146.7665557861328,
        1097.7781982421875,
        140.0
      ],
      "bbox_max": [
        -144.5,
        1097.7781982421875,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        -160.0,
        820.0,
        140.0
      ],
      "bbox_max": [
        835.0,
        1217.30712890625,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        360.0,
        980.0,
        190.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        254.03262329101562,
        980.0,
        190.0
      ],
      "bbox_max": [
        260.0,
        980.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        210.0,
        841.853759765625,
        350.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        210.0,
        841.853759765625,
        350.0
      ],
      "bbox_max": [
        236.40264892578125,
        881.3681640625,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903981924057,
        0.0
      ],
      "plane_d": 59.91377258300781,
      "bbox_min": [
        210.0,
        820.0,
        210.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        300.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        224.19573974609375,
        820.0,
        280.0
      ],
      "bbox_max": [
        241.07882690429688,
        881.3681640625,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        210.0,
        820.0,
        210.0
      ],
      "bbox_max": [
        236.40264892578125,
        881.3681640625,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        210.0,
        841.853759765625,
        280.0
      ],
      "bbox_max": [
        236.40264892578125,
        881.3681640625,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        210.0,
        841.853759765625,
        210.0
      ],
      "bbox_max": [
        236.40264892578125,
        881.3681640625,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -159.99998474121094,
      "bbox_min": [
        224.19573974609375,
        820.0,
        160.0
      ],
      "bbox_max": [
        241.07882690429688,
        881.3681640625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -159.99998474121094,
      "bbox_min": [
        210.0,
        820.0,
        140.0
      ],
      "bbox_max": [
        236.40264892578125,
        881.3681640625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        210.0,
        841.853759765625,
        140.0
      ],
      "bbox_max": [
        236.40264892578125,
        881.3681640625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314693570137024,
        0.5555705428123474,
        0.0
      ],
      "plane_d": -430.4105224609375,
      "bbox_min": [
        -150.0,
        879.7918701171875,
        140.0
      ],
      "bbox_max": [
        107.05952453613281,
        1040.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -150.0,
        1000.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        1040.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        -150.0,
        1000.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        1000.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        202.07957458496094,
        830.0,
        160.0
      ],
      "bbox_max": [
        210.0,
        841.853759765625,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        202.07957458496094,
        830.0,
        350.0
      ],
      "bbox_max": [
        210.0,
        841.853759765625,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        202.07957458496094,
        830.0,
        160.0
      ],
      "bbox_max": [
        210.0,
        841.853759765625,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -159.99998474121094,
      "bbox_min": [
        202.07957458496094,
        830.0,
        160.0
      ],
      "bbox_max": [
        210.0,
        841.853759765625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        195.3977813720703,
        820.0,
        160.0
      ],
      "bbox_max": [
        210.0,
        830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        195.3977813720703,
        820.0,
        350.0
      ],
      "bbox_max": [
        210.0,
        830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -159.99998474121094,
      "bbox_min": [
        195.3977813720703,
        820.0,
        160.0
      ],
      "bbox_max": [
        210.0,
        830.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        195.3977813720703,
        820.0,
        210.0
      ],
      "bbox_max": [
        210.0,
        830.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -359.5000305175781,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -339.5,
        1006.441162109375,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        -359.5000305175781,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -339.5,
        1006.441162109375,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660256266593933,
        0.4999997317790985,
        0.0
      ],
      "plane_d": -1046.42041015625,
      "bbox_min": [
        -538.36669921875,
        1160.3629150390625,
        140.0
      ],
      "bbox_max": [
        -529.5,
        1175.720458984375,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -434.5,
        1097.7781982421875,
        200.0
      ],
      "bbox_max": [
        -394.5001220703125,
        1115.0986328125,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8544729351997375,
        -0.5194959044456482,
        -0.0
      ],
      "plane_d": 146.394775390625,
      "bbox_min": [
        -464.5001220703125,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -359.5000305175781,
        1097.7781982421875,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660242557525635,
        0.5000020861625671,
        0.0
      ],
      "plane_d": -925.178955078125,
      "bbox_min": [
        -464.5001220703125,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -359.5000305175781,
        1097.7781982421875,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8544729351997375,
        -0.5194959044456482,
        -0.0
      ],
      "plane_d": 146.394775390625,
      "bbox_min": [
        -464.5001220703125,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -359.5000305175781,
        1097.7781982421875,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660242557525635,
        0.5000020861625671,
        0.0
      ],
      "plane_d": -925.178955078125,
      "bbox_min": [
        -464.5001220703125,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -359.5000305175781,
        1097.7781982421875,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 971.800048828125,
      "bbox_min": [
        -419.5,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -359.5000305175781,
        971.800048828125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.7781982421875,
      "bbox_min": [
        -539.5,
        1097.7781982421875,
        140.0
      ],
      "bbox_max": [
        -502.2333984375,
        1160.3629150390625,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660256266593933,
        0.4999997317790985,
        0.0
      ],
      "plane_d": -1046.42041015625,
      "bbox_min": [
        -539.5,
        1158.39990234375,
        140.0
      ],
      "bbox_max": [
        -538.36669921875,
        1160.3629150390625,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555700659751892,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -555.204833984375,
      "bbox_min": [
        -50.0,
        690.0,
        100.0
      ],
      "bbox_max": [
        360.0,
        820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555700063705444,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -565.204833984375,
      "bbox_min": [
        -50.0,
        723.0171508789062,
        120.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555704236030579,
        0.8314695358276367,
        0.0
      ],
      "plane_d": -632.5145874023438,
      "bbox_min": [
        38.46703338623047,
        786.4217529296875,
        120.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314697742462158,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -303.1000061035156,
      "bbox_min": [
        161.99351501464844,
        788.0064697265625,
        120.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        183.72076416015625,
        802.5241088867188,
        120.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314697742462158,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -303.1000061035156,
      "bbox_min": [
        161.99351501464844,
        788.0064697265625,
        130.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        183.72076416015625,
        802.5241088867188,
        130.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        -1690.0,
        520.0,
        100.0
      ],
      "bbox_max": [
        1290.0,
        690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        840.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        640.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        -200.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        600.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        840.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        600.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -314.9999694824219,
      "bbox_min": [
        -355.0,
        530.0,
        100.0
      ],
      "bbox_max": [
        -290.0,
        566.3043212890625,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -290.0,
      "bbox_min": [
        -305.0,
        535.0,
        100.0
      ],
      "bbox_max": [
        -290.0,
        555.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 555.0,
      "bbox_min": [
        -305.0,
        555.0,
        100.0
      ],
      "bbox_max": [
        -290.0,
        555.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        -355.0,
        530.0,
        100.0
      ],
      "bbox_max": [
        -355.0,
        566.3043212890625,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        -1655.0,
        530.0,
        100.0
      ],
      "bbox_max": [
        -1655.0,
        566.3043212890625,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        -1680.0,
        528.0,
        100.0
      ],
      "bbox_max": [
        -1660.0,
        530.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 427.5362548828125,
      "bbox_min": [
        -310.0,
        528.0,
        100.0
      ],
      "bbox_max": [
        -285.0,
        530.0,
        104.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        -1655.0,
        530.0,
        116.0
      ],
      "bbox_max": [
        -390.0,
        565.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 530.0,
      "bbox_min": [
        -315.0,
        530.0,
        116.0
      ],
      "bbox_max": [
        -280.0,
        555.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -290.0,
      "bbox_min": [
        -305.0,
        535.0,
        116.0
      ],
      "bbox_max": [
        -290.0,
        555.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 555.0,
      "bbox_min": [
        -305.0,
        555.0,
        116.0
      ],
      "bbox_max": [
        -290.0,
        555.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        360.0,
        520.0,
        140.0
      ],
      "bbox_max": [
        1290.0,
        820.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1290.0,
      "bbox_min": [
        840.0,
        520.0,
        140.0
      ],
      "bbox_max": [
        1290.0,
        640.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071070075035095,
        -0.7071065902709961,
        0.0
      ],
      "plane_d": 820.2513427734375,
      "bbox_min": [
        360.0,
        749.9893188476562,
        140.0
      ],
      "bbox_max": [
        410.0213928222656,
        800.0107421875,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555700659751892,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -555.204833984375,
      "bbox_min": [
        68.63186645507812,
        713.5973510742188,
        350.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        169.20310974121094,
        780.796875,
        350.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555700659751892,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -555.204833984375,
      "bbox_min": [
        68.63186645507812,
        713.5973510742188,
        280.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555700659751892,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -555.204833984375,
      "bbox_min": [
        68.63186645507812,
        713.5973510742188,
        210.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.0999755859375,
      "bbox_min": [
        169.20310974121094,
        780.796875,
        210.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        68.63186645507812,
        650.0,
        140.0
      ],
      "bbox_max": [
        254.0325927734375,
        820.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5555700659751892,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -555.204833984375,
      "bbox_min": [
        68.63186645507812,
        713.5973510742188,
        140.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -293.1000061035156,
      "bbox_min": [
        169.20310974121094,
        780.796875,
        140.0
      ],
      "bbox_max": [
        195.3977813720703,
        820.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 555.0,
      "bbox_min": [
        -390.0,
        555.0,
        140.0
      ],
      "bbox_max": [
        -290.0,
        565.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1560.0,
      "bbox_min": [
        -1680.0,
        520.0,
        140.0
      ],
      "bbox_max": [
        -1560.0,
        565.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        -1680.0,
        535.0,
        140.0
      ],
      "bbox_max": [
        -1580.0,
        565.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        -1580.0,
        555.0,
        140.0
      ],
      "bbox_max": [
        -1580.0,
        565.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 555.0,
      "bbox_min": [
        -1580.0,
        550.0,
        145.0
      ],
      "bbox_max": [
        -290.0,
        563.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -409.9999694824219,
      "bbox_min": [
        -1560.0,
        550.0,
        145.0
      ],
      "bbox_max": [
        -290.0,
        555.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        -1685.0,
        535.0,
        145.0
      ],
      "bbox_max": [
        -285.0,
        550.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        -1685.0,
        535.0,
        145.0
      ],
      "bbox_max": [
        -1660.0,
        550.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 535.0,
      "bbox_min": [
        -1685.0,
        535.0,
        145.0
      ],
      "bbox_max": [
        -1680.0,
        535.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 535.0,
      "bbox_min": [
        -1665.0,
        535.0,
        145.0
      ],
      "bbox_max": [
        -1660.0,
        535.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 535.0,
      "bbox_min": [
        -290.0,
        535.0,
        145.0
      ],
      "bbox_max": [
        -285.0,
        535.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -310.0,
        535.0,
        145.0
      ],
      "bbox_max": [
        -305.0,
        550.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 535.0,
      "bbox_min": [
        -310.0,
        535.0,
        145.0
      ],
      "bbox_max": [
        -305.0,
        535.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        170.0,
        266.0564880371094,
        100.0
      ],
      "bbox_max": [
        840.0,
        470.0,
        381.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        205.0,
        440.0,
        100.00000762939453
      ],
      "bbox_max": [
        840.0,
        470.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 205.0,
      "bbox_min": [
        205.0,
        440.0,
        300.0
      ],
      "bbox_max": [
        255.0,
        470.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        205.0,
        440.0,
        300.0
      ],
      "bbox_max": [
        255.0,
        470.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        -10.0,
        440.0,
        140.0
      ],
      "bbox_max": [
        110.0,
        470.0,
        381.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 25.0,
      "bbox_min": [
        25.0,
        440.0,
        300.0
      ],
      "bbox_max": [
        75.0,
        470.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        -190.0,
        440.0,
        140.0
      ],
      "bbox_max": [
        -70.0,
        470.0,
        381.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -155.0,
      "bbox_min": [
        -155.0,
        440.0,
        300.0
      ],
      "bbox_max": [
        -105.0,
        470.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -155.0,
        440.0,
        300.0
      ],
      "bbox_max": [
        -105.0,
        470.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -210.0,
      "bbox_min": [
        -1717.22216796875,
        280.0,
        100.0
      ],
      "bbox_max": [
        -190.0,
        470.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -435.0,
      "bbox_min": [
        -390.0,
        425.0,
        140.0
      ],
      "bbox_max": [
        -290.0,
        435.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1559.9998779296875,
      "bbox_min": [
        -1680.0,
        425.0,
        140.0
      ],
      "bbox_max": [
        -1560.0,
        470.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        -1680.0,
        425.0,
        140.0
      ],
      "bbox_max": [
        -1580.0,
        455.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1579.9998779296875,
      "bbox_min": [
        -1580.0,
        425.0,
        140.0
      ],
      "bbox_max": [
        -1580.0,
        435.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -435.0,
      "bbox_min": [
        -1580.0,
        427.0,
        145.0
      ],
      "bbox_max": [
        -290.0,
        440.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -409.9999694824219,
      "bbox_min": [
        -1560.0,
        435.0,
        145.0
      ],
      "bbox_max": [
        -290.0,
        440.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        -1685.0,
        440.0,
        145.0
      ],
      "bbox_max": [
        -285.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        -1685.0,
        440.0,
        145.0
      ],
      "bbox_max": [
        -1660.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -455.0,
      "bbox_min": [
        -1685.0,
        455.0,
        145.0
      ],
      "bbox_max": [
        -1680.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -455.0,
      "bbox_min": [
        -1665.0,
        455.0,
        145.0
      ],
      "bbox_max": [
        -1660.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -455.0,
      "bbox_min": [
        -290.0,
        455.0,
        145.0
      ],
      "bbox_max": [
        -285.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -310.0,
        440.0,
        145.0
      ],
      "bbox_max": [
        -305.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -455.0,
      "bbox_min": [
        -310.0,
        455.0,
        145.0
      ],
      "bbox_max": [
        -305.0,
        455.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -355.0,
        423.6956481933594,
        100.0
      ],
      "bbox_max": [
        -290.0,
        456.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -290.0,
      "bbox_min": [
        -305.0,
        435.0,
        100.0
      ],
      "bbox_max": [
        -290.0,
        455.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -435.0,
      "bbox_min": [
        -305.0,
        435.0,
        100.0
      ],
      "bbox_max": [
        -290.0,
        435.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 354.9999694824219,
      "bbox_min": [
        -355.0,
        423.6956481933594,
        100.0
      ],
      "bbox_max": [
        -355.0,
        456.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        -1655.0,
        423.6956481933594,
        100.0
      ],
      "bbox_max": [
        -1580.0,
        460.0,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1654.9998779296875,
      "bbox_min": [
        -1655.0,
        423.6956481933594,
        100.0
      ],
      "bbox_max": [
        -1655.0,
        456.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        -1655.0,
        460.0,
        110.0
      ],
      "bbox_max": [
        -315.0,
        466.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        -1655.0,
        425.0,
        116.0
      ],
      "bbox_max": [
        -390.0,
        460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        -315.0,
        435.0,
        116.0
      ],
      "bbox_max": [
        -280.0,
        460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -290.0,
      "bbox_min": [
        -305.0,
        435.0,
        116.0
      ],
      "bbox_max": [
        -290.0,
        455.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -435.0,
      "bbox_min": [
        -305.0,
        435.0,
        116.0
      ],
      "bbox_max": [
        -290.0,
        435.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        -1655.0,
        450.0,
        100.0
      ],
      "bbox_max": [
        -290.0,
        460.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1654.9998779296875,
      "bbox_min": [
        -1655.0,
        450.0,
        100.0
      ],
      "bbox_max": [
        -1655.0,
        460.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        -1685.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        470.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        840.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        470.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        -1680.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        -1660.0,
        462.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": -457.94677734375,
      "bbox_min": [
        -310.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        -285.0,
        462.0,
        104.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        360.0,
        466.0,
        116.0
      ],
      "bbox_max": [
        840.0,
        470.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        360.0,
        466.0,
        116.0
      ],
      "bbox_max": [
        360.0,
        470.0,
        119.99998474121094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        -1560.0,
        470.0,
        165.0
      ],
      "bbox_max": [
        840.0,
        480.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1559.9998779296875,
      "bbox_min": [
        -1560.0,
        470.0,
        165.0
      ],
      "bbox_max": [
        -410.0,
        480.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        -1690.0,
        480.0,
        165.0
      ],
      "bbox_max": [
        840.0,
        510.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        -1690.0,
        480.0,
        165.0
      ],
      "bbox_max": [
        -280.0,
        510.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -280.0,
      "bbox_min": [
        -280.0,
        480.0,
        165.0
      ],
      "bbox_max": [
        -280.0,
        510.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        -1560.0,
        470.0,
        140.0
      ],
      "bbox_max": [
        840.0,
        480.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1559.9998779296875,
      "bbox_min": [
        -1560.0,
        470.0,
        140.0
      ],
      "bbox_max": [
        -410.0,
        480.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8000000715255737,
        0.6000000238418579,
        0.0
      ],
      "plane_d": -488.0,
      "bbox_min": [
        -1720.0,
        470.0,
        145.0
      ],
      "bbox_max": [
        840.0,
        480.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        360.0,
        470.0,
        145.0
      ],
      "bbox_max": [
        840.0,
        480.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        840.0,
        470.0,
        145.0
      ],
      "bbox_max": [
        840.0,
        480.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        360.0,
        470.0,
        145.0
      ],
      "bbox_max": [
        360.0,
        480.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8000000715255737,
        0.6000000238418579,
        -0.0
      ],
      "plane_d": 1088.0001220703125,
      "bbox_min": [
        -1720.0,
        470.0,
        145.0
      ],
      "bbox_max": [
        -1712.5,
        480.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        -1690.0,
        470.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        480.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        190.0,
        470.0,
        100.0
      ],
      "bbox_max": [
        210.6666717529297,
        480.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        -0.0,
        -0.8000000715255737
      ],
      "plane_d": 206.40000915527344,
      "bbox_min": [
        190.0,
        470.0,
        100.0
      ],
      "bbox_max": [
        210.6666717529297,
        480.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        -1655.0,
        470.0,
        106.0
      ],
      "bbox_max": [
        -1655.0,
        480.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        -1725.0,
        480.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        510.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        660.0,
        480.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        510.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        660.0,
        480.0,
        140.0
      ],
      "bbox_max": [
        660.0,
        510.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        0.8000000715255737
      ],
      "plane_d": 32.0,
      "bbox_min": [
        -1725.0,
        480.0,
        106.0
      ],
      "bbox_max": [
        240.0,
        510.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        190.0,
        480.0,
        108.0
      ],
      "bbox_max": [
        200.0,
        490.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        -1690.0,
        480.0,
        140.0
      ],
      "bbox_max": [
        -280.0,
        510.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -280.0,
      "bbox_min": [
        -280.0,
        480.0,
        140.0
      ],
      "bbox_max": [
        -280.0,
        510.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1720.0,
      "bbox_min": [
        -1720.0,
        480.0,
        145.0
      ],
      "bbox_max": [
        -250.0,
        510.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -250.0,
      "bbox_min": [
        -250.0,
        480.0,
        145.0
      ],
      "bbox_max": [
        -250.0,
        510.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        -155.0,
        470.0,
        170.0
      ],
      "bbox_max": [
        930.0,
        510.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -155.0,
        500.0,
        170.0
      ],
      "bbox_max": [
        660.0,
        510.0,
        350.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 25.0,
      "bbox_min": [
        -155.0,
        500.0,
        300.0
      ],
      "bbox_max": [
        205.0,
        510.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 205.0,
      "bbox_min": [
        205.0,
        500.0,
        300.0
      ],
      "bbox_max": [
        205.0,
        510.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -155.0,
      "bbox_min": [
        -155.0,
        500.0,
        300.0
      ],
      "bbox_max": [
        -155.0,
        510.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        360.0,
        500.0,
        170.0
      ],
      "bbox_max": [
        660.0,
        510.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        660.0,
        500.0,
        170.0
      ],
      "bbox_max": [
        660.0,
        510.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -155.0,
        470.0,
        170.0
      ],
      "bbox_max": [
        840.0,
        500.0,
        350.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 25.0,
      "bbox_min": [
        -155.0,
        470.0,
        300.0
      ],
      "bbox_max": [
        205.0,
        500.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 205.0,
      "bbox_min": [
        205.0,
        470.0,
        300.0
      ],
      "bbox_max": [
        205.0,
        500.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -155.0,
      "bbox_min": [
        -155.0,
        470.0,
        300.0
      ],
      "bbox_max": [
        -155.0,
        500.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        360.0,
        470.0,
        170.0
      ],
      "bbox_max": [
        840.0,
        500.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        660.0,
        470.0,
        170.0
      ],
      "bbox_max": [
        840.0,
        500.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        840.0,
        470.0,
        170.0
      ],
      "bbox_max": [
        840.0,
        500.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -409.9999694824219,
      "bbox_min": [
        -1560.0,
        510.0,
        165.0
      ],
      "bbox_max": [
        840.0,
        520.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1560.0,
      "bbox_min": [
        -1560.0,
        510.0,
        165.0
      ],
      "bbox_max": [
        -1560.0,
        520.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -409.9999694824219,
      "bbox_min": [
        -1560.0,
        510.0,
        140.0
      ],
      "bbox_max": [
        840.0,
        520.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        660.0,
        510.0,
        140.0
      ],
      "bbox_max": [
        840.0,
        520.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1560.0,
      "bbox_min": [
        -1560.0,
        510.0,
        140.0
      ],
      "bbox_max": [
        -1560.0,
        520.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8000000715255737,
        -0.6000000238418579,
        0.0
      ],
      "plane_d": 105.99998474121094,
      "bbox_min": [
        -1720.0,
        510.0,
        145.0
      ],
      "bbox_max": [
        840.0,
        520.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8000000715255737,
        -0.6000000238418579,
        0.0
      ],
      "plane_d": 1682.0001220703125,
      "bbox_min": [
        -1720.0,
        510.0,
        145.0
      ],
      "bbox_max": [
        -1712.5,
        520.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        -1655.0,
        510.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        520.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        -1655.0,
        510.0,
        106.0
      ],
      "bbox_max": [
        -315.0,
        520.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 25.0,
      "bbox_min": [
        -155.0,
        510.0,
        300.0
      ],
      "bbox_max": [
        205.0,
        520.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 205.0,
      "bbox_min": [
        205.0,
        510.0,
        300.0
      ],
      "bbox_max": [
        205.0,
        520.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -155.0,
      "bbox_min": [
        -155.0,
        510.0,
        300.0
      ],
      "bbox_max": [
        -155.0,
        520.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        660.0,
        510.0,
        170.0
      ],
      "bbox_max": [
        660.0,
        516.0,
        190.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}